'use strict';

var jsrsasign = require('jsrsasign');
var jsBase64 = require('js-base64');
var moment = require('moment');
var sessionState = require('sip.js/lib/api/session-state');
var EventEmitter = require('events');
var jsonToGraphQLQuery = require('json-to-graphql-query/lib/jsonToGraphQLQuery');
var invitation = require('sip.js/lib/api/invitation');
require('webrtc-adapter');
var userAgentState = require('sip.js/lib/api/user-agent-state');
var parser = require('sip.js/lib/core/messages/parser');
var constants = require('sip.js/lib/core/messages/methods/constants');
var uri = require('sip.js/lib/grammar/uri');
var userAgent = require('sip.js/lib/api/user-agent');
var modifiers = require('sip.js/lib/platform/web/modifiers/modifiers');
var registerer = require('sip.js/lib/api/registerer');
var inviter = require('sip.js/lib/api/inviter');
var messager = require('sip.js/lib/api/messager');
var registererState = require('sip.js/lib/api/registerer-state');
var transportState = require('sip.js/lib/api/transport-state');
var peerConnectionConfigurationDefault = require('sip.js/lib/platform/web/session-description-handler/peer-connection-configuration-default');
var getStats = require('getstats');
var sessionDescriptionHandler = require('sip.js/lib/platform/web/session-description-handler/session-description-handler');
require('sip.js/lib/platform/web/session-description-handler/session-description-handler-options');
var sdpParser = require('sdp-transform');
var ReconnectingWebSocket = require('reconnecting-websocket');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var EventEmitter__default = /*#__PURE__*/_interopDefaultLegacy(EventEmitter);
var getStats__default = /*#__PURE__*/_interopDefaultLegacy(getStats);
var sdpParser__default = /*#__PURE__*/_interopDefaultLegacy(sdpParser);
var ReconnectingWebSocket__default = /*#__PURE__*/_interopDefaultLegacy(ReconnectingWebSocket);

//      

const swarmPublicKey  = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmkXOuNfY8u5xoTiIhkb8
djnbIwG/Wrz3vpo8BZir8L5e1a1nSy740qBjP7ZINBQoALDhFfmdOfJnCyEGiHuz
ZW6jbG6C3PryE3Bu6GKwqSmD6k3q4Zk27fpwYAnNl+rWhYYM563rJZBda/INyHNN
pK7M1mixWi7gNdjjXwoEXSSBx+VpYMkY6LiAB2mvHXTY9M1qI14dvgGoQISZQoKi
NMTRCg5UP2ic0Dd9nSz/XpcOxGfa+0fwIl1F7RC1tJXOqvkGGPTOV4LLfg/Yta3h
nUPX9EZZDIX6vO/0IBV1LzjSl2A1bYFYAjJfowv3i1CpvONBOClHjSY5t9Y8MH6p
BwIDAQAB
-----END PUBLIC KEY-----`;

//      

var newFrom = (instance     , ToClass     ) => {
  const args = {};
  Object.getOwnPropertyNames(instance).forEach(prop => {
    args[prop] = instance[prop];
  });

  return new ToClass(args);
};

//      

                  
                  
                
             
                                               
  

                        
             
                                              
                    
  

                     
                             
                           
                          
                               
             
  

                      
             
                               
                                   
                                 
                                
  

class Line {
               

             
                               
                                  
                                
                               

  static parse(plain              )       {
    return new Line({
      id: plain.id,
      extensions: plain.extensions,
      endpointCustom: plain.endpoint_custom || null,
      endpointSccp: plain.endpoint_sccp || null,
      endpointSip: plain.endpoint_sip || null,
    });
  }

  static newFrom(profile      ) {
    return newFrom(profile, Line);
  }

  is(line       ) {
    return line ? this.id === line.id : false;
  }

  hasExtension(extension        ) {
    if (!this.extensions) {
      return false;
    }

    return this.extensions.some(ext => ext.exten === extension);
  }

  constructor({ id, extensions, endpointCustom, endpointSccp, endpointSip }                = {}) {
    this.id = id;
    this.extensions = extensions;
    this.endpointCustom = endpointCustom || null;
    this.endpointSccp = endpointSccp || null;
    this.endpointSip = endpointSip || null;

    // Useful to compare instead of instanceof with minified code
    this.type = 'Line';
  }
}

//      

                 
                      
                   
  

const FORWARD_KEYS = {
  BUSY: 'busy',
  NO_ANSWER: 'noanswer',
  UNCONDITIONAL: 'unconditional',
};

                               
                      
                   
              
  

class ForwardOption {
                      
                   
              

  static parse(plain          , key        )                {
    return new ForwardOption({
      destination: plain.destination || '',
      enabled: plain.enabled,
      key,
    });
  }

  static newFrom(profile               ) {
    return newFrom(profile, ForwardOption);
  }

  constructor({ destination, enabled, key }                         = {}) {
    this.destination = destination;
    this.enabled = enabled;
    this.key = key;
  }

  setDestination(number        )                {
    this.destination = number;

    return this;
  }

  setEnabled(enabled         )                {
    this.enabled = enabled;

    return this;
  }

  is(other               ) {
    return this.key === other.key;
  }
}

//      
                                       

const availableCodecs = ['vp8', 'vp9', 'h264'];

                        
             
               
                      
                   
                 
               
               
                       
                                    
                                        
                       
                 
                 
  

                         
             
               
                     
                   
                 
               
               
                       
                                      
                       
                 
                 
  

class SipLine {
          
               
                     
                   
                 
               
               
                       
                                      
                       
                 
                 

  static parse(plain                 )          {
    let { username, secret, host } = plain;

    // Since 20.13 engine so options are now in section
    if (plain.auth_section_options) {
      // $FlowFixMe
      const findOption = (options            , name        ) => options.find(option => option[0] === name);

      const usernameOption = findOption(plain.auth_section_options, 'username');
      const secretOption = findOption(plain.auth_section_options, 'password');
      const hostOption = findOption(plain.endpoint_section_options, 'media_address');

      username = usernameOption ? usernameOption[1] : '';
      secret = secretOption ? secretOption[1] : '';
      host = hostOption ? hostOption[1] : '';
    }

    return new SipLine({
      id: plain.id,
      uuid: plain.uuid,
      tenantUuid: plain.tenant_uuid,
      username,
      secret,
      type: plain.type,
      host,
      options: plain.options,
      endpointSectionOptions: plain.endpoint_section_options,
      links: plain.links,
      trunk: plain.trunk,
      line: plain.line,
    });
  }

  static newFrom(sipLine         ) {
    return newFrom(sipLine, SipLine);
  }

  is(line         ) {
    if (line.uuid) {
      return this.uuid === line.uuid;
    }
    return this.id === line.id;
  }

  getOptions()                {
    // `options` params have beend remove since 20.13... we should now use endpointSectionOptions
    return this.endpointSectionOptions || this.options || [];
  }

  isWebRtc() {
    return this.getOptions().some(option => option[0] === 'webrtc' && option[1] === 'yes');
  }

  hasVideo() {
    const allow = this.getOptions().find(option => option[0] === 'allow');
    return Array.isArray(allow) && allow[1].split(',').some(codec => availableCodecs.some(c => c === codec));
  }

  hasVideoConference() {
    return (
      this.getOptions().some(option => option[0] === 'max_audio_streams' && parseInt(option[1], 10) > 0)
      && this.getOptions().some(option => option[0] === 'max_video_streams' && parseInt(option[1], 10) > 1)
    );
  }

  constructor({
    id,
    uuid,
    tenantUuid,
    username,
    secret,
    type,
    host,
    options,
    endpointSectionOptions,
    links,
    trunk,
    line,
  }                   = {}) {
    this.id = id;
    this.uuid = uuid;
    this.tenantUuid = tenantUuid;
    this.username = username;
    this.secret = secret;
    this.type = type;
    this.host = host;
    this.options = options;
    this.endpointSectionOptions = endpointSectionOptions;
    this.links = links;
    this.trunk = trunk;
    this.line = line;

    // Useful to compare instead of instanceof with minified code
    this.type = 'SipLine';
  }
}

//      

const STATE = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  INVISIBLE: 'invisible',
  DISCONNECTED: 'disconnected',
  AWAY: 'away',
};

const LINE_STATE = {
  AVAILABLE: 'available',
  HOLDING: 'holding',
  RINGING: 'ringing',
  TALKING: 'talking',
  UNAVAILABLE: 'unavailable',
  PROGRESSING: 'progressing',
};

                        
                                              
                    
                     
                   
                    
               
                
               
                                                                                                                    
                                      
                                    
                                   
     
             
                   
                    
                   
                
             
           
                          
                       
      
               
                          
                       
      
                    
                          
                       
      
    
                               
                        
                             
             
          
                       
      
    
                           
           
                      
               
                     
                   
    
               
               
                 
    
                                    
                      
                     
                 
     
                                       
  

                         
             
                    
                   
                
                     
                            
                   
                       
                                 
                         
                       
                 
                 
                            
               
               
                 
    
           
                      
               
                     
                   
    
                           
                                                                                       
                                     
  

class Profile {
             
                    
                   
                
                     
                           
                   
                       
                                 
                         
                                    
                 
                       
                                           
                 
                            
                                                                              
                           
                                                                                      

  static parse(plain                 )          {
    return new Profile({
      id: plain.uuid,
      firstName: plain.firstName || plain.firstname || '',
      lastName: plain.lastName || plain.lastname || '',
      email: plain.email,
      lines: plain.lines.map(line => Line.parse(line)),
      username: plain.username,
      mobileNumber: plain.mobile_phone_number || '',
      ringSeconds: plain.ring_seconds,
      forwards: [
        ForwardOption.parse(plain.forwards.unconditional, FORWARD_KEYS.UNCONDITIONAL),
        ForwardOption.parse(plain.forwards.noanswer, FORWARD_KEYS.NO_ANSWER),
        ForwardOption.parse(plain.forwards.busy, FORWARD_KEYS.BUSY),
      ],
      doNotDisturb: plain.services.dnd.enabled,
      subscriptionType: plain.subscription_type,
      voicemail: plain.voicemail,
      switchboards: plain.switchboards || [],
      agent: plain.agent,
      status: '',
      callPickupTargetUsers: plain.call_pickup_target_users || [],
      onlineCallRecordEnabled: plain.online_call_record_enabled,
    });
  }

  static newFrom(profile         ) {
    return newFrom(profile, Profile);
  }

  constructor({
    id,
    firstName,
    lastName,
    email,
    lines,
    username,
    mobileNumber,
    forwards,
    doNotDisturb,
    state,
    subscriptionType,
    voicemail,
    switchboards,
    agent,
    status,
    ringSeconds,
    sipLines,
    callPickupTargetUsers,
    onlineCallRecordEnabled,
  }                           = {}) {
    this.id = id;
    this.firstName = firstName;
    this.lastName = lastName;
    this.email = email;
    this.lines = lines;
    this.username = username;
    this.mobileNumber = mobileNumber;
    this.forwards = forwards;
    this.doNotDisturb = doNotDisturb;
    this.state = state;
    this.voicemail = voicemail;
    this.subscriptionType = subscriptionType;
    this.switchboards = switchboards;
    this.agent = agent;
    this.status = status;
    this.callPickupTargetUsers = callPickupTargetUsers;
    this.onlineCallRecordEnabled = onlineCallRecordEnabled;
    this.ringSeconds = ringSeconds;

    this.sipLines = sipLines || [];
  }

  static getLinesState(lines               ) {
    let result = LINE_STATE.UNAVAILABLE;

    // eslint-disable-next-line
    for (const line of lines) {
      if (line.state === LINE_STATE.RINGING) {
        result = LINE_STATE.RINGING;
        break;
      }

      if (line.state === LINE_STATE.TALKING) {
        result = LINE_STATE.TALKING;
        break;
      }

      if (line.state === LINE_STATE.AVAILABLE) {
        result = LINE_STATE.AVAILABLE;
      }
    }

    return result;
  }

  hasId(id        ) {
    return id === this.id;
  }

  setMobileNumber(number        ) {
    this.mobileNumber = number;

    return this;
  }

  setForwardOption(forwardOption               ) {
    const updatedForwardOptions = this.forwards.slice();
    const index = updatedForwardOptions.findIndex(forward => forward.is(forwardOption));
    updatedForwardOptions.splice(index, 1, forwardOption);

    this.forwards = updatedForwardOptions;

    return this;
  }

  setDoNotDisturb(enabled         ) {
    this.doNotDisturb = enabled;

    return this;
  }

  setState(state        ) {
    this.state = state;

    return this;
  }
}

//      
                                                         

const BACKEND = {
  OFFICE365: 'office365',
  PERSONAL: 'personal',
  GOOGLE: 'google',
  WAZO: 'wazo',
};

                          
                    
                   
                      
                 
                   
                      
                    
                
                                                     
                      
  

                               
                 
                  
                            
              
                    
                    
                      
                        
                      
                            
    
  

                                
                               
               
                                
                                  
  

                                       
             
                     
                    
                  
                                                      
                 
                      
                    
                   
                
                    
                     
                    
                   
                     
  

                                       
         
         
                 
                      
                 
                               
                              
                                 
                                    
                                 
                           
                                       
                              
            
           
        
      
    
  

// @see: https://github.com/rt2zz/react-native-contacts#example-contact-record
                                     
                   
                  
                         
                  
                  
     
                    
                     
                     
                   
               
                       
                  
                
     
                       
                  
                   
     
                        
                        
                          
                   
                 
                  
                   
                     
                    
                  
     
             
                 
                  
                
    
  

                         
              
                
                
                  
                                                      
                      
                 
                                                    
                      
                    
                   
                
                      
                     
                 
                  
                     
                     
                              
                        
                   
                  
                   
                          
                                                     
                      
                         
                    
                   
  

                          
                     
                
                       
                        
                             
                         
                    
                       
                   
                          
                  
                      
                                                           
                 
                  
                 
                   
                       
             
                   
                
                
                               
               
                  
                      
                
                      
                    
                         
                        
                  
                  
                  
             
                       
                     
                   
  

                     
                
                
                    
                   
                           
               
             
                        
  
                           
                  
               
             
                                                        
                                                     
  

                       
                   
             
               
                    
                        
  

const SOURCE_MOBILE = 'mobile';

class Contact {
               

              
                
                
                  
                                                      
                      
                 
                                                    
                      
                    
                   
                
                      
                     
                 
                     
                              
                        
                   
                  
                    
                  
                   
                         
                                                     
                      
                         
                    
                  

  static merge(oldContacts                , newContacts                )                 {
    return newContacts.map(current => {
      const old = oldContacts.find(contact => contact && contact.is(current));

      return old ? current.merge(old) : current;
    });
  }

  static sortContacts(a         , b         ) {
    const aNames = a.separateName();
    const bNames = b.separateName();
    const aLastName = aNames.lastName;
    const bLastName = bNames.lastName;

    // last Name can be empty
    if (aLastName === bLastName) {
      return aNames.firstName.localeCompare(bNames.firstName);
    }

    return aLastName.localeCompare(bLastName);
  }

  static parseMany(response                  )                 {
    if (!response || !response.results) {
      return [];
    }
    return response.results.map(r => Contact.parse(r, response.column_types));
  }

  static manyGraphQlWithNumbersParser(numbers          )           {
    return (response                         ) => {
      if (!response.data || !response.data.me || !response.data.me.contacts) {
        return [];
      }

      return response.data.me.contacts.edges.map((edge, i) => {
        if (!edge.node) {
          return null;
        }

        const { email } = edge.node;
        const name = edge.node.firstname && edge.node.lastname
          ? `${edge.node.firstname || ''} ${edge.node.lastname || ''}` : edge.node.wazoReverse;

        return new Contact({
          name,
          number: numbers[i],
          numbers: [{ label: 'primary', number: numbers[i] }],
          backend: edge.node.wazoBackend,
          source: edge.node.wazoSourceName,
          sourceId: edge.node.wazoSourceEntryId || '',
          email: email || '',
          emails: email ? [{ label: 'primary', email }] : [],
          uuid: edge.node.userUuid,
        });
      }).filter(contact => !!contact);
    };
  }

  static fetchNumbers(plain                 , columns                )                {
    const numberColumns = columns
      .map((e, index) => ({ index, columnName: e }))
      .filter(e => e.columnName === 'number' || e.columnName === 'callable')
      .map(e => e.index);

    return plain.column_values.filter((e, index) => numberColumns.some(i => i === index) && e !== null);
  }

  static parse(plain                 , columns                )          {
    const numbers = Contact.fetchNumbers(plain, columns);
    const email = plain.column_values[columns.indexOf('email')];

    return new Contact({
      name: plain.column_values[columns.indexOf('name')],
      number: numbers.length ? numbers[0] : '',
      numbers: numbers.map((number, i) => ({ label: i === 0 ? 'primary' : 'secondary', number })),
      favorited: plain.column_values[columns.indexOf('favorite')],
      email: email || '',
      emails: email ? [{ label: 'primary', email }] : [],
      entreprise: plain.column_values[columns.indexOf('entreprise')] || '',
      birthday: plain.column_values[columns.indexOf('birthday')] || '',
      address: plain.column_values[columns.indexOf('address')] || '',
      note: plain.column_values[columns.indexOf('note')] || '',
      endpointId: plain.relations.endpoint_id,
      personal: plain.column_values[columns.indexOf('personal')],
      source: plain.source,
      sourceId: plain.relations.source_entry_id || '',
      uuid: plain.relations.user_uuid,
      backend: plain.backend || '',
    });
  }

  static parseManyPersonal(results                                )                  {
    return results.map(r => Contact.parsePersonal(r));
  }

  static parsePersonal(plain                         )          {
    return new Contact({
      name: `${plain.firstName || plain.firstname || ''} ${plain.lastName || plain.lastname || ''}`,
      number: plain.number || '',
      numbers: plain.number ? [{ label: 'primary', number: plain.number }] : [],
      email: plain.email || '',
      emails: plain.email ? [{ label: 'primary', email: plain.email }] : [],
      source: 'personal',
      sourceId: plain.id || '',
      entreprise: plain.entreprise || '',
      birthday: plain.birthday || '',
      address: plain.address || '',
      note: plain.note || '',
      favorited: plain.favorited,
      personal: true,
      backend: plain.backend || BACKEND.PERSONAL,
    });
  }

  static parseMobile(plain                       )          {
    let address = '';
    if (plain.postalAddresses.length) {
      const postalAddress = plain.postalAddresses[0];

      address = `${postalAddress.street} ${postalAddress.city} ${postalAddress.postCode} ${postalAddress.country}`;
    }

    return new Contact({
      name: `${plain.givenName || ''} ${plain.familyName || ''}`,
      number: plain.phoneNumbers.length ? plain.phoneNumbers[0].number : '',
      numbers: plain.phoneNumbers.length ? [{ label: 'primary', number: plain.phoneNumbers[0].number }] : [],
      email: plain.emailAddresses.length ? plain.emailAddresses[0].email : '',
      emails: plain.emailAddresses.length ? [{ label: 'primary', email: plain.emailAddresses[0].email }] : [],
      source: SOURCE_MOBILE,
      sourceId: plain.recordID || '',
      birthday: plain.birthday ? `${plain.birthday.year}-${plain.birthday.month}-${plain.birthday.day}` : '',
      address,
      note: plain.note || '',
      favorited: false,
      personal: true,
    });
  }

  static parseManyOffice365(response                     , source                 )                 {
    return response.map(r => Contact.parseOffice365(r, source));
  }

  static parseOffice365(single                   , source                 )          {
    const emails                                           = [];
    const numbers                                            = [];

    if (single.emailAddresses) {
      single.emailAddresses.map(email => emails.push({ email: email.address }));
    }

    if (single.businessPhones) {
      single.businessPhones.map(phone => numbers.push({ label: 'business', number: phone }));
    }

    if (single.mobilePhone) {
      numbers.push({ label: 'mobile', number: single.mobilePhone });
    }

    if (single.homePhones) {
      single.homePhones.map(phone => numbers.push({ label: 'home', number: phone }));
    }

    return new Contact({
      sourceId: single.id || '',
      name: single.displayName || '',
      number: numbers.length ? numbers[0].number : '',
      numbers,
      emails,
      source: source.name,
      backend: BACKEND.OFFICE365,
    });
  }

  static parseManyGoogle(response                  , source                 )                 {
    return response.map(r => Contact.parseGoogle(r, source));
  }

  static parseGoogle(single                , source                 )          {
    const emails                                           = [];
    const numbers                                            = [];

    if (single.emails) {
      single.emails.forEach(email =>
        (typeof email === 'object' ? { email: email.address, label: email.label } : { email }));
    }

    if (single.numbers_by_label) {
      Object.keys(single.numbers_by_label).forEach(label =>
        numbers.push({ label, number: single.numbers_by_label[label] }));
    } else if (single.numbers) {
      single.numbers.forEach(phone => numbers.push({ number: phone }));
    }

    return new Contact({
      sourceId: single.id || '',
      name: single.name || '',
      number: numbers.length ? numbers[0].number : '',
      numbers,
      emails,
      source: source.name,
      backend: BACKEND.GOOGLE,
    });
  }

  static parseManyWazo(response                , source                 )                 {
    return response.map(r => Contact.parseWazo(r, source));
  }

  static parseWazo(single              , source                 )          {
    const emails = [];
    const numbers = [];

    if (single.email) {
      emails.push({ label: 'email', email: single.email });
    }

    if (single.exten) {
      numbers.push({ label: 'exten', number: single.exten });
    }

    if (single.mobile_phone_number) {
      numbers.push({ label: 'mobile', number: single.mobile_phone_number });
    }

    return new Contact({
      uuid: single.uuid,
      sourceId: String(single.id) || '',
      name: `${single.firstname}${single.lastname ? ` ${single.lastname}` : ''}`,
      number: numbers.length ? numbers[0].number : '',
      numbers,
      emails,
      source: source.name,
      backend: BACKEND.WAZO,
    });
  }

  static parseManyConference(response                      , source                 )                 {
    return response.map(r => Contact.parseConference(r, source));
  }

  static parseConference(single                    , source                 )          {
    const numbers = [];
    let firstNumber = '';

    if (single && single.extensions && single.extensions.length > 0 && single.extensions[0].exten) {
      firstNumber = single.extensions[0].exten;
      numbers.push({ label: 'exten', number: firstNumber });
    }

    return new Contact({
      sourceId: String(single.id),
      name: single.name,
      number: firstNumber,
      numbers,
      source: source.name,
      backend: 'conference',
    });
  }

  static newFrom(contact         ) {
    return newFrom(contact, Contact);
  }

  constructor({
    id,
    uuid,
    name,
    number,
    numbers,
    email,
    emails,
    source,
    sourceId,
    entreprise,
    birthday,
    address,
    note,
    state,
    lineState,
    lastActivity,
    mobile,
    status,
    endpointId,
    personal,
    favorited,
    backend,
    personalStatus,
    sessions,
    connected,
    doNotDisturb,
    ringing,
    previousPresential,
    lines,
  }                   = {}) {
    this.id = id;
    this.uuid = uuid;
    this.name = name || '';
    this.number = number;
    this.numbers = numbers;
    this.email = email;
    this.emails = emails;
    this.source = source;
    this.sourceId = sourceId;
    this.entreprise = entreprise;
    this.birthday = birthday;
    this.address = address;
    this.note = note;
    this.state = state;
    this.lineState = lineState;
    this.lastActivity = lastActivity;
    this.mobile = mobile;
    this.status = status;
    this.endpointId = endpointId;
    this.personal = personal;
    this.favorited = favorited;
    this.backend = backend;
    this.personalStatus = personalStatus || '';
    this.sessions = sessions || [];
    this.connected = connected;
    this.doNotDisturb = doNotDisturb;
    this.ringing = ringing;
    this.previousPresential = previousPresential;
    this.lines = lines || [];

    // Useful to compare instead of instanceof with minified code
    this.type = 'Contact';
  }

  setFavorite(value         ) {
    this.favorited = value;

    return this;
  }

  is(other         )          {
    const sameSourceId = this.sourceId !== null && other.sourceId !== null && this.sourceId === other.sourceId;
    const sameUuid = !!this.uuid && !!other.uuid && this.uuid === other.uuid;

    const hasSameId = sameSourceId || sameUuid;
    const hasSameBackend = !!this.backend && !!other.backend && this.backend === other.backend;
    const hasSameSource = !!this.source && !!other.source && this.source === other.source;

    return !!other && hasSameId && hasSameBackend && hasSameSource;
  }

  hasId(id        )          {
    return this.uuid === id;
  }

  hasNumber(number        )          {
    return this.number === number;
  }

  hasEndpointId(endpointId        )          {
    return this.endpointId === endpointId;
  }

  isAvailable()          {
    return this.state === STATE.AVAILABLE;
  }

  isAway()          {
    return this.state === STATE.AWAY;
  }

  isUnavailable()          {
    return this.state === STATE.UNAVAILABLE;
  }

  isInvisible()          {
    return this.state === STATE.INVISIBLE;
  }

  isInCall()          {
    return this.lineState === LINE_STATE.TALKING || this.lineState === LINE_STATE.HOLDING;
  }

  isRinging()           {
    return this.ringing;
  }

  isInUseOrRinging()          {
    return this.lineState === LINE_STATE.TALKING || this.lineState === LINE_STATE.RINGING;
  }

  isProgressing()          {
    return this.lineState === LINE_STATE.PROGRESSING;
  }

  merge(old         )          {
    Object.keys(old).filter(key => key !== 'lineState').forEach(key => {
      // $FlowFixMe
      this[key] = old[key] || this[key];
    });

    if (old.lineState) {
      this.lineState = old.lineState;
    }

    return this;
  }

  isIntern()          {
    return !!this.uuid;
  }

  hasSourceId()          {
    return !!this.sourceId;
  }

  isCallable(session         )          {
    return !!this.number && !!session && !session.is(this);
  }

  isFromMobile() {
    return this.source === SOURCE_MOBILE;
  }

  isFavorite() {
    return this.favorited;
  }

  separateName()                                          {
    if (!this.name) {
      return {
        firstName: '',
        lastName: '',
      };
    }
    const names = this.name.split(/\s+/);
    const firstName = names[0];
    const lastName = names.slice(1).join(' ');

    return {
      firstName,
      lastName,
    };
  }
}

// Can't use `semver` package as Wazo version aren't in semver format

const compareVersions = (a, b) => {
  let i;
  let diff;
  const regExStrip0 = /(\.0+)+$/;
  const segmentsA = a.replace(regExStrip0, '').split('.');
  const segmentsB = b.replace(regExStrip0, '').split('.');
  const l = Math.min(segmentsA.length, segmentsB.length);

  for (i = 0; i < l; i++) {
    diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
    if (diff) {
      return diff;
    }
  }
  return segmentsA.length - segmentsB.length;
};

//      

const swarmKey = jsrsasign.KEYUTIL.getKey(swarmPublicKey);
const MINIMUM_WAZO_ENGINE_VERSION_FOR_DEFAULT_CONTEXT = '19.08';

                 
         
                 
                          
                       
                                       
                        
                           
                      
                      
                    
                       
                            
                
                   
                        
                 
                         
                            
                             
                       
                                      
                     
      
    
  

                      
               
                                                  
                   
  

                         
                                
                 
                
                         
                        
                 
                       
                     
                  
                                        
                          
                       
  

class Session {
                
                
                        
                
                      
                      
                       
                         
                    
                  
                                       

  static parse(plain          )           {
    const token = plain.data.metadata ? plain.data.metadata.jwt : null;
    let authorizations = [];

    // Add authorizations from JWT
    if (token) {
      const isValid = jsrsasign.jws.JWS.verifyJWT(token, swarmKey, { alg: ['RS256'], verifyAt: new Date() });
      if (isValid) {
        const decodedToken = jsrsasign.jws.JWS.readSafeJSONString(jsrsasign.b64utoutf8(token.split('.')[1]));
        authorizations = decodedToken ? decodedToken.authorizations : [];
      }
    }

    return new Session({
      token: plain.data.token,
      refreshToken: plain.data.refresh_token || null,
      uuid: plain.data.metadata ? plain.data.metadata.uuid : null,
      sessionUuid: plain.data.session_uuid,
      authorizations,
      acl: plain.data.acls ? plain.data.acls : plain.data.acl ? plain.data.acl : [],
      tenantUuid: plain.data.metadata ? plain.data.metadata.tenant_uuid : undefined,
      expiresAt: new Date(`${plain.data.utc_expires_at}z`),
      engineUuid: plain.data.xivo_uuid,
    });
  }

  static newFrom(profile         ) {
    return newFrom(profile, Session);
  }

  constructor({
    token,
    uuid,
    tenantUuid,
    profile,
    expiresAt,
    authorizations,
    acl,
    engineVersion,
    refreshToken,
    sessionUuid,
    engineUuid,
  }                   = {}) {
    this.token = token;
    this.uuid = uuid;
    this.tenantUuid = tenantUuid || null;
    this.profile = profile;
    this.expiresAt = expiresAt;
    this.authorizations = authorizations || [];
    this.acl = acl || [];
    this.engineVersion = engineVersion;
    this.refreshToken = refreshToken;
    this.sessionUuid = sessionUuid;
    this.engineUuid = engineUuid;
  }

  hasExpired(date       = new Date())          {
    return date >= this.expiresAt;
  }

  is(contact         )          {
    return Boolean(contact) && this.uuid === contact.uuid;
  }

  using(profile         )          {
    this.profile = profile;

    return this;
  }

  hasAuthorizations() {
    return this.authorizations && !!this.authorizations.length;
  }

  displayName()         {
    return this.profile ? `${this.profile.firstName} ${this.profile.lastName}` : '';
  }

  hasAccessToVoicemail()          {
    if (!this.profile) {
      return false;
    }
    return !!this.profile.voicemail;
  }

  primaryLine()        {
    return this.profile && this.profile.lines.length > 0 ? this.profile.lines[0] : null;
  }

  primarySipLine()           {
    return this.profile && this.profile.sipLines.length > 0 ? this.profile.sipLines[0] : null;
  }

  primaryWebRtcLine()           {
    return this.profile && (this.profile.sipLines || []).find(sipLine => sipLine && sipLine.isWebRtc());
  }

  primaryCtiLine()           {
    return this.profile && (this.profile.sipLines || []).find(sipLine => sipLine && !sipLine.isWebRtc());
  }

  primaryContext()         {
    if (this.engineVersion) {
      if (this.hasEngineVersionGte(MINIMUM_WAZO_ENGINE_VERSION_FOR_DEFAULT_CONTEXT)) {
        return 'default';
      }
    }

    const line = this.primaryLine();

    return line && line.extensions.length > 0 ? line.extensions[0].context : 'default';
  }

  hasEngineVersionGte(version        ) {
    return this.engineVersion && compareVersions(String(this.engineVersion), String(version)) >= 0;
  }

  primaryNumber()          {
    const line = this.primaryLine();

    return line && line.extensions.length ? line.extensions[0].exten : null;
  }

  allLines()         {
    return this.profile ? this.profile.lines || [] : [];
  }

  allNumbers()           {
    const extensions = this.allLines().map(line => line.extensions.map(extension => extension.exten));
    if (!extensions.length) {
      return [];
    }

    return extensions.reduce((a, b) => a.concat(b));
  }

  hasExtension(extension        )          {
    return this.allNumbers().some(number => number === extension);
  }

  get acls()                 {
    console.warn('`acls` property of Session has been removed in Wazo\'s SDK, please use `acl` instead.');
    return this.acl;
  }
}

/*       */

class BadResponse extends Error {
  static fromResponse(error        , status        ) {
    return new BadResponse(
      error.message || JSON.stringify(error),
      status,
      error.timestamp,
      error.error_id,
      error.details,
      error,
    );
  }

  static fromText(response        , status        ) {
    return new BadResponse(response, status);
  }

                  
                 
                     
                   
                   
                

  constructor(
    message        ,
    status        ,
    timestamp          = null,
    errorId          = null,
    details          = null,
    error         = null,
  ) {
    super(message);

    this.timestamp = timestamp;
    this.status = status;
    this.errorId = errorId;
    this.details = details;
    this.error = error;
  }
}

/*       */

class ServerError extends BadResponse {
  static fromResponse(error        , status        ) {
    return new ServerError(
      error.message || JSON.stringify(error),
      status,
      error.timestamp,
      error.error_id,
      error.details,
    );
  }

  static fromText(response        , status        ) {
    return new ServerError(response, status);
  }
}

/*       */
/* global navigator */
const isMobile = () => typeof navigator !== 'undefined' && navigator.product === 'ReactNative';

/* global window */

const TRACE = 'trace';
const DEBUG = 'debug';
const INFO = 'info';
const LOG = 'log';
const WARN = 'warn';
const ERROR = 'error';
const CONSOLE_METHODS = [INFO, LOG, WARN, ERROR];
const LOG_LEVELS = [TRACE, DEBUG, INFO, LOG, WARN, ERROR];
const CATEGORY_PREFIX = 'logger-category=';

const MAX_REMOTE_RETRY = 100;

const addLevelsTo = (instance        , withMethods = false) => {
  instance.TRACE = TRACE;
  instance.DEBUG = DEBUG;
  instance.INFO = INFO;
  instance.LOG = LOG;
  instance.WARN = WARN;
  instance.ERROR = ERROR;

  if (withMethods) {
    instance.trace = (...args) => instance.apply(null, [TRACE, ...args]);
    instance.debug = (...args) => instance.apply(null, [DEBUG, ...args]);
    instance.info = (...args) => instance.apply(null, [INFO, ...args]);
    instance.log = (...args) => instance.apply(null, [LOG, ...args]);
    instance.warn = (...args) => instance.apply(null, [WARN, ...args]);
    instance.error = (...args) => instance.apply(null, [ERROR, ...args]);
  }

  return instance;
};

const safeStringify = (object        ) => {
  const result = '{"message": "Not parsable JSON"}';
  try {
    return JSON.stringify(object);
  } catch (e) {
    // Nothing to do
  }

  return result;
};

class IssueReporter {
                
               
              
               
                

                            
                   
                                     

                   
                            
                                
                                  
                       

  constructor() {
    addLevelsTo(this);

    this.oldConsoleMethods = null;
    this.enabled = false;
    this.remoteClientConfiguration = null;
    this.buffer = [];
    this.bufferTimeout = null;
    this._boundProcessBuffer = this._processBuffer.bind(this);
    this._boundParseLoggerBody = this._parseLoggerBody.bind(this);
    this._callback = null;
  }

  init() {
    this._catchConsole();
  }

  setCallback(cb          ) {
    this._callback = cb;
  }

  configureRemoteClient(configuration         = { tag: 'wazo-sdk', host: null, port: null, level: null, extra: {} }) {
    this.remoteClientConfiguration = configuration;
  }

  enable() {
    if (!this.oldConsoleMethods) {
      this.init();
    }

    this.enabled = true;
  }

  disable() {
    this.enabled = false;
  }

  loggerFor(category        )      {
    const logger = (level        , ...args     ) => {
      this.log.apply(this, [level, this._makeCategory(category), ...args]);
    };

    return addLevelsTo(logger, true);
  }

  removeSlashes(str        ) {
    return str.replace(/"/g, "'").replace(/\\/g, '');
  }

  log(level        , ...args     ) {
    if (!this.enabled) {
      return;
    }

    // Handle category label
    let category = null;
    let skipSendToRemote = false;
    let extra = {};
    if (args[0].indexOf(CATEGORY_PREFIX) === 0) {
      category = args[0].split('=')[1];
      // eslint-disable-next-line no-param-reassign
      args.splice(0, 1);
    }

    // Handle extra data as object for the last argument
    const lastArg = args[args.length - 1];
    if (lastArg && ((typeof lastArg === 'object' && Object.keys(lastArg).length) || lastArg instanceof Error)) {
      if (lastArg instanceof Error) {
        extra = {
          errorMessage: lastArg.message,
          errorStack: lastArg.stack,
          errorType: lastArg.constructor.name,
          skipSendToRemote: lastArg.skipSendToRemote,
        };
      } else {
        extra = lastArg;
      }
      // eslint-disable-next-line no-param-reassign
      args.splice(1, 1);
    }

    if (extra.skipSendToRemote) {
      skipSendToRemote = true;
      delete extra.skipSendToRemote;
    }

    const date = moment__default['default']().format('YYYY-MM-DD HH:mm:ss.SSS');
    const message = args.join(', ');
    let consoleMessage = message;

    if (Object.keys(extra).length) {
      const parsedExtra = safeStringify(extra);
      consoleMessage = `${consoleMessage} (${parsedExtra})`;
    }

    if (category) {
      consoleMessage = `[${category}] ${consoleMessage}`;
    }

    // Log the message in the console anyway (but don't console.error on mobile)
    const consoleLevel = isMobile() && level === 'error' ? WARN : level;

    // eslint-disable-next-line
    const oldMethod = this.oldConsoleMethods[consoleLevel] || this.oldConsoleMethods.log;
    oldMethod.apply(oldMethod, [date, consoleMessage]);

    if (this._callback) {
      this._callback(level, consoleMessage);
    }

    if (!skipSendToRemote) {
      this._sendToRemoteLogger(level, { date, message, category, ...extra });
    }
  }

  logRequest(url        , options        , response        , start      ) {
    if (!this.enabled) {
      return;
    }
    const { status } = response;
    const duration = new Date() - start;

    let level = TRACE;
    if (status >= 400 && status < 500) {
      level = WARN;
    } else if (status >= 500) {
      level = ERROR;
    }

    this.log(level, this._makeCategory('http'), url, {
      status,
      body: this.removeSlashes(JSON.stringify(options.body)),
      method: options.method,
      headers: options.headers,
      duration,
    });
  }

  // Logs aren't stored anymore
  getLogs() {
    console.warn('IssueReporter\'s logs aren\'t stored anymore. Please use fluentd to store them');
    return [];
  }

  getParsedLogs() {
    console.warn('IssueReporter\'s logs aren\'t stored anymore. Please use fluentd to store them');
    return [];
  }

  getReport() {
    return this.getParsedLogs().join('\r\n');
  }

  _catchConsole() {
    this.oldConsoleMethods = {};
    CONSOLE_METHODS.forEach((methodName        ) => {
      // eslint-disable-next-line
      this.oldConsoleMethods[methodName] = console[methodName];
      window.console[methodName] = (...args) => {
        // Store message
        try {
          this.log(methodName, args.join(' '));
          // Use old console method to log it normally
          this.oldConsoleMethods[methodName].apply(null, args);
        } catch (e) {
          // Avoid circular structure issues
        }
      };
    });
  }

  _sendToRemoteLogger(level        , payload         = {}) {
    if (!this.remoteClientConfiguration) {
      return;
    }

    const { level: minLevel, bufferSize } = this.remoteClientConfiguration;
    if (!minLevel || this._isLevelAbove(minLevel, level)) {
      return;
    }

    payload.level = level;

    if (bufferSize > 0) {
      return this._addToBuffer(payload);
    }

    this._sendDebugToGrafana(payload);
  }

  _parseLoggerBody(payload        ) {
    const { level } = payload;
    const { maxMessageSize, extra } = this.remoteClientConfiguration || {};

    delete payload.level;

    if (maxMessageSize && typeof payload.message === 'string' && payload.message.length > maxMessageSize) {
      payload.message = `${payload.message.substr(0, maxMessageSize)}...`;
    }

    return safeStringify({
      level,
      ...payload,
      ...extra,
    });
  }

  _addToBuffer(payload        ) {
    // Reset buffer timer
    if (this.bufferTimeout) {
      clearTimeout(this.bufferTimeout);
      this.bufferTimeout = null;
    }

    this.buffer.push(payload);

    // $FlowFixMe
    const { bufferSize, bufferTimeout } = this.remoteClientConfiguration;

    if (this.buffer.length > bufferSize) {
      return this._processBuffer();
    }

    if (bufferTimeout > 0) {
      this.bufferTimeout = setTimeout(this._boundProcessBuffer, bufferTimeout);
    }
  }

  _processBuffer() {
    this._sendDebugToGrafana(this.buffer);

    this.buffer = [];
    if (this.bufferTimeout) {
      clearTimeout(this.bufferTimeout);
      this.bufferTimeout = null;
    }
  }

  _sendDebugToGrafana(payload                   , retry         = 0) {
    if (!this.remoteClientConfiguration || retry >= MAX_REMOTE_RETRY) {
      return;
    }

    const { tag, host, port } = this.remoteClientConfiguration;
    const isArray = Array.isArray(payload);
    const isSecure = +port === 443;
    const url = `http${isSecure ? 's' : ''}://${host}${isSecure ? '' : `:${port}`}/${tag}`;
    const body = isArray ? `[${payload.map(this._boundParseLoggerBody).join(',')}]` : this._parseLoggerBody(payload);

    realFetch()(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      // $FlowFixMe
      body,
    }).catch((e       ) => {
      // $FlowFixMe
      e.skipSendToRemote = true;
      this.log('error', this._makeCategory('grafana'), 'Sending log to grafana, error', e);

      setTimeout(() => {
        if (isArray) {
          payload = payload.map(message => this._writeRetryCount(message, retry + 1));
        } else if (payload && typeof payload === 'object') {
          payload = this._writeRetryCount(payload, retry + 1);
        }

        this._sendDebugToGrafana(payload, retry + 1);
      }, 5000 + retry * 1000);
    });
  }

  _writeRetryCount(message                 , count        )                  {
    if (message && typeof message === 'object') {
      // $FlowFixMe
      message._retry = count;
    }

    return message;
  }

  _isLevelAbove(level1        , level2        ) {
    const index1 = LOG_LEVELS.indexOf(level1);
    const index2 = LOG_LEVELS.indexOf(level2);
    if (index1 === -1 || index2 === -1) {
      return false;
    }

    return index1 > index2;
  }

  _makeCategory(category        ) {
    return `${CATEGORY_PREFIX}${category}`;
  }
}

var IssueReporter$1 = new IssueReporter();

/*       */

                          
                 
                 
                    
                                 
                 
                        
  

const methods = ['head', 'get', 'post', 'put', 'delete'];

const logger$c = IssueReporter$1 ? IssueReporter$1.loggerFor('api') : console;

// Use a function here to be able to mock it in tests
const realFetch = () => {
  if (typeof document !== 'undefined' && window.fetch) {
    // Browser
    return window.fetch;
  }

  if (isMobile()) {
    // React native
    return fetch;
  }

  // nodejs
  // this package is disable for react-native in package.json because it requires nodejs modules
  // Used to trick the optimizer to avoid requiring `node-fetch/lib/index` directly
  // It causes to require it on browsers when delivered by a nodejs engine (cf: vitejs).
  try {
    // $FlowFixMe
    return require(Math.random() >= 0 ? 'node-fetch/lib/index' : '');
  } catch (e) {
    return fetch;
  }
};

class ApiRequester {
                 
                 
                    
                
                  
                       
                                 
                                     
                           

                 
                
                 
                
                   

  // eslint-disable-next-line
  static successResponseParser(response        , isJson         ) {
    return response.status === 204 || response.status === 201 || response.status === 200;
  }

  static defaultParser(response        ) {
    return response.json().then((data        ) => data);
  }

  static getQueryString(obj        )         {
    return Object.keys(obj)
      .filter(key => obj[key])
      .map(key => `${key}=${encodeURIComponent(obj[key])}`)
      .join('&');
  }

  static base64Encode(str        )         {
    return typeof btoa !== 'undefined' ? btoa(str) : jsBase64.Base64.encode(str);
  }

  // @see https://github.com/facebook/flow/issues/183#issuecomment-358607052
  constructor({ server, refreshTokenCallback, clientId, agent = null, token = null, fetchOptions }                   ) {
    this.server = server;
    this.agent = agent;
    this.clientId = clientId;
    this.refreshTokenCallback = refreshTokenCallback;
    this.refreshTokenPromise = null;
    this.fetchOptions = fetchOptions || {};
    if (token) {
      this.token = token;
    }

    this.shouldLogErrors = true;

    methods.forEach(method => {
      // $FlowFixMe
      ApiRequester.prototype[method] = function sugar(...args) {
        // Add method in arguments passed to `call`
        args.splice(1, 0, method);

        return this.call.call(this, ...args);
      };
    });
  }

  setTenant(tenant         ) {
    this.tenant = tenant;
  }

  setToken(token        ) {
    this.token = token;
  }

  setFetchOptions(options        ) {
    this.fetchOptions = options;
  }

  disableErrorLogging() {
    this.shouldLogErrors = false;
  }

  enableErrorLogging() {
    this.shouldLogErrors = true;
  }

  async call(
    path        ,
    method         = 'get',
    body          = null,
    headers                    = null,
    parse           = ApiRequester.defaultParser,
    firstCall          = true,
  )               {
    const url = this.computeUrl(method, path, body);
    const newHeaders = this.getHeaders(headers);
    let newBody = method === 'get' ? null : body;
    if (newBody && newHeaders['Content-Type'] === 'application/json') {
      newBody = JSON.stringify(newBody);
    }
    const isHead = method === 'head';
    const hasEmptyResponse = method === 'delete' || isHead;
    const newParse = hasEmptyResponse ? ApiRequester.successResponseParser : parse;

    const fetchOptions = { ...this.fetchOptions || {} };
    const extraHeaders = fetchOptions.headers || {};
    delete fetchOptions.headers;

    const options = {
      method,
      body: newBody,
      headers: { ...this.getHeaders(headers), ...extraHeaders },
      agent: this.agent,
      ...fetchOptions,
    };

    if (this.refreshTokenPromise) {
      logger$c.info('A token is already refreshing, waiting ...', { url });
      await this.refreshTokenPromise;
    }

    const start = new Date();

    return realFetch()(url, options).then(response => {
      const contentType = response.headers.get('content-type') || '';
      const isJson = contentType.indexOf('application/json') !== -1;

      IssueReporter$1.logRequest(url, options, response, start);

      // Throw an error only if status >= 400
      if ((isHead && response.status >= 500) || (!isHead && response.status >= 400)) {
        const promise = isJson ? response.json() : response.text();
        const exceptionClass = response.status >= 500 ? ServerError : BadResponse;

        return promise.then(async (err        ) => {
          // Check if the token is still valid
          if (firstCall && this._checkTokenExpired(response, err)) {
            logger$c.warn('token expired', { error: err.reason });
            // Replay the call after refreshing the token
            return this._replayWithNewToken(err, path, method, body, headers, parse);
          }

          const error = typeof err === 'string'
            ? exceptionClass.fromText(err, response.status)
            : exceptionClass.fromResponse(err, response.status);

          if (this.shouldLogErrors) {
            logger$c.error('API error', error);
          }

          throw error;
        });
      }

      return newParse(response, isJson);
    }).catch(error => {
      if (this.shouldLogErrors) {
        logger$c.error('Fetch failed', { url, options, message: error.message, stack: error.stack });
      }

      throw error;
    });
  }

  _checkTokenExpired(response        , err        ) {
    // Special case when authenticating form a token: we got a 404
    const isTokenNotFound = response.status === 404 && this._isTokenNotFound(err);

    return response.status === 401 || isTokenNotFound;
  }

  _isTokenNotFound(err        ) {
    return err && err.reason && err.reason[0] === 'No such token';
  }

  _replayWithNewToken(
    err        ,
    path        ,
    method        ,
    body          = null,
    headers                    = null,
    parse          ,
  ) {
    const isTokenNotFound = this._isTokenNotFound(err);
    let newPath = path;
    logger$c.info('refreshing token', { inProgress: !!this.refreshTokenPromise });

    this.refreshTokenPromise = this.refreshTokenPromise || this.refreshTokenCallback();

    return this.refreshTokenPromise.then(() => {
      this.refreshTokenPromise = null;
      logger$c.info('token refreshed', { isTokenNotFound });
      if (isTokenNotFound) {
        const pathParts = path.split('/');
        pathParts.pop();
        pathParts.push(this.token);
        newPath = pathParts.join('/');
      }

      return this.call(newPath, method, body, headers, parse, false);
    }).catch((e) => {
      this.refreshTokenPromise = null;
      throw e;
    });
  }

  getHeaders(header                  )         {
    if (header instanceof Object) {
      return header;
    }

    return {
      'X-Auth-Token': this.token,
      ...(this.tenant ? { 'Wazo-Tenant': this.tenant } : null),
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  }

  computeUrl(method        , path        , body         )         {
    const url = `${this.baseUrl}/${path}`;

    return method === 'get' && body && Object.keys(body).length ? `${url}?${ApiRequester.getQueryString(body)}` : url;
  }

  get baseUrl()         {
    return `https://${this.server}/api`;
  }
}

/*       */

const DEFAULT_BACKEND_USER = 'wazo_user';
const BACKEND_LDAP_USER = 'ldap_user';
const DETAULT_EXPIRATION = 3600;

var authMethods = (client              , baseUrl        ) => ({
  checkToken: (token       )                   => client.head(`${baseUrl}/token/${token}`, null, {}),

  authenticate: (token       )                    =>
    client.get(`${baseUrl}/token/${token}`, null, {}).then(response => Session.parse(response)),

  logIn(params   
                     
                     
                    
                       
                     
                      
                        
   )                    {
    const body         = {
      backend: params.backend || DEFAULT_BACKEND_USER,
      expiration: params.expiration || DETAULT_EXPIRATION,
    };
    const headers         = {
      Authorization: `Basic ${ApiRequester.base64Encode(`${params.username}:${params.password}`)}`,
      'Content-Type': 'application/json',
    };

    if (client.clientId) {
      body.access_type = 'offline';
      body.client_id = client.clientId;
    }

    if (params.mobile) {
      headers['Wazo-Session-Type'] = 'mobile';
    }

    if (params.tenantId) {
      console.warn('Use of `tenantId` is deprecated when calling logIn() method, use `domainName` instead.');
      body.tenant_id = params.tenantId;
    }

    if (params.domainName) {
      body.domain_name = params.domainName;
    }

    return client.post(`${baseUrl}/token`, body, headers).then(response => Session.parse(response));
  },

  logOut: (token       )                          =>
    client.delete(`${baseUrl}/token/${token}`, null, {}, ApiRequester.successResponseParser),

  refreshToken: (
    refreshToken        ,
    backend        ,
    expiration        ,
    isMobile          = false,
    tenantId         ,
    domainName         ,
  )                    => {
    const body         = {
      backend: backend || DEFAULT_BACKEND_USER,
      expiration: expiration || DETAULT_EXPIRATION,
      refresh_token: refreshToken,
      client_id: client.clientId,
    };

    if (tenantId) {
      console.warn('Use of `tenantId` is deprecated when calling refreshToken() method, use `domainName` instead.');
      body.tenant_id = tenantId;
    }

    if (domainName) {
      body.domain_name = domainName;
    }

    const headers         = {
      'Content-Type': 'application/json',
      ...(isMobile ? { 'Wazo-Session-Type': 'mobile' } : {}),
    };

    return client.post(`${baseUrl}/token`, body, headers, ApiRequester.defaultParser, false).then(Session.parse);
  },

  deleteRefreshToken: (clientId        )                   =>
    client.delete(`${baseUrl}/users/me/tokens/${clientId}`, null, null, ApiRequester.successResponseParser),

  updatePassword: (userUuid      , oldPassword        , newPassword        )                   => {
    const body = {
      new_password: newPassword,
      old_password: oldPassword,
    };

    return client.put(`${baseUrl}/users/${userUuid}/password`, body, null, ApiRequester.successResponseParser);
  },

  sendDeviceToken: (userUuid      , deviceToken        , apnsVoipToken         , apnsNotificationToken         ) => {
    const body         = {
      token: deviceToken,
    };

    if (apnsVoipToken) {
      // Should be called `voip_token`, but we can't changed it to be retro-compatible
      body.apns_token = apnsVoipToken;
      body.apns_voip_token = apnsVoipToken;
    }

    if (apnsNotificationToken) {
      body.apns_notification_token = apnsNotificationToken;
    }

    return client.post(`${baseUrl}/users/${userUuid}/external/mobile`, body);
  },

  getPushNotificationSenderId: (userUuid      ) =>
    client.get(`${baseUrl}/users/${userUuid}/external/mobile/sender_id`, null).then(response => response.sender_id),

  /**
   * `username` or `email` should be set.
   */
  sendResetPasswordEmail: ({ username, email }                                       ) => {
    const body = {};
    if (username) {
      body.username = username;
    }
    if (email) {
      body.email = email;
    }

    return client.get(`${baseUrl}/users/password/reset`, body, {}, ApiRequester.successResponseParser);
  },

  resetPassword: (userUuid        , password        ) => {
    const body = {
      password,
    };

    return client.post(
      `${baseUrl}/users/password/reset?user_uuid=${userUuid}`,
      body,
      null,
      ApiRequester.successResponseParser,
    );
  },

  removeDeviceToken: (userUuid      ) => client.delete(`${baseUrl}/users/${userUuid}/external/mobile`),

  createUser: (
    username        ,
    password        ,
    firstname        ,
    lastname        ,
  )                               => {
    const body = {
      username,
      password,
      firstname,
      lastname,
    };

    return client.post(`${baseUrl}/users`, body);
  },

  addUserEmail: (userUuid      , email        , main          ) => {
    const body = {
      emails: [
        {
          address: email,
          main,
        },
      ],
    };

    return client.put(`${baseUrl}/users/${userUuid}/emails`, body);
  },

  addUserPolicy: (userUuid      , policyUuid      ) =>
    client.put(`${baseUrl}/users/${userUuid}/policies/${policyUuid}`),

  getRestrictionPolicies: (scopes          ) =>
    client.post(`${baseUrl}/token/${client.token}/scopes/check`, { scopes }),

  deleteUserPolicy: (userUuid      , policyUuid      ) =>
    client.delete(`${baseUrl}/users/${userUuid}/policies/${policyUuid}`),

  addUserGroup: (userUuid      , groupUuid      ) => client.put(`${baseUrl}/groups/${groupUuid}/users/${userUuid}`),

  listUsersGroup: (groupUuid      ) => client.get(`${baseUrl}/groups/${groupUuid}/users`),

  deleteUserGroup: (userUuid      , groupUuid      ) =>
    client.delete(`${baseUrl}/groups/${groupUuid}/users/${userUuid}`),

  getUser: (userUuid      )                           => client.get(`${baseUrl}/users/${userUuid}`),

  getUserSession: (userUuid      ) => client.get(`${baseUrl}/users/${userUuid}/sessions`),

  deleteUserSession: (userUuid      , sessionUuids      ) =>
    client.delete(`${baseUrl}/users/${userUuid}/sessions/${sessionUuids}`),

  listUsers: ()                             => client.get(`${baseUrl}/users`),

  deleteUser: (userUuid      )                                  => client.delete(`${baseUrl}/users/${userUuid}`),

  listTenants: ()                               => client.get(`${baseUrl}/tenants`),

  getTenant: (tenantUuid      )                             => client.get(`${baseUrl}/tenants/${tenantUuid}`),

  createTenant: (name        )                                 => client.post(`${baseUrl}/tenants`, { name }),

  updateTenant: (
    uuid      ,
    name        ,
    contact        ,
    phone        ,
    address               ,
  )                                 => {
    const body = {
      name,
      contact,
      phone,
      address,
    };

    return client.put(`${baseUrl}/tenants/${uuid}`, body);
  },

  deleteTenant: (uuid      )                                  => client.delete(`${baseUrl}/tenants/${uuid}`),

  createGroup: (name        ) => client.post(`${baseUrl}/groups`, { name }),

  listGroups: ()                              => client.get(`${baseUrl}/groups`),

  deleteGroup: (uuid      )                                  => client.delete(`${baseUrl}/groups/${uuid}`),

  createPolicy: (name        , description        , aclTemplates               ) => {
    const body = {
      name,
      description,
      acl_templates: aclTemplates, // deprecated
      acl: aclTemplates,
    };

    client.post(`${baseUrl}/policies`, body);
  },

  listPolicies: ()                                => client.get(`${baseUrl}/policies`),

  deletePolicy: (policyUuid      )                                  =>
    client.delete(`${baseUrl}/policies/${policyUuid}`),

  getProviders: (userUuid      ) => client.get(`${baseUrl}/users/${userUuid}/external`),

  getProviderToken: (userUuid      , provider        ) =>
    client.get(`${baseUrl}/users/${userUuid}/external/${provider}`),

  getProviderAuthUrl: (userUuid      , provider        ) =>
    client.post(`${baseUrl}/users/${userUuid}/external/${provider}`, {}),

  deleteProviderToken: (userUuid      , provider        ) =>
    client.delete(`${baseUrl}/users/${userUuid}/external/${provider}`),
});

/*       */
                                                                                

var applicationMethods = (client              , baseUrl        ) => ({
  bridgeCall(
    applicationUuid        ,
    callId        ,
    context        ,
    exten        ,
    autoanswer        ,
    displayed_caller_id_number         ,
  ) {
    const url = `${baseUrl}/${applicationUuid}/nodes`;
    const body = { calls: [{ id: callId }] };

    return client
      .post(url, body, null, res => res.json().then(response => response.uuid))
      .then(nodeUuid =>
        client
          .post(`${url}/${nodeUuid}/calls`, { context, exten, autoanswer, displayed_caller_id_number })
          .then(data => ({
            nodeUuid,
            data,
          })));
  },

  answerCall: (applicationUuid        , callId        ) =>
    client.put(`${baseUrl}/${applicationUuid}/calls/${callId}/answer`, {}, null, ApiRequester.successResponseParser),

  calls: (applicationUuid        ) => client.get(`${baseUrl}/${applicationUuid}/calls`),

  hangupCall: (applicationUuid        , callId        ) =>
    client.delete(`${baseUrl}/${applicationUuid}/calls/${callId}`),

  startPlaybackCall: (applicationUuid        , callId        , language        , uri        ) =>
    client.post(`${baseUrl}/${applicationUuid}/calls/${callId}/playbacks`, { language, uri }),

  stopPlaybackCall: (applicationUuid        , playbackUuid        ) =>
    client.delete(`${baseUrl}/${applicationUuid}/playbacks/${playbackUuid}`),

  startProgressCall: (applicationUuid        , callId        ) =>
    client.put(
      `${baseUrl}/${applicationUuid}/calls/${callId}/progress/start`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  stopProgressCall: (applicationUuid        , callId        ) =>
    client.put(
      `${baseUrl}/${applicationUuid}/calls/${callId}/progress/stop`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  startMohCall: (applicationUuid        , callId        , mohUuid        ) =>
    client.put(
      `${baseUrl}/${applicationUuid}/calls/${callId}/moh/${mohUuid}/start`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  stopMohCall: (applicationUuid        , callId        ) =>
    client.put(`${baseUrl}/${applicationUuid}/calls/${callId}/moh/stop`, {}, null, ApiRequester.successResponseParser),

  startHoldCall: (applicationUuid        , callId        ) =>
    client.put(
      `${baseUrl}/${applicationUuid}/calls/${callId}/hold/start`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  stopHoldCall: (applicationUuid        , callId        ) =>
    client.put(`${baseUrl}/${applicationUuid}/calls/${callId}/hold/stop`, {}, null, ApiRequester.successResponseParser),

  startMuteCall: (applicationUuid        , callId        ) =>
    client.put(
      `${baseUrl}/${applicationUuid}/calls/${callId}/mute/start`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  stopMuteCall: (applicationUuid        , callId        ) =>
    client.put(`${baseUrl}/${applicationUuid}/calls/${callId}/mute/stop`, {}, null, ApiRequester.successResponseParser),

  sendDTMFCall: (applicationUuid        , callId        , digits        ) =>
    client.put(`${baseUrl}/${applicationUuid}/calls/${callId}/dtmf`, { digits }, null,
      ApiRequester.successResponseParser),

  addCallNodes: (applicationUuid        , nodeUuid        , callId        )                   =>
    client.put(
      `${baseUrl}/${applicationUuid}/nodes/${nodeUuid}/calls/${callId}`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  createNewNodeWithCall: (applicationUuid        , calls               ) =>
    client.post(`${baseUrl}/${applicationUuid}/nodes`, { calls }),

  addNewCallNodes: (applicationUuid        , nodeUuid        , context        , exten        , autoanswer        ) =>
    client.post(`${baseUrl}/${applicationUuid}/nodes/${nodeUuid}/calls`, { context, exten, autoanswer }),

  listCallsNodes: (applicationUuid        , nodeUuid        )                                 =>
    client.get(`${baseUrl}/${applicationUuid}/nodes/${nodeUuid}`),

  listNodes: (applicationUuid        )                             => client.get(`${baseUrl}/${applicationUuid}/nodes`),

  removeNode: (applicationUuid        , nodeUuid        ) =>
    client.delete(`${baseUrl}/${applicationUuid}/nodes/${nodeUuid}`),

  removeCallNodes: (applicationUuid        , nodeUuid        , callId        ) =>
    client.delete(`${baseUrl}/${applicationUuid}/nodes/${nodeUuid}/calls/${callId}`),

  listSnoop: (applicationUuid        )                             =>
    client.get(`${baseUrl}/${applicationUuid}/snoops`),

  removeSnoop: (applicationUuid        , snoopUuid        ) =>
    client.delete(`${baseUrl}/${applicationUuid}/snoops/${snoopUuid}`),

  viewSnoop: (applicationUuid        , snoopUuid        )                             =>
    client.get(`${baseUrl}/${applicationUuid}/snoops/${snoopUuid}`),

  createSnoop: (applicationUuid        , callId        , snoopingCallId        , whisperMode        ) =>
    client.post(`${baseUrl}/${applicationUuid}/calls/${callId}/snoops`,
      { snooping_call_id: snoopingCallId, whisper_mode: whisperMode }),

  updateSnoop: (applicationUuid        , snoopUuid        , whisperMode        ) =>
    client.put(`${baseUrl}/${applicationUuid}/snoops/${snoopUuid}`, { whisper_mode: whisperMode }, null,
      ApiRequester.successResponseParser),
});

//      

                 
               
                        
  

                     
                    
  

                  
               
                        
  

class ExternalApp {
               
               
                        

  static parse(plain          )              {
    return new ExternalApp({
      name: plain.name,
      configuration: plain.configuration,
    });
  }

  static parseMany(plain              )                {
    return plain.items.map(item => ExternalApp.parse(item));
  }

  static newFrom(profile             ) {
    return newFrom(profile, ExternalApp);
  }

  constructor({ name, configuration }            = {}) {
    this.name = name;
    this.configuration = configuration;

    // Useful to compare instead of instanceof with minified code
    this.type = 'ExternalApp';
  }
}

//      

class MeetingAuthorization {
                      
               
                   
                   
                 

  constructor({
    meetingUuid,
    uuid,
    userUuid,
    userName,
  }         = {}) {
    this.meetingUuid = meetingUuid;
    this.uuid = uuid;
    this.userUuid = userUuid;
    this.userName = userName;
  }

  setStatus(status        ) {
    this.status = status;
  }

  getStatus() {
    return this.status;
  }

  static parse(plain                         ) {
    const {
      meeting_uuid: meetingUuid,
      uuid,
      guest_uuid: userUuid,
      guest_name: userName,
    } = plain;

    return new MeetingAuthorization({
      meetingUuid,
      uuid,
      userUuid,
      userName,
    });
  }

  static parseMany(items                           )                              {
    if (!items) {
      return [];
    }
    return items.map(MeetingAuthorization.parse);
  }
}

//      

                                      
               
                                
                      
 

                                      
                
                                 
 

                                       
                                  
                           
               
                             
               
               
                
                      
                        
                                 
 

class Meeting {
               

                                
              
               
               
               
                    
                      
                            
                     
                                                    
                                

  static parse(plain                         )          {
    return new Meeting({
      guestSipAuthorization: plain.guest_sip_authorization,
      uri: plain.ingress_http_uri,
      name: plain.name,
      ownerUuids: plain.owner_uuids,
      port: plain.port,
      uuid: plain.uuid,
      extension: plain.exten,
      persistent: plain.persistent,
      creationTime: moment__default['default'](plain.creation_time).toDate(),
      requireAuthorization: plain.require_authorization,
    });
  }

  static parseMany(items                           )                 {
    if (!items) {
      return [];
    }
    return items.map(plain => Meeting.parse(plain));
  }

  static newFrom(meeting         ) {
    return newFrom(meeting, Meeting);
  }

  constructor({
    uuid,
    name,
    guestSipAuthorization,
    ownerUuids,
    port,
    uri,
    extension,
    persistent,
    creationTime,
    requireAuthorization,
  }         = {}) {
    this.guestSipAuthorization = guestSipAuthorization;
    this.uri = uri;
    this.name = name;
    this.ownerUuids = ownerUuids;
    this.port = port;
    this.uuid = uuid;
    this.extension = extension;
    this.persistent = persistent;
    this.creationTime = creationTime;
    this.requireAuthorization = requireAuthorization;

    // Useful to compare instead of instanceof with minified code
    this.type = 'Meeting';
  }

  getGuestSipCredentials() {
    // eslint-disable-next-line no-undef
    const [username, secret] = atob(this.guestSipAuthorization).split(':');
    return { username, secret };
  }

}

//      

const camelToUnderscore = (key        ) => {
  if (typeof key !== 'string') {
    throw new Error('Input is not a string');
  }
  return key.charAt(0).toLowerCase() + key.substring(1).replace(/([A-Z])/g, '_$1').toLowerCase();
};

//      

const convertKeysFromCamelToUnderscore = (args        ) => {
  if (!args || typeof args !== 'object' || Array.isArray(args)) {
    throw new Error('Input is not an object');
  }

  return Object.keys(args).reduce((acc, key) => {
    acc[camelToUnderscore(key)] = typeof args[key] === 'object' && !Array.isArray(args[key])
      ? convertKeysFromCamelToUnderscore(args[key]) : args[key];
    return acc;
  }, {});
};

/*       */

var confdMethods = (client              , baseUrl        ) => ({
  listUsers: ()                                  => client.get(`${baseUrl}/users`, null),

  getUser: (userUuid        )                   => client.get(`${baseUrl}/users/${userUuid}`, null).then(Profile.parse),

  updateUser: (userUuid        , profile         )                   => {
    const body = {
      firstname: profile.firstName,
      lastname: profile.lastName,
      email: profile.email,
      mobile_phone_number: profile.mobileNumber,
    };

    return client.put(`${baseUrl}/users/${userUuid}`, body, null, ApiRequester.successResponseParser);
  },

  updateForwardOption: (userUuid        , key        , destination        , enabled         )                   => {
    const url = `${baseUrl}/users/${userUuid}/forwards/${key}`;
    return client.put(url, { destination, enabled }, null, ApiRequester.successResponseParser);
  },

  updateDoNotDisturb: (userUuid      , enabled         )                   =>
    client.put(`${baseUrl}/users/${userUuid}/services/dnd`, { enabled }, null, ApiRequester.successResponseParser),

  getUserLineSip: (userUuid        , lineId        )                   =>
    client.get(`${baseUrl}/users/${userUuid}/lines/${lineId}/associated/endpoints/sip?view=merged`).then(SipLine.parse),

  getUserLinesSip(userUuid        , lineIds          )                     {
    // We have to catch all exception, unless Promise.all will returns an empty array for 2 lines with a custom one:
    // The custom line will throw a 404 and break the Promise.all.
    // $FlowFixMe
    return Promise.all(lineIds.map(lineId => this.getUserLineSip(userUuid, lineId).catch(() => null)));
  },

  getUserLineSipFromToken(userUuid        ) {
    return this.getUser(userUuid).then(user => {
      if (!user.lines.length) {
        console.warn(`No sip line for user: ${userUuid}`);
        return null;
      }
      const line = user.lines[0];

      return this.getUserLineSip(userUuid, line.uuid || line.id);
    });
  },

  listApplications: ()                                    => client.get(`${baseUrl}/applications`, null),

  getInfos: ()                                                  => client.get(`${baseUrl}/infos`, null),

  getExternalApps: (userUuid        )                         =>
    client.get(`${baseUrl}/users/${userUuid}/external/apps`).then(ExternalApp.parseMany),

  getExternalApp: async (userUuid        , name        )                        => {
    const url = `${baseUrl}/users/${userUuid}/external/apps/${name}?view=fallback`;

    try {
      return await client.get(url).then(ExternalApp.parse);
    } catch (e) {
      return null;
    }
  },

  getMyMeetings: ()                   =>
    client.get(`${baseUrl}/users/me/meetings`).then(response => Meeting.parseMany(response.items)),

  createMyMeeting: (args                        )                   =>
    client
      .post(`${baseUrl}/users/me/meetings`, convertKeysFromCamelToUnderscore(args))
      .then(Meeting.parse),

  updateMyMeeting: (meetingUuid        , data                        )                   =>
    client.put(
      `${baseUrl}/users/me/meetings/${meetingUuid}`,
      convertKeysFromCamelToUnderscore(data),
      null,
      ApiRequester.successResponseParser,
    ),

  deleteMyMeeting: (meetingUuid        )                   =>
    client.delete(`${baseUrl}/users/me/meetings/${meetingUuid}`, null),

  getMeeting: (meetingUuid        )                   =>
    client.get(`${baseUrl}/meetings/${meetingUuid}`, null).then(Meeting.parse),

  meetingAuthorizations: (meetingUuid        )                                       =>
    client.get(`${baseUrl}/users/me/meetings/${meetingUuid}/authorizations`, null).then(MeetingAuthorization.parseMany),

  meetingAuthorizationReject: (meetingUuid        , authorizationUuid        )                   =>
    client.put(
      `${baseUrl}/users/me/meetings/${meetingUuid}/authorizations/${authorizationUuid}/reject`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  meetingAuthorizationAccept: (meetingUuid        , authorizationUuid        )                   =>
    client.put(
      `${baseUrl}/users/me/meetings/${meetingUuid}/authorizations/${authorizationUuid}/accept`,
      {},
      null,
      ApiRequester.successResponseParser,
    ),

  guestGetMeeting: (meetingUuid        )                   =>
    client.get(`${baseUrl}/guests/me/meetings/${meetingUuid}`, null).then(Meeting.parse),

  guestAuthorizationRequest: (userUuid        , meetingUuid        , username        )            =>
    client
      .post(`${baseUrl}/guests/${userUuid}/meetings/${meetingUuid}/authorizations`, { guest_name: username })
      .then(MeetingAuthorization.parse),

  guestAuthorizationCheck: (userUuid        , meetingUuid        , authorizationUuid        )            =>
    client.get(`${baseUrl}/guests/${userUuid}/meetings/${meetingUuid}/authorizations/${authorizationUuid}`, null),

});

//      

                                  
                             
                    
                         
                         
                         
                  
  

                            
                         
                          
                          
  

class Relocation {
                                             

                        

                        

                        

  static parse(response                    ) {
    return new Relocation({
      initiatorCall: response.initiator_call,
      recipientCall: response.recipient_call,
      relocatedCall: response.relocated_call,
    });
  }

  constructor({ relocatedCall, initiatorCall, recipientCall }                     ) {
    this.initiatorCall = initiatorCall || '';
    this.relocatedCall = relocatedCall || '';
    this.recipientCall = recipientCall || '';
  }
}

Relocation.MIN_ENGINE_VERSION_REQUIRED = '19.09';

//      

                        
                      
               
                    
  

                                       
                
  

                                   
                
                  
                     
                      
                    
               
                    
                                 
  

                                       
                   
                
                                    
  

class ChatMessage {
               

               
                  
             
                
                   
                    
                

  static parseMany(plain                         )                     {
    if (!plain || !plain.items) {
      return [];
    }

    return plain.items.map(item => ChatMessage.parse(item));
  }

  static parse(plain                     )              {
    return new ChatMessage({
      uuid: plain.uuid,
      date: moment__default['default'](plain.created_at).toDate(),
      content: plain.content,
      alias: plain.alias,
      userUuid: plain.user_uuid,
      read: true,
      roomUuid: plain.room ? plain.room.uuid : null,
    });
  }

  static newFrom(message             ) {
    return newFrom(message, ChatMessage);
  }

  constructor({ uuid, date, content, userUuid, alias, roomUuid, read }         = {}) {
    this.uuid = uuid;
    this.date = date;
    this.content = content;
    this.userUuid = userUuid;
    this.alias = alias;
    this.roomUuid = roomUuid;

    // @TODO: change after message read status available
    this.read = read;

    // Useful to compare instead of instanceof with minified code
    this.type = 'ChatMessage';
  }

  is(other             ) {
    return this.uuid === other.uuid;
  }

  isIncoming(userUuid        ) {
    return this.userUuid !== userUuid;
  }

  acknowledge() {
    // @TODO: change after message read status available
    this.read = true;
    return this;
  }
}

//      

                        
                         
                        
                   
             
                  
                    
  

                 
             
               
                 
                  
               
                 
                 
                                     
     
  

                           
             
             
                   
           
                 
                   
    
                    
  

class Voicemail {
               

             
             
                   
                   
           
                 
                   
    

  static parse(plain                 )            {
    return new Voicemail({
      id: plain.id,
      date: moment__default['default'](plain.timestamp * 1000).toDate(),
      duration: plain.duration * 1000,
      caller: {
        name: plain.caller_id_name,
        number: plain.caller_id_num,
      },
      unread: plain.folder ? plain.folder.type === 'new' : null,
    });
  }

  static parseMany(plain          )                   {
    if (!plain) {
      return [];
    }
    const plainUnread = plain.folders.filter(folder => folder.type === 'new')[0].messages;
    const plainRead = plain.folders.filter(folder => folder.type === 'old')[0].messages;

    const unread = plainUnread.map(message => Voicemail.parse(message)).map(voicemail => voicemail.makeAsUnRead());
    const read = plainRead.map(message => Voicemail.parse(message)).map(voicemail => voicemail.acknowledge());

    return [...unread, ...read];
  }

  static newFrom(profile           ) {
    return newFrom(profile, Voicemail);
  }

  constructor({ id, date, duration, caller, unread }                     = {}) {
    this.id = id;
    this.date = date;
    this.duration = duration;
    this.caller = caller;
    this.unread = unread;

    // Useful to compare instead of instanceof with minified code
    this.type = 'Voicemail';
  }

  is(other           )          {
    return other && this.id === other.id;
  }

  acknowledge() {
    this.unread = false;

    return this;
  }

  makeAsUnRead() {
    this.unread = true;

    return this;
  }

  contains(query        )          {
    if (!query) {
      return true;
    }

    return this.caller.name.toUpperCase().includes(query.toUpperCase()) || this.caller.number.includes(query);
  }
}

//      

const RECORD_STATE_ACTIVE = 'active';

                     
                  
                      
                         
                           
                              
                                
                           
                 
                     
                     
                   
                        
                   
                 
                     
                        
  

                      
             
                    
                    
                    
                     
                       
                     
                       
                          
                  
                  
                 
                 
                     
                         
                     
  

class Call {
               

             
                    
                     
                       
                     
                       
                          
                  
                    
                   
                  
                 
                 
                     
                         
                     

  static parseMany(plain                     )              {
    if (!plain) {
      return [];
    }
    return plain.map((plainCall              ) => Call.parse(plainCall));
  }

  static parse(plain              )       {
    return new Call({
      id: plain.call_id,
      sipCallId: plain.sip_call_id,
      callerName: plain.caller_id_name,
      callerNumber: plain.caller_id_number,
      calleeName: plain.peer_caller_id_name,
      calleeNumber: plain.peer_caller_id_number,
      dialedExtension: plain.dialed_extension,
      isCaller: plain.is_caller,
      isVideo: plain.is_video,
      muted: plain.muted,
      onHold: plain.on_hold,
      status: plain.status,
      lineId: plain.line_id,
      startingTime: moment__default['default'](plain.creation_time).toDate(),
      talkingToIds: Object.keys(plain.talking_to || {}),
      recording: plain.record_state === RECORD_STATE_ACTIVE,
    });
  }

  static newFrom(call      ) {
    return newFrom(call, Call);
  }

  constructor({
    id,
    sipCallId,
    callerName,
    callerNumber,
    calleeName,
    calleeNumber,
    dialedExtension,
    isCaller,
    isVideo,
    lineId,
    muted,
    onHold,
    status,
    startingTime,
    talkingToIds,
    recording,
  }                = {}) {
    this.id = id;
    this.sipCallId = sipCallId;
    this.callerName = callerName;
    this.callerNumber = callerNumber;
    this.calleeName = calleeName;
    this.calleeNumber = calleeNumber;
    this.dialedExtension = dialedExtension;
    this.muted = muted;
    this.onHold = onHold;
    this.isCaller = isCaller;
    this.lineId = lineId;
    this.status = status;
    this.startingTime = startingTime;
    this.talkingToIds = talkingToIds || [];
    this.recording = recording;
    this.isVideo = !!isVideo;

    // Useful to compare instead of instanceof with minified code
    this.type = 'Call';
  }

  getElapsedTimeInSeconds()         {
    const now = Date.now();
    return (now - this.startingTime) / 1000;
  }

  separateCalleeName()                                          {
    const names = this.calleeName.split(' ');
    const firstName = names[0];
    const lastName = names.slice(1).join(' ');

    return { firstName, lastName };
  }

  is(other       )          {
    return !!other && this.id === other.id;
  }

  hasACalleeName()          {
    return this.calleeName.length > 0;
  }

  hasNumber(number        )          {
    return this.calleeNumber === number;
  }

  isUp()          {
    return this.status === 'Up';
  }

  isDown()          {
    return this.status === 'Down';
  }

  isRinging()          {
    return this.isRingingIncoming() || this.isRingingOutgoing();
  }

  isRingingIncoming()          {
    return this.status === 'Ringing';
  }

  isRingingOutgoing()          {
    return this.status === 'Ring';
  }

  isFromTransfer()          {
    return this.status === 'Down' || this.status === 'Ringing';
  }

  isOnHold()          {
    return this.onHold;
  }

  putOnHold()       {
    this.onHold = true;
  }

  resume()       {
    this.onHold = false;
  }

  isRecording()          {
    return this.recording;
  }
}

//      
/* eslint-disable no-param-reassign */

var updateFrom = (instance     , from     ) => {
  Object.keys(from).forEach(key => {
    // $FlowFixMe
    if (
      (!instance[key] && from[key])
      || (typeof instance[key] !== 'undefined' && typeof from[key] !== 'undefined' && instance[key] !== from[key])
    ) {
      // $FlowFixMe
      instance[key] = from[key];
    }
  });
};

//      

                             
                    
                     
                            
              
                 
                       
                         
                       
                                  
                      
                  
                    
                 
                      
                                    
                 
                  
                   
                    
                 
                     
                    
                       
                    
                         
                     
                           
                       
                      
  

class CallSession {
              

  // Wazo's callId, like `1594062407.xxxx`
                 

                      

  // Used to retrieve the real callee when doing indirect transfer
                          

                        

                 

                       

                      

                     // = creationTime

                    

                 

                    

                            

                          

                   

  // Should be computed ?
                  

  // Asterisk callId, like `7aed6793-4405-466d-873e-92d21c2fef9f`
                    

                     

                 

                      

                                    

                         

                      

                   

                         

               

                     

                           

                      

                      

  constructor({
    answered,
    answeredBySystem,
    isCaller,
    displayName,
    callId,
    muted,
    videoMuted,
    number,
    paused,
    ringing,
    startTime,
    creationTime,
    endTime,
    cameraEnabled,
    dialedExtension,
    sipCallId,
    sipStatus,
    callerNumber,
    call,
    autoAnswer,
    ignored,
    screensharing,
    recording,
    recordingPaused,
    videoRemotelyDowngraded,
    sipSession,
    answerTime,
    conference,
  }                      ) {
    this.callId = callId;
    this.sipCallId = sipCallId;
    this.displayName = displayName;
    this.number = number;
    this.creationTime = creationTime;
    this.startTime = startTime;
    this.endTime = endTime;
    this.isCaller = isCaller;
    this.answered = answered;
    this.answeredBySystem = answeredBySystem;
    this.ringing = ringing;
    this.paused = paused;
    this.muted = muted;
    this.videoMuted = videoMuted;
    this.callerNumber = callerNumber;
    this.cameraEnabled = cameraEnabled;
    this.dialedExtension = dialedExtension || '';
    this.call = call;
    this.sipStatus = sipStatus;
    this.autoAnswer = autoAnswer || false;
    this.ignored = ignored || false;
    this.screensharing = screensharing || false;
    this.recording = recording || false;
    this.recordingPaused = recordingPaused || false;
    this.videoRemotelyDowngraded = videoRemotelyDowngraded;
    this.sipSession = sipSession;
    this.answerTime = answerTime || this.answerTime;
    this.conference = conference;

    // Useful to compare instead of instanceof with minified code
    this.type = 'CallSession';
  }

  resume() {
    this.paused = false;
  }

  hold() {
    this.paused = true;
  }

  mute() {
    this.muted = true;
  }

  unmute() {
    this.muted = false;
  }

  muteVideo() {
    this.videoMuted = true;
  }

  unmuteVideo() {
    this.videoMuted = false;
  }

  answer() {
    this.answerTime = new Date();
  }

  systemAnswer() {
    this.answeredBySystem = true;
  }

  enableCamera() {
    this.cameraEnabled = true;
  }

  disableCamera() {
    this.cameraEnabled = false;
  }

  ignore() {
    this.ignored = true;
  }

  startScreenSharing() {
    this.screensharing = true;
  }

  stopScreenSharing() {
    this.screensharing = false;
  }

  setIsConference(conference         ) {
    this.conference = conference;
  }

  isIncoming()          {
    return !this.isCaller && !this.answered;
  }

  isOutgoing()          {
    return this.isCaller && !this.answered;
  }

  isActive()          {
    return this.answered || this.isOutgoing();
  }

  isAnswered()          {
    return this.answered;
  }

  isAnsweredBySystem()          {
    return this.answeredBySystem;
  }

  isRinging()          {
    return this.ringing;
  }

  isOnHold()          {
    return this.paused;
  }

  isMuted()          {
    return this.muted;
  }

  isVideoMuted()          {
    return this.videoMuted;
  }

  isCameraEnabled()          {
    return this.cameraEnabled;
  }

  isIgnored()          {
    return this.ignored;
  }

  isScreenSharing()          {
    return this.screensharing;
  }

  isRecording()          {
    return this.recording;
  }

  recordingIsPaused()          {
    return this.recordingPaused;
  }

  hasAnInitialInterceptionNumber()          {
    return this.number.startsWith('*8');
  }

  isAnInterception()          {
    return this.dialedExtension.startsWith('*8');
  }

  isEstablished()          {
    return this.sipStatus === sessionState.SessionState.Established;
  }

  isTerminating()          {
    return this.sipStatus === sessionState.SessionState.Terminating;
  }

  isTerminated()          {
    return this.sipStatus === sessionState.SessionState.Terminated;
  }

  isConference()          {
    return this.conference;
  }

  getElapsedTimeInSeconds() {
    if (!this.startTime) {
      return 0;
    }
    return (Date.now() - this.startTime) / 1000;
  }

  getId() {
    return this.sipCallId || this.callId;
  }

  is(callSession              ) {
    if (!callSession) {
      return false;
    }

    return this.isId(callSession.sipCallId) || this.isId(callSession.callId);
  }

  isId(id        )          {
    return (
      this.getId() === id || (this.sipCallId && this.sipCallId === id) || (Boolean(this.callId) && this.callId === id)
    );
  }

  updateFrom(session             ) {
    updateFrom(this, session);
  }

  separateDisplayName()                                          {
    const names = this.displayName.split(' ');
    const firstName = names[0];
    const lastName = names.slice(1).join(' ');

    return { firstName, lastName };
  }

  getTalkingToIds() {
    return this.call ? this.call.talkingToIds : [];
  }

  setVideoRemotelyDowngraded(value         ) {
    this.videoRemotelyDowngraded = value;
  }

  isVideoRemotelyDowngraded() {
    return this.videoRemotelyDowngraded;
  }

  static newFrom(callSession             ) {
    return newFrom(callSession, CallSession);
  }

  // Retro-compatibility: `answered` was a boolean before. We can reproduce the behaviour with a getter/setter
  set answered(value         ) {
    this.answerTime = value ? this.answerTime || new Date() : null;
  }

  get answered()          {
    return !!this.answerTime;
  }

  toJSON() {
    const jsonObj = { ...this };
    // $FlowFixMe
    jsonObj.answered = this.answered;

    return jsonObj;
  }

  static parseCall(call      )              {
    return new CallSession({
      callId: call.id,
      sipCallId: call.sipCallId,
      displayName: call.calleeName || call.calleeNumber,
      number: call.calleeNumber,
      callerNumber: call.callerNumber,
      startTime: +call.startingTime,
      paused: call.isOnHold(),
      isCaller: call.isCaller,
      muted: call.muted,
      videoMuted: false,
      screensharing: false,
      recording: call.isRecording(),
      recordingPaused: false, // @TODO
      ringing: call.isRinging(),
      answered: call.isUp(),
      answeredBySystem: call.isUp() && call.talkingToIds.length === 0,
      cameraEnabled: call.isVideo,
      dialedExtension: call.dialedExtension,
      call,
      conference: false, // @FIXME?
    });
  }
}

//      

class Emitter {
                             

  constructor() {
    this.eventEmitter = new EventEmitter__default['default']();
  }

  on(event        , callback          ) {
    this.eventEmitter.on(event, callback);
  }

  once(event        , callback          ) {
    this.eventEmitter.once(event, callback);
  }

  off(event        , callback          ) {
    this.eventEmitter.removeListener(event, callback);
  }

  unbind() {
    this.eventEmitter.removeAllListeners();
  }
}

//      

                                 
                   
                    
                   
                     
               
  

                           
                   
             
                   
              
               
 

class Recording {
                   
             
                   
              
               

  static parseMany(recordings                      = [])              {
    if (!recordings) {
      return [];
    }
    return recordings.map(item => Recording.parse(item));
  }

  static parse(plain                   )            {
    return new Recording({
      deleted: plain.deleted,
      fileName: plain.filename,
      end: plain.end_time ? moment__default['default'](plain.end_time).toDate() : null,
      start: moment__default['default'](plain.start_time).toDate(),
      uuid: plain.uuid,
    });
  }

  constructor({ deleted, end, fileName, start, uuid }                    ) {
    this.deleted = deleted;
    this.end = end;
    this.fileName = fileName;
    this.start = start;
    this.uuid = uuid;
  }
}

//      

                        
                  
                    
                         
                                
                            
                                 
                   
               
             
                           
                      
                            
                                  
                              
                         
                
  

                 
                   
                                
                
  

                         
                
                    
                          
                        
                
                      
                 
                  
    
           
                      
                 
                  
    
             
                   
              
             
                          
  

class CallLog {
               

                
                    
                         
                        
                
                      
                 
    

                          

           
                      
                 
    

             
                   
              
             

  static merge(current                , toMerge                )                  {
    const onlyUnique = (value, index, self) => self.indexOf(value) === index;

    const allLogs                 = current.concat(toMerge);
    const onlyUniqueIds                = allLogs.map(c => c.id).filter(onlyUnique);

    return onlyUniqueIds.map(id => allLogs.find(log => log && log.id === id));
  }

  static parseMany(plain          )                 {
    if (!plain || !plain.items) {
      return [];
    }

    return plain.items.map(item => CallLog.parse(item));
  }

  static parse(plain                 )          {
    return new CallLog({
      answer: plain.answer ? moment__default['default'](plain.answer).toDate() : null,
      answered: plain.answered,
      callDirection: plain.call_direction,
      destination: {
        // @TEMP: Temporarily assuming empty numbers are meetings
        // which is admittedly a very dangerous assumption. Did i mention it was temporary?
        extension: plain.requested_extension
          || plain.destination_extension
          || `meeting-${plain.requested_name || plain.destination_name || ''}`,
        name: plain.requested_name || plain.destination_name || '',
        uuid: plain.destination_user_uuid,
      },
      source: {
        extension: plain.source_extension,
        name: plain.source_name,
        uuid: plain.source_user_uuid,
      },
      id: plain.id,
      duration: (plain.duration || 0) * 1000, // duration is in seconds
      start: moment__default['default'](plain.start).toDate(),
      end: plain.end ? moment__default['default'](plain.end).toDate() : null,
      recordings: Recording.parseMany(plain.recordings || []),
    });
  }

  static parseNew(plain                 , session         )          {
    const callLog          = CallLog.parse(plain);
    // @TODO: FIXME add verification declined vs missed call
    callLog.newMissedCall = session
      && session.hasExtension(plain.requested_extension || plain.destination_extension) && !plain.answered;
    return callLog;
  }

  static newFrom(profile         ) {
    return newFrom(profile, CallLog);
  }

  constructor({
    answer,
    answered,
    callDirection,
    destination,
    source,
    id,
    duration,
    start,
    end,
    recordings,
  }                   = {}) {
    this.answer = answer;
    this.answered = answered;
    this.callDirection = callDirection;
    this.destination = destination;
    this.source = source;
    this.id = id;
    this.duration = duration;
    this.start = start;
    this.end = end;
    this.recordings = recordings || [];

    // Useful to compare instead of instanceof with minified code
    this.type = 'CallLog';
  }

  isFromSameParty(other         , session         )          {
    return this.theOtherParty(session).extension === other.theOtherParty(session).extension;
  }

  theOtherParty(session         )                                      {
    if (this.callDirection === 'inbound') {
      return this.source;
    }

    if (this.callDirection === 'outbound') {
      return this.destination;
    }

    return session && session.hasExtension(this.source.extension) ? this.destination : this.source;
  }

  isNewMissedCall()          {
    return this.newMissedCall;
  }

  acknowledgeCall()          {
    this.newMissedCall = false;

    return this;
  }

  isAcknowledged()          {
    return this.newMissedCall;
  }

  isAnswered()          {
    return this.answered;
  }

  isOutgoing(session         )          {
    if (this.callDirection === 'internal') {
      return session.hasExtension(this.source.extension);
    }

    return this.callDirection === 'outbound';
  }

  isIncoming(session         )          {
    if (this.callDirection === 'internal') {
      return session.hasExtension(this.destination.extension);
    }

    return this.callDirection === 'inbound';
  }

  isAnOutgoingCall(session         )          {
    console.warn(`@wazo/sdk 
      CallLog.isAnOutgoingcall(session) method is obsolete.
      Please use CallLog.isOutgoing(session).
    `);

    return session.hasExtension(this.source.extension) && this.answered;
  }

  isAMissedOutgoingCall(session         )          {
    return session.hasExtension(this.source.extension) && !this.answered;
  }

  isAnIncomingCall(session         )          {
    console.warn(`@wazo/sdk
      CallLog.isAnIncomingCall(session) method is obsolete.
      Please use CallLog.isIncoming(session).
    `);

    return session.hasExtension(this.destination.extension) && this.answered;
  }

  isADeclinedCall(session         )          {
    return !this.answered && session.hasExtension(this.destination.extension);
  }

  getRecordings() {
    return this.recordings;
  }
}

//      

                                         
                  
              
                        
                   
  

                
             
                         
                           
                         
                         
                 
               
 

class IndirectTransfer {
                  

              

                   

                        

  constructor({ sourceId, destinationId, status, id }                           ) {
    this.sourceId = sourceId;
    this.destinationId = destinationId;
    this.status = status;
    this.id = id;
  }

  static parseFromCallSession(source             , destination             ) {
    return new IndirectTransfer({
      sourceId: source.getId(),
      destinationId: destination.getId(),
    });
  }

  static parseFromApi(plain         ) {
    return new IndirectTransfer({
      id: plain.id,
      status: plain.status,
      sourceId: plain.initiator_call,
      destinationId: plain.recipient_call,
    });
  }

  destinationIs(callSession             )          {
    return callSession.isId(this.destinationId);
  }

  sourceIs(callSession             )          {
    return callSession.isId(this.sourceId);
  }

  updateFrom(indirectTransfer                  ) {
    updateFrom(this, indirectTransfer);
  }

  static newFrom(indirectTransfer                  ) {
    return newFrom(indirectTransfer, IndirectTransfer);
  }
}

//      

class CallApi {
  static async fetchCallLogs(offset        , limit        )                  {
    return getApiClient().callLogd.listCallLogs(offset, limit);
  }

  static async fetchDistinctCallLogs(offset        , limit        , distinct         = 'peer_exten')                  {
    return getApiClient().callLogd.listDistinctCallLogs(offset, limit, distinct);
  }

  static async fetchActiveCalls()                  {
    return getApiClient().calld.listCalls();
  }

  static async fetchCallLogsFromDate(from      , number        )                     {
    return getApiClient().callLogd.listCallLogsFromDate(from, number);
  }

  static async search(query        , limit        )                     {
    return getApiClient().callLogd.search(query, limit);
  }

  static async searchBy(field        , value        , limit        )                     {
    return getApiClient().callLogd.searchBy(field, value, limit);
  }

  static async fetchSIP(session         , line       )               {
    const lineToUse = line || session.primaryLine();
    return getApiClient().confd.getUserLineSip(session.uuid, lineToUse ? lineToUse.id : null);
  }

  static async cancelCall(callSession             )                {
    return getApiClient().calld.cancelCall(callSession.callId);
  }

  static async makeCall(callFromLine      , extension        , isMobile          = false,
    callbackAllLines          = false)                 {
    const lineId = callFromLine ? callFromLine.id : null;

    const response = await getApiClient().calld.makeCall(extension, isMobile, lineId, callbackAllLines);
    return Call.parse(response);
  }

  static async relocateCall(callId        , line        , contactIdentifier         )                      {
    return getApiClient().calld.relocateCall(callId, 'line', line, contactIdentifier);
  }

  static async hold(callId        )                {
    return getApiClient().calld.hold(callId);
  }

  static async resume(callId        )                {
    return getApiClient().calld.resume(callId);
  }

  static async mute(callId        )                {
    return getApiClient().calld.mute(callId);
  }

  static async sendDTMF(callId        , digits        )                {
    return getApiClient().calld.sendDTMF(callId, digits);
  }

  static async unmute(callId        )                {
    return getApiClient().calld.unmute(callId);
  }

  static async transferCall(callId        , number        , flow        )                    {
    return getApiClient().calld.transferCall(callId, number, flow);
  }

  static async cancelCallTransfer(transferId        )                    {
    return getApiClient().calld.cancelCallTransfer(transferId);
  }

  static async confirmCallTransfer(transferId        )                    {
    return getApiClient().calld.confirmCallTransfer(transferId);
  }
}

//      

const TRANSFER_FLOW_ATTENDED = 'attended';
const TRANSFER_FLOW_BLIND = 'blind';

// const MINIMUM_WAZO_ENGINE_VERSION_FOR_CTI_HOLD = '20.11';

const logger$b = IssueReporter$1 ? IssueReporter$1.loggerFor('cti-phone') : console;

class CTIPhone extends Emitter                  {
                   

                    

                            

                     

  constructor(session         , isMobile          = false, callbackAllLines          = false) {
    super();
    logger$b.info('CTI Phone created');
    this.session = session;
    this.isMobile = isMobile;
    this.callbackAllLines = callbackAllLines;
  }

  getOptions()                        {
    // @FIXME: temporarily disabling this option
    // const hold = this.session.hasEngineVersionGte(MINIMUM_WAZO_ENGINE_VERSION_FOR_CTI_HOLD);

    return {
      accept: false,
      decline: true,
      mute: true,
      hold: false,
      transfer: true,
      sendKey: true,
      addParticipant: false,
      record: true,
      merge: false,
    };
  }

  hasAnActiveCall() {
    return !!this.currentCall;
  }

  callCount() {
    return this.currentCall ? 1 : 0;
  }

  isWebRTC() {
    return false;
  }

  getUserAgent() {
    return 'cti-phone';
  }

  startHeartbeat() {
  }

  setOnHeartbeatTimeout() {
  }

  setOnHeartbeatCallback() {
  }

  stopHeartbeat() {
  }

  bindClientEvents() {
  }

  onConnect() {
  }

  onDisconnect() {
  }

  async makeCall(number        , line      )                        {
    logger$b.info('make CTI call', { number });

    if (!number) {
      return null;
    }
    try {
      this.currentCall = await CallApi.makeCall(line, number, this.isMobile, this.callbackAllLines);
    } catch (_) {
      // We have to deal with error like `User has no mobile phone number` error in the UI.
    }
    if (!this.currentCall) {
      return null;
    }
    const callSession = CallSession.parseCall(this.currentCall);
    this.eventEmitter.emit('onCallOutgoing', callSession);

    return callSession;
  }

  accept(callSession             )                         {
    if (!callSession) {
      return Promise.resolve(null);
    }
    logger$b.info('accept CTI call', { callId: callSession.getId(), number: callSession.number });

    if (!this.currentCall) {
      this.currentCall = callSession.call;
    }

    return Promise.resolve(callSession.getId());
  }

  endCurrentCall(callSession             )       {
    if (!callSession) {
      return;
    }
    logger$b.info('end current CTI call', { callId: callSession.getId(), number: callSession.number });

    this.currentCall = undefined;
    this.eventEmitter.emit('onCallEnded', callSession);
  }

  async hangup(callSession             )                   {
    if (!callSession) {
      return Promise.resolve(false);
    }
    logger$b.info('hangup CTI call', { callId: callSession.getId(), number: callSession.number });

    try {
      await CallApi.cancelCall(callSession);
      if (this.currentCall && callSession.callId === this.currentCall.id) {
        this.endCurrentCall(callSession);
      }

      this.eventEmitter.emit('onCallEnded', callSession);
      return true;
    } catch (e) {
      logger$b.error('hangup CTI call, error', e);

      this.eventEmitter.emit('onCallFailed', callSession);
      return false;
    }
  }

  ignore() {}

  async reject(callSession             )                {
    if (!callSession) {
      return;
    }
    logger$b.info('reject CTI call', { callId: callSession.getId(), number: callSession.number });

    await CallApi.cancelCall(callSession);
    this.eventEmitter.emit('onCallEnded', callSession);
  }

  async transfer(callSession             , number        )                {
    if (!callSession) {
      return;
    }
    logger$b.info('transfer CTI call', { callId: callSession.getId(), number: callSession.number, to: number });

    await CallApi.transferCall(callSession.callId, number, TRANSFER_FLOW_BLIND);
  }

  indirectTransfer() {
    return Promise.resolve(false);
  }

  async initiateCTIIndirectTransfer(callSession             , number        )               {
    if (!callSession) {
      return;
    }
    logger$b.info('indirect CTI transfer', { callId: callSession.getId(), number: callSession.number, to: number });

    return CallApi.transferCall(callSession.callId, number, TRANSFER_FLOW_ATTENDED);
  }

  async cancelCTIIndirectTransfer(transferId        )               {
    logger$b.info('cancel CTI transfer', { transferId });

    return CallApi.cancelCallTransfer(transferId);
  }

  async confirmCTIIndirectTransfer(transferId        )               {
    logger$b.info('confirm CTI transfer', { transferId });

    return CallApi.confirmCallTransfer(transferId);
  }

  sendKey(callSession             , digits        ) {
    if (!callSession) {
      return;
    }
    logger$b.info('send CTI key', { callId: callSession.getId(), number: callSession.number, digits });

    return CallApi.sendDTMF(callSession.callId, digits);
  }

  onConnectionMade() {
    logger$b.info('on CTI connection made');

    this.eventEmitter.emit('onCallAccepted');
  }

  async close() {
    logger$b.info('CTI close');

    return Promise.resolve();
  }

  async hold(callSession             )                {
    if (!callSession) {
      return;
    }
    logger$b.info('CTI hold', { callId: callSession.getId(), number: callSession.number });

    return CallApi.hold(callSession.callId);
  }

  async resume(callSession             )                {
    if (!callSession) {
      return;
    }
    logger$b.info('CTI resume', { callId: callSession.getId(), number: callSession.number });

    return CallApi.resume(callSession.callId);
  }

  async mute(callSession             )                {
    if (!callSession) {
      return;
    }
    logger$b.info('CTI mute', { callId: callSession.getId(), number: callSession.number });

    return CallApi.mute(callSession.callId);
  }

  async unmute(callSession             )                {
    if (!callSession) {
      return;
    }
    logger$b.info('CTI unmute', { callId: callSession.getId(), number: callSession.number });

    return CallApi.unmute(callSession.callId);
  }

  putOnSpeaker() {}

  putOffSpeaker() {}

  turnCameraOff() {}

  turnCameraOn() {}

  changeAudioInputDevice() {}

  changeVideoInputDevice() {}

  changeAudioDevice() {}

  changeRingDevice() {}

  changeAudioVolume() {}

  changeRingVolume() {}

  hasVideo()          {
    return false;
  }

  hasAVideoTrack()          {
    return false;
  }

  getLocalStreamForCall()               {
    return null;
  }

  getRemoteStreamForCall()               {
    return null;
  }

  getLocalVideoStream()               {
    return null;
  }

  setActiveSipSession() {}

  isRegistered()          {
    return true;
  }

  hasIncomingCallSession()          {
    return true;
  }

  hasActiveRemoteVideoStream()          {
    return false;
  }

  getCurrentCallSession()               {
    return this.currentCall ? CallSession.parseCall(this.currentCall) : null;
  }

  enableRinging() {}

  sendMessage() {}

  disableRinging() {}

  getLocalStream() {
    return null;
  }

  getRemoteStream() {
    return null;
  }

  getRemoteVideoStream() {
    return null;
  }

  getRemoteAudioStream() {
    return null;
  }

  hasLocalVideo() {
    return false;
  }

  useLocalVideoElement() {}

  setMediaConstraints() {}
}

/*       */

                  
                       
                    
                   
                      
  

var ctidNgMethods = (client              , baseUrl        ) => ({
  updatePresence: (presence        )                   =>
    client.put(`${baseUrl}/users/me/presences`, { presence }, null, ApiRequester.successResponseParser),

  listMessages: (participantUuid       , limit         )                              => {
    const query         = {};

    if (participantUuid) {
      query.participant_user_uuid = participantUuid;
    }

    if (limit) {
      query.limit = limit;
    }

    return client.get(`${baseUrl}/users/me/chats`, query).then(ChatMessage.parseMany);
  },

  sendMessage: (alias        , msg        , toUserId        ) => {
    const body = { alias, msg, to: toUserId };

    return client.post(`${baseUrl}/users/me/chats`, body, null, ApiRequester.successResponseParser);
  },

  makeCall: (extension        , fromMobile         , lineId         , allLines           = false) => {
    const query            = {
      from_mobile: fromMobile,
      extension,
    };

    if (lineId) {
      query.line_id = lineId;
    }

    if (allLines) {
      query.all_lines = true;
    }

    return client.post(`${baseUrl}/users/me/calls`, query);
  },

  cancelCall: (callId        )                   => client.delete(`${baseUrl}/users/me/calls/${callId}`),

  listCalls: ()                       =>
    client.get(`${baseUrl}/users/me/calls`).then(response => Call.parseMany(response.items)),

  relocateCall(callId        , destination        , lineId         , contact          )                      {
    const body         = {
      completions: ['answer'],
      destination,
      initiator_call: callId,
      auto_answer: true,
    };

    if (lineId || contact) {
      body.location = {};
    }

    if (lineId) {
      body.location.line_id = lineId;
    }

    if (contact) {
      body.location.contact = contact;
    }

    return client.post(`${baseUrl}/users/me/relocates`, body).then(response => Relocation.parse(response));
  },

  transferCall(
    callId        ,
    number        ,
    flow         = TRANSFER_FLOW_BLIND,
  )                                      {
    const body         = {
      exten: number,
      flow,
      initiator_call: callId,
    };

    return client.post(`${baseUrl}/users/me/transfers`, body).then(response => response);
  },

  // @TODO: fix response type
  cancelCallTransfer: (transferId        )                               =>
    client.delete(`${baseUrl}/users/me/transfers/${transferId}`),

  // @TODO: fix response type
  confirmCallTransfer: (transferId        )                               =>
    client.put(`${baseUrl}/users/me/transfers/${transferId}/complete`),

  listVoicemails: ()                                           =>
    client.get(`${baseUrl}/users/me/voicemails`, null).then(response => Voicemail.parseMany(response)),

  deleteVoicemail: (voicemailId        )                   =>
    client.delete(`${baseUrl}/users/me/voicemails/messages/${voicemailId}`, null),

  getPresence: (contactUuid      )                                                                      =>
    client.get(`${baseUrl}/users/${contactUuid}/presences`, null),

  getStatus: (lineUuid      ) => client.get(`${baseUrl}/lines/${lineUuid}/presences`, null),

  fetchSwitchboardHeldCalls: (switchboardUuid      ) =>
    client.get(`${baseUrl}/switchboards/${switchboardUuid}/calls/held`, null),

  holdSwitchboardCall: (switchboardUuid      , callId        ) =>
    client.put(
      `${baseUrl}/switchboards/${switchboardUuid}/calls/held/${callId}`,
      null,
      null,
      ApiRequester.successResponseParser,
    ),

  answerSwitchboardHeldCall: (switchboardUuid      , callId        ) =>
    client.put(`${baseUrl}/switchboards/${switchboardUuid}/calls/held/${callId}/answer`, null),

  fetchSwitchboardQueuedCalls: (switchboardUuid      ) =>
    client.get(`${baseUrl}/switchboards/${switchboardUuid}/calls/queued`, null),

  answerSwitchboardQueuedCall: (switchboardUuid      , callId        ) =>
    client.put(`${baseUrl}/switchboards/${switchboardUuid}/calls/queued/${callId}/answer`, null),

  sendFax: (extension        , fax        , callerId          = null) => {
    const headers = {
      'Content-type': 'application/pdf',
      'X-Auth-Token': client.token,
    };
    const params = ApiRequester.getQueryString({ extension, caller_id: callerId });

    return client.post(`${baseUrl}/users/me/faxes?${params}`, fax, headers);
  },

});

/*       */
                                                    
                                                                                   
                                        

const getContactPayload = (contact                      ) => ({
  email: contact.email,
  firstname: contact.firstName ? contact.firstName : '',
  lastname: contact.lastName ? contact.lastName : '',
  number: contact.phoneNumber ? contact.phoneNumber : '',
  entreprise: contact.entreprise ? contact.entreprise : '',
  birthday: contact.birthday ? contact.birthday : '',
  address: contact.address ? contact.address : '',
  note: contact.note ? contact.note : '',
});

                                 
                 
                             
                 
                  
                  
                
         

var dirdMethods = (client              , baseUrl        ) => ({
  search: (context        , term        )                          =>
    client.get(`${baseUrl}/directories/lookup/${context}`, { term }).then(Contact.parseMany),

  listPersonalContacts: (queryParams                           = null)                          =>
    client.get(`${baseUrl}/personal`, queryParams).then(response => Contact.parseManyPersonal(response.items)),

  fetchPersonalContact: (contactUuid        )                   =>
    client
      .get(`${baseUrl}/personal/${contactUuid}`)
      .then(Contact.parsePersonal),

  addContact: (contact            )                   =>
    client.post(`${baseUrl}/personal`, getContactPayload(contact)).then(Contact.parsePersonal),

  editContact: (contact         )                   =>
    client
      .put(`${baseUrl}/personal/${contact.sourceId || contact.id || ''}`, getContactPayload(contact))
      .then(Contact.parsePersonal),

  importContacts: (csv        )                     => {
    const headers = {
      'Content-Type': 'text/csv; charset=utf-8',
      'X-Auth-Token': client.token,
    };

    return client.post(`${baseUrl}/personal/import`, csv, headers)
      .then(result => Contact.parseManyPersonal(result.created));
  },

  deleteContact: (contactUuid      ) => client.delete(`${baseUrl}/personal/${contactUuid}`),

  listFavorites: (context        )                          =>
    client.get(`${baseUrl}/directories/favorites/${context}`).then(Contact.parseMany),

  markAsFavorite: (source        , sourceId        )                   => {
    const url = `${baseUrl}/directories/favorites/${source}/${sourceId}`;

    return client.put(url, null, null, ApiRequester.successResponseParser);
  },

  removeFavorite: (source        , sourceId        ) =>
    client.delete(`${baseUrl}/directories/favorites/${source}/${sourceId}`),

  fetchOffice365Source: (context        )                            =>
    client.get(`${baseUrl}/directories/${context}/sources`, { backend: 'office365' }),

  fetchOffice365Contacts: (source                 ,
    queryParams                           = null)                      => {
    if (!source) {
      return null;
    }

    return client
      .get(`${baseUrl}/backends/office365/sources/${source.uuid}/contacts`, queryParams)
      .then(response => Contact.parseManyOffice365(response.items, source));
  },

  fetchWazoSource: (context        )                   =>
    client.get(`${baseUrl}/directories/${context}/sources`, { backend: 'wazo' }),

  // Can be used with `queryParams = { uuid: uuid1, uuid2 }` to fetch multiple contacts
  fetchWazoContacts: (source                 , queryParams                           = null)                      => {
    if (!source) {
      return null;
    }
    return client
      .get(`${baseUrl}/backends/wazo/sources/${source.uuid}/contacts`, queryParams)
      .then(response => Contact.parseManyWazo(response.items, source));
  },

  fetchGoogleSource: (context        )                   =>
    client.get(`${baseUrl}/directories/${context}/sources`, { backend: 'google' }),

  fetchGoogleContacts: (source                 , queryParams                           = null)                      => {
    if (!source) {
      return null;
    }

    return client
      .get(`${baseUrl}/backends/google/sources/${source.uuid}/contacts`, queryParams)
      .then(response => Contact.parseManyGoogle(response.items, source));
  },

  fetchConferenceSource: (context        )                   =>
    client.get(`${baseUrl}/directories/${context}/sources`, { backend: 'conference' }),

  fetchConferenceContacts: (source                 )                      => {
    if (!source) {
      return null;
    }

    return client
      .get(`${baseUrl}/backends/conference/sources/${source.uuid}/contacts`)
      .then(response => Contact.parseManyConference(response.items, source));
  },

  // Graphql
  findMultipleContactsByNumber: (numbers          , fields         = null)                     => {
    const query = jsonToGraphQLQuery.jsonToGraphQLQuery({
      me: {
        contacts: {
          __args: {
            profile: 'default',
            extens: numbers,
          },
          edges: {
            node: fields || {
              firstname: true,
              lastname: true,
              wazoReverse: true,
              wazoBackend: true,
              email: true,
              wazoSourceEntryId: true,
              wazoSourceName: true,
              '... on WazoContact': {
                userUuid: true,
              },
            },
          },
        },
      },
    });

    return client.post(`${baseUrl}/graphql`, { query: `{${query}}` })
      .then(Contact.manyGraphQlWithNumbersParser(numbers));
  },

});

/*       */

var callLogdMethods = (client              , baseUrl        ) => ({
  search: (search        , limit         = 5)                          =>
    client.get(`${baseUrl}/users/me/cdr`, { search, limit }).then(CallLog.parseMany),

  searchBy: (field        , value        , limit         = 5)                          =>
    client.get(`${baseUrl}/users/me/cdr`, { [field]: value, limit }).then(CallLog.parseMany),

  listCallLogs: (offset        , limit         = 5)                          =>
    client.get(`${baseUrl}/users/me/cdr`, { offset, limit }).then(CallLog.parseMany),

  listDistinctCallLogs: (offset        , limit         = 5, distinct        )                          =>
    client.get(`${baseUrl}/users/me/cdr`, { offset, limit, distinct }).then(CallLog.parseMany),

  listCallLogsFromDate: (from      , number        )                          =>
    client.get(`${baseUrl}/users/me/cdr`, { from: from.toISOString(), number }).then(CallLog.parseMany),
});

//      

                            
               
               
                         
  

                                
                   
                
                             
  

class ChatRoom {
               

               
               
                         

  static parseMany(plain                  )                  {
    if (!plain || !plain.items) {
      return [];
    }
    return plain.items.map(item => ChatRoom.parse(item));
  }

  static parse(plain              )           {
    return new ChatRoom({
      uuid: plain.uuid,
      name: plain.name,
      users: plain.users,
    });
  }

  static newFrom(room          ) {
    return newFrom(room, ChatRoom);
  }

  constructor({ uuid, name, users }         = {}) {
    this.uuid = uuid;
    this.name = name;
    this.users = users;

    // Useful to compare instead of instanceof with minified code
    this.type = 'ChatRoom';
  }
}

/*       */

                                
                                              
                                                     
                
                 
                    
  

                             
                   
                
                                 
  

                           
                     
                 
                 
                  
                 
                   
  

var chatdMethods = (client              , baseUrl        ) => ({
  updateState: (contactUuid      , state        )                   =>
    client.put(`${baseUrl}/users/${contactUuid}/presences`, { state }, null, ApiRequester.successResponseParser),

  updateStatus: (contactUuid      , state        , status        )                   => {
    const body = { state, status };

    return client.put(`${baseUrl}/users/${contactUuid}/presences`, body, null, ApiRequester.successResponseParser);
  },

  getState: async (contactUuid      )                  =>
    client.get(`${baseUrl}/users/${contactUuid}/presences`).then((response                  ) => response.state),

  getContactStatusInfo: async (contactUuid      )                            =>
    client.get(`${baseUrl}/users/${contactUuid}/presences`).then((response                  ) => response),

  getLineState: async (contactUuid      )                  =>
    client
      .get(`${baseUrl}/users/${contactUuid}/presences`)
      .then((response                  ) => Profile.getLinesState(response.lines)),

  getMultipleLineState: async (contactUuids              )                  => {
    const body = {};
    if (contactUuids && contactUuids.length) {
      body.user_uuid = contactUuids.join(',');
    }

    return client.get(`${baseUrl}/users/presences`, body).then((response                      ) => response.items);
  },

  getUserRooms: async ()                           => client.get(`${baseUrl}/users/me/rooms`).then(ChatRoom.parseMany),

  createRoom: async (name        , users                 )                    =>
    client.post(`${baseUrl}/users/me/rooms`, { name, users }).then(ChatRoom.parse),

  getRoomMessages: async (roomUuid        , params                     = {})                              => {
    const qs = ApiRequester.getQueryString(params);

    return client
      .get(`${baseUrl}/users/me/rooms/${roomUuid}/messages${qs.length ? `?${qs}` : ''}`)
      .then((response                         ) => ChatMessage.parseMany(response));
  },

  sendRoomMessage: async (roomUuid        , message             )                       =>
    client.post(`${baseUrl}/users/me/rooms/${roomUuid}/messages`, message).then(ChatMessage.parse),

  getMessages: async (options                    )                       =>
    client.get(`${baseUrl}/users/me/rooms/messages`, options),
});

//      

                                     
               
  

class MeetingStatus {
               

                

  constructor({
    full,
  }         = {}) {
    this.full = full;

    // Useful to compare instead of instanceof with minified code
    this.type = 'MeetingStatus';
  }

  static parse(plain                       )                {
    return new MeetingStatus({
      full: plain.full,
    });
  }

}

/*       */

                  
                       
                    
                   
                      
  

var calldMethods = (client              , baseUrl        ) => ({
  updatePresence: (presence        )                   =>
    client.put(`${baseUrl}/users/me/presences`, { presence }, null, ApiRequester.successResponseParser),

  listMessages: (participantUuid       , limit         )                              => {
    const query         = {};

    if (participantUuid) {
      query.participant_user_uuid = participantUuid;
    }

    if (limit) {
      query.limit = limit;
    }

    return client.get(`${baseUrl}/users/me/chats`, query).then(response => ChatMessage.parseMany(response));
  },

  sendMessage: (alias        , msg        , toUserId        ) => {
    const body = { alias, msg, to: toUserId };

    return client.post(`${baseUrl}/users/me/chats`, body, null, ApiRequester.successResponseParser);
  },

  makeCall: (extension        , fromMobile         , lineId         , allLines           = false) => {
    const query            = {
      from_mobile: fromMobile,
      extension,
    };

    if (lineId) {
      query.line_id = lineId;
    }

    if (allLines) {
      query.all_lines = true;
    }

    return client.post(`${baseUrl}/users/me/calls`, query);
  },

  cancelCall: (callId        )                   => client.delete(`${baseUrl}/users/me/calls/${callId}`, null),

  listCalls: ()                       =>
    client.get(`${baseUrl}/users/me/calls`, null).then(response => Call.parseMany(response.items)),

  relocateCall(callId        , destination        , lineId         , contact          )                      {
    const body         = {
      completions: ['answer'],
      destination,
      initiator_call: callId,
      auto_answer: true,
    };

    if (lineId || contact) {
      body.location = {};
    }

    if (lineId) {
      body.location.line_id = lineId;
    }

    if (contact) {
      body.location.contact = contact;
    }

    return client.post(`${baseUrl}/users/me/relocates`, body).then(response => Relocation.parse(response));
  },

  listVoicemails: ()                                           =>
    client.get(`${baseUrl}/users/me/voicemails`).then(response => Voicemail.parseMany(response)),

  deleteVoicemail: (voicemailId        )                   =>
    client.delete(`${baseUrl}/users/me/voicemails/messages/${voicemailId}`),

  getVoicemailUrl: (voicemail           ) => {
    const body = { token: client.token };

    return client.computeUrl('get', `${baseUrl}/users/me/voicemails/messages/${voicemail.id}/recording`, body);
  },

  fetchSwitchboardHeldCalls: (switchboardUuid      ) =>
    client.get(`${baseUrl}/switchboards/${switchboardUuid}/calls/held`),

  holdSwitchboardCall: (switchboardUuid      , callId        ) =>
    client.put(
      `${baseUrl}/switchboards/${switchboardUuid}/calls/held/${callId}`,
      null,
      null,
      ApiRequester.successResponseParser,
    ),

  answerSwitchboardHeldCall: (switchboardUuid      , callId        , lineId          = null) =>
    client.put(
      `${baseUrl}/switchboards/${switchboardUuid}/calls/held/${callId}/answer${lineId ? `?line_id=${lineId}` : ''}`,
    ),

  fetchSwitchboardQueuedCalls: (switchboardUuid      ) =>
    client.get(`${baseUrl}/switchboards/${switchboardUuid}/calls/queued`),

  answerSwitchboardQueuedCall: (switchboardUuid      , callId        , lineId          = null) =>
    client.put(
      `${baseUrl}/switchboards/${switchboardUuid}/calls/queued/${callId}/answer${lineId ? `?line_id=${lineId}` : ''}`,
    ),

  sendFax: (extension        , fax        , callerId          = null) => {
    const headers = {
      'Content-type': 'application/pdf',
      'X-Auth-Token': client.token,
    };
    const params = ApiRequester.getQueryString({ extension, caller_id: callerId });

    return client.post(`${baseUrl}/users/me/faxes?${params}`, fax, headers);
  },

  getConferenceParticipantsAsUser: async (conferenceId        )                  =>
    client.get(`${baseUrl}/users/me/conferences/${conferenceId}/participants`),

  getMeetingParticipantsAsUser: async (meetingUuid        )                  =>
    client.get(`${baseUrl}/users/me/meetings/${meetingUuid}/participants`),

  banMeetingParticipant: (meetingUuid        , participantUuid        ) =>
    client.delete(
      `${baseUrl}/users/me/meetings/${meetingUuid}/participants/${participantUuid}`,
      null,
      null,
      ApiRequester.successResponseParser,
    ),

  listTrunks: () => client.get(`${baseUrl}/trunks`),

  mute: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/mute/start`, null, null, ApiRequester.successResponseParser),

  unmute: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/mute/stop`, null, null, ApiRequester.successResponseParser),

  hold: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/hold/start`, null, null, ApiRequester.successResponseParser),

  resume: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/hold/stop`, null, null, ApiRequester.successResponseParser),

  // eslint-disable-next-line camelcase
  transferCall: (initiator_call        , exten        , flow        ) =>
    client.post(`${baseUrl}/users/me/transfers`, { initiator_call, exten, flow }).then(IndirectTransfer.parseFromApi),

  confirmCallTransfer: (transferId        ) => client.put(`${baseUrl}/users/me/transfers/${transferId}/complete`),

  cancelCallTransfer: (transferId        ) => client.delete(`${baseUrl}/users/me/transfers/${transferId}`),

  sendDTMF: (callId        , digits        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/dtmf?digits=${encodeURIComponent(digits)}`,
      null, null, ApiRequester.successResponseParser),

  // @deprecated: check for engine version >= 20.12 instead
  isAhHocConferenceAPIEnabled: () => client.head(`${baseUrl}/users/me/conferences/adhoc`, null, null,
    ApiRequester.successResponseParser),

  createAdHocConference: (hostCallId        , participantCallIds        ) =>
    client.post(`${baseUrl}/users/me/conferences/adhoc`, {
      host_call_id: hostCallId,
      participant_call_ids: participantCallIds,
    }),

  addAdHocConferenceParticipant: (conferenceId        , callId        ) =>
    client.put(`${baseUrl}/users/me/conferences/adhoc/${conferenceId}/participants/${callId}`, null, null,
      ApiRequester.successResponseParser),

  removeAdHocConferenceParticipant: (conferenceId        , participantCallId        ) =>
    client.delete(`${baseUrl}/users/me/conferences/adhoc/${conferenceId}/participants/${participantCallId}`, null, null,
      ApiRequester.successResponseParser),

  deleteAdHocConference: (conferenceId        ) =>
    client.delete(`${baseUrl}/users/me/conferences/adhoc/${conferenceId}`, null, null,
      ApiRequester.successResponseParser),

  startRecording: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/record/start`, null, null,
      ApiRequester.successResponseParser),

  stopRecording: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/record/stop`, null, null,
      ApiRequester.successResponseParser),

  pauseRecording: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/record/pause`, null, null,
      ApiRequester.successResponseParser),

  resumeRecording: (callId        ) =>
    client.put(`${baseUrl}/users/me/calls/${callId}/record/resume`, null, null,
      ApiRequester.successResponseParser),

  guestGetMeetingStatus: (meetingUuid        )                         =>
    client.get(`${baseUrl}/guests/me/meetings/${meetingUuid}/status`).then(MeetingStatus.parse),
});

//      

                      
                  
                    
             
                  
                 
                  
                        
 

                       
                  
                    
             
                  
                 
                  
                       
 

class Agent {

                  
                    
             
                  
                 
                  
                       

  static parse(plain               )        {
    return new Agent({
      context: plain.context,
      extension: plain.extension,
      id: plain.id,
      logged: plain.logged,
      number: plain.number,
      paused: plain.paused,
      pausedReason: plain.paused_reason,
    });
  }

  constructor({
    context,
    extension,
    id,
    logged,
    number,
    paused,
    pausedReason,
  }                        ) {
    this.context = context;
    this.extension = extension;
    this.id = id;
    this.logged = logged;
    this.number = number;
    this.paused = paused;
    this.pausedReason = pausedReason;
  }
}

/*       */

var agentdMethods = (client              , baseUrl        ) => ({
  getAgent: (agentId        )                 =>
    client.get(`${baseUrl}/agents/by-id/${agentId}`, null).then(Agent.parse),

  login: (agentNumber        , context        , extension        ) =>
    client.post(
      `${baseUrl}/agents/by-number/${agentNumber}/login`,
      { context, extension },
      null,
      ApiRequester.successResponseParser,
    ),

  loginWithLineId: (lineId        ) =>
    client.post(
      `${baseUrl}/users/me/agents/login`,
      { line_id: lineId },
      null,
      ApiRequester.successResponseParser,
    ),

  logout: (agentNumber        ) =>
    client.post(
      `${baseUrl}/agents/by-number/${agentNumber}/logoff`,
      null,
      null,
      ApiRequester.successResponseParser,
    ),

  pause: (agentNumber        ) =>
    client.post(
      `${baseUrl}/agents/by-number/${agentNumber}/pause`,
      { reason: 'songbird_reason' },
      null,
      ApiRequester.successResponseParser,
    ),

  resume: (agentNumber        ) =>
    client.post(
      `${baseUrl}/agents/by-number/${agentNumber}/unpause`,
      null,
      null,
      ApiRequester.successResponseParser,
    ),

  getStatus: ()                 => client.get(`${baseUrl}/users/me/agents`, null).then(Agent.parse),

  staticLogout: () =>
    client.post(
      `${baseUrl}/users/me/agents/logoff`,
      null,
      null,
      ApiRequester.successResponseParser,
    ),

  staticPause: () =>
    client.post(
      `${baseUrl}/users/me/agents/pause`,
      { reason: 'songbird_reason' },
      null,
      ApiRequester.successResponseParser,
    ),

  staticResume: () =>
    client.post(
      `${baseUrl}/users/me/agents/unpause`,
      null,
      null,
      ApiRequester.successResponseParser,
    ),
});

//      

                             
                 
                   
                           
                           
                   
               
                            
                          
                  
               
 

                              
               
                   
                 
               
                  
                         
                         
                   
                          
                        
 

class Subscription {

               
                   
                 
               
                  
                         
                         
                   
                          
                        

  static parse(plain                      )               {
    return new Subscription({
      name: plain.name,
      events: plain.events,
      config: plain.config,
      uuid: plain.uuid,
      service: plain.service,
      eventsUserUuid: plain.events_user_uuid,
      eventsWazoUuid: plain.events_wazo_uuid,
      metadata: plain.metadata,
      ownerTenantUuid: plain.owner_tenant_uuid,
      ownerUserUuid: plain.owner_user_uuid,
    });
  }

  static parseMany(response                                   )                 {
    return response.items.map(payload => Subscription.parse(payload));
  }

  constructor({
    name,
    events,
    config,
    uuid,
    service,
    eventsUserUuid,
    eventsWazoUuid,
    metadata,
    ownerTenantUuid,
    ownerUserUuid,
  }                               ) {
    this.name = name;
    this.events = events;
    this.config = config;
    this.uuid = uuid;
    this.service = service;
    this.eventsUserUuid = eventsUserUuid;
    this.eventsWazoUuid = eventsWazoUuid;
    this.metadata = metadata;
    this.ownerTenantUuid = ownerTenantUuid;
    this.ownerUserUuid = ownerUserUuid;
  }
}

/*       */

                      
           
                 
                         
                   
                
                              
    
                   
               
                  
              
 

var webhookdMethods = (client              , baseUrl        ) => ({
  getSubscriptions: ()                          =>
    client.get(`${baseUrl}/users/me/subscriptions`).then(Subscription.parseMany),

  getSubscription: (uuid        )                        =>
    client.get(`${baseUrl}/users/me/subscriptions/${uuid}`).then(Subscription.parse),

  createSubscription: (payload               )                        =>
    client.post(`${baseUrl}/users/me/subscriptions`, payload),

  removeSubscription: (uuid        )                        =>
    client.delete(`${baseUrl}/users/me/subscriptions/${uuid}`),
});

/*       */

var amidMethods = (client              , baseUrl        ) => ({
  action: (action        , args         = {})                  =>
    client.post(`${baseUrl}/action/${action}`, args),

  getAors: async (endpoint        ) => {
    const rawEvents = await client.post(`${baseUrl}/action/PJSIPShowEndpoint`, { Endpoint: endpoint });

    return rawEvents.filter(event => event.Event === 'ContactStatusDetail');
  },
});

/*       */

                          
                 
                  
                    
                         
                      
                        
  

const AUTH_VERSION = '0.1';
const APPLICATION_VERSION = '1.0';
const CONFD_VERSION = '1.1';
const CTIDNG_VERSION = '1.0';
const DIRD_VERSION = '0.1';
const CALL_LOGD_VERSION = '1.0';
const CHATD_VERSION = '1.0';
const CALLD_VERSION = '1.0';
const AGENTD_VERSION = '1.0';
const WEBHOOKD_VERSION = '1.0';
const AMID_VERSION = '1.0';

const logger$a = IssueReporter$1 ? IssueReporter$1.loggerFor('api') : console;

class ApiClient {
                       
               
                      
                
                 
               
                   
                
                
                 
                   
               

                        
                            
                                 
                             
                          
                           
                             
                    
                       

  // @see https://github.com/facebook/flow/issues/183#issuecomment-358607052
  constructor({ server, agent = null, refreshToken, clientId, isMobile = false, fetchOptions }                   ) {
    this.updateParameters({ server, agent, clientId, fetchOptions });
    this.refreshToken = refreshToken;
    this.isMobile = isMobile || false;
  }

  initializeEndpoints()       {
    this.auth = authMethods(this.client, `auth/${AUTH_VERSION}`);
    this.application = applicationMethods(this.client, `calld/${APPLICATION_VERSION}/applications`);
    this.confd = confdMethods(this.client, `confd/${CONFD_VERSION}`);
    this.ctidNg = ctidNgMethods(this.client, `ctid-ng/${CTIDNG_VERSION}`);
    this.dird = dirdMethods(this.client, `dird/${DIRD_VERSION}`);
    this.callLogd = callLogdMethods(this.client, `call-logd/${CALL_LOGD_VERSION}`);
    this.chatd = chatdMethods(this.client, `chatd/${CHATD_VERSION}`);
    this.calld = calldMethods(this.client, `calld/${CALLD_VERSION}`);
    this.agentd = agentdMethods(this.client, `agentd/${AGENTD_VERSION}`);
    this.webhookd = webhookdMethods(this.client, `webhookd/${WEBHOOKD_VERSION}`);
    this.amid = amidMethods(this.client, `amid/${AMID_VERSION}`);
  }

  updateParameters({ server, agent, clientId, fetchOptions }        ) {
    const refreshTokenCallback = this.refreshTokenCallback.bind(this);
    this.client = new ApiRequester({ server, agent, refreshTokenCallback, clientId, fetchOptions });

    this.initializeEndpoints();
  }

  async forceRefreshToken() {
    logger$a.info('forcing refresh token, calling callback');
    return this.refreshTokenCallback();
  }

  async refreshTokenCallback() {
    logger$a.info('refresh token callback called', {
      refreshToken: this.refreshToken,
      refreshBackend: this.refreshBackend,
      refreshTenantId: this.refreshTenantId,
      refreshDomainName: this.refreshDomainName,
      refreshExpiration: this.refreshExpiration,
      isMobile: this.isMobile,
    });

    if (!this.refreshToken) {
      return null;
    }

    try {
      const session = await this.auth.refreshToken(
        this.refreshToken,
        this.refreshBackend,
        this.refreshExpiration,
        this.isMobile,
        this.refreshTenantId,
        this.refreshDomainName,
      );

      logger$a.info('token refreshed', { token: session.token });

      if (this.onRefreshToken) {
        this.onRefreshToken(session.token, session);
      }

      this.setToken(session.token);

      return session.token;
    } catch (error) {
      logger$a.error('token refresh, error', error);

      if (this.onRefreshTokenError) {
        this.onRefreshTokenError(error);
      }
    }
  }

  setToken(token        ) {
    this.client.setToken(token);
  }

  setTenant(tenant        ) {
    this.client.setTenant(tenant);
  }

  setRefreshToken(refreshToken         ) {
    this.refreshToken = refreshToken;
  }

  setClientId(clientId         ) {
    this.client.clientId = clientId;
  }

  setOnRefreshToken(onRefreshToken          ) {
    this.onRefreshToken = onRefreshToken;
  }

  setOnRefreshTokenError(callback          ) {
    this.onRefreshTokenError = callback;
  }

  setRefreshExpiration(refreshExpiration        ) {
    this.refreshExpiration = refreshExpiration;
  }

  setRefreshBackend(refreshBackend        ) {
    this.refreshBackend = refreshBackend;
  }

  setRefreshTenantId(tenantId         ) {
    console.warn('Use of `setRefreshTenantId` is deprecated, use `setRefreshDomainName` instead');
    this.refreshTenantId = tenantId;
  }

  setRefreshDomainName(domainName         ) {
    this.refreshDomainName = domainName;
  }

  setIsMobile(isMobile         ) {
    this.isMobile = isMobile;
  }

  setFetchOptions(fetchOptions        ) {
    this.fetchOptions = fetchOptions;
    this.client.setFetchOptions(fetchOptions);
  }

  disableErrorLogging() {
    this.client.disableErrorLogging();
  }
}

/* eslint-disable dot-notation */

// Can't use node cache mechanism here because when requiring lib/CallApi.js
// this file will be merge with CallApi.js and the cache will be lost.
// So we have to store values in global scope.
global.wazoClients = global.wazoClients || {};
global.wazoClientId = global.wazoClientId || {};
global.wazoClientToken = global.wazoClientToken || {};
global.wazoRefreshToken = global.wazoRefreshToken || {};
global.wazoRefreshTenantId = global.wazoRefreshTenantId || {};
global.wazoRefreshDomainName = global.wazoRefreshDomainName || {};
global.wazoOnRefreshToken = global.wazoOnRefreshToken || {};
global.wazoOnRefreshTokenError = global.wazoOnRefreshTokenError || {};
global.wazoRefreshExpiration = global.wazoRefreshExpiration || {};
global.wazoRefreshBackend = global.wazoRefreshBackend || {};
global.wazoIsMobile = global.wazoIsMobile || {};
global.wazoFetchOptions = global.wazoFetchOptions || {};

const setApiClientId = (clientId        , forServer          = null) => {
  global.wazoClientId[forServer] = clientId;
};

const setCurrentServer = (newServer        ) => {
  global.wazoCurrentServer = newServer;
};

const setApiToken = (newToken         , forServer          = null) => {
  global.wazoClientToken[forServer] = newToken;
};

const setRefreshToken = (newRefreshToken         , forServer          = null) => {
  global.wazoRefreshToken[forServer] = newRefreshToken;
};

const setRefreshTenantId = (refreshTenantId         , forServer          = null) => {
  console.warn('Use of `setRefreshTenantId` is deprecated, please use `setRefreshDomainName` instead');
  global.wazoRefreshTenantId[forServer] = refreshTenantId;
};

const setRefreshDomainName = (refreshDomainName         , forServer          = null) => {
  global.wazoRefreshDomainName[forServer] = refreshDomainName;
};

const setOnRefreshToken = (onRefreshToken          , forServer          = null) => {
  global.wazoOnRefreshToken[forServer] = onRefreshToken;
};

const setOnRefreshTokenError = (callback          , forServer          = null) => {
  global.wazoOnRefreshTokenError[forServer] = callback;
};

const setRefreshExpiration = (refreshExpiration        , forServer          = null) => {
  global.wazoRefreshExpiration[forServer] = refreshExpiration;
};

const setFetchOptions = (fetchOptions        , forServer          = null) => {
  global.wazoFetchOptions[forServer] = fetchOptions;
};

const fillClient = (apiClient               ) => {
  const { server, token, clientId } = apiClient.client;
  const tenantId = global.wazoRefreshTenantId[server] || global.wazoRefreshTenantId[null] || apiClient.refreshTenantId;

  //  try with null server when dealing with non-related server info
  apiClient.setToken(global.wazoClientToken[server] || global.wazoClientToken[null] || token);

  apiClient.setClientId(global.wazoClientId[server] || global.wazoClientId[null] || clientId);

  apiClient.setRefreshToken(global.wazoRefreshToken[server] || global.wazoRefreshToken[null] || apiClient.refreshToken);

  if (tenantId) {
    apiClient.setRefreshTenantId(tenantId);
  }

  apiClient.setRefreshDomainName(
    global.wazoRefreshDomainName[server] || global.wazoRefreshDomainName[null] || apiClient.refreshDomainName,
  );

  apiClient.setFetchOptions(global.wazoFetchOptions[server] || global.wazoFetchOptions[null] || apiClient.fetchOptions);

  apiClient.setOnRefreshToken(
    global.wazoOnRefreshToken[server] || global.wazoOnRefreshToken[null] || apiClient.onRefreshToken,
  );

  apiClient.setOnRefreshTokenError(
    global.wazoOnRefreshTokenError[server] || global.wazoOnRefreshTokenError[null] || apiClient.onRefreshTokenError,
  );

  apiClient.setRefreshExpiration(
    global.wazoRefreshExpiration[server] || global.wazoRefreshExpiration[null] || apiClient.refreshExpiration,
  );

  apiClient.setRefreshBackend(
    global.wazoRefreshBackend[server] || global.wazoRefreshBackend[null] || apiClient.refreshBackend,
  );

  apiClient.setIsMobile(global.wazoIsMobile[server] || global.wazoIsMobile[null] || apiClient.isMobile);

  return apiClient;
};

var getApiClient = (forServer          = null)                => {
  const server         = forServer || global.wazoCurrentServer || '';
  if (server in global.wazoClients) {
    return fillClient(global.wazoClients[server]);
  }

  global.wazoClients[server] = new ApiClient({ server });

  return fillClient(global.wazoClients[server]);
};

//      

class InvalidSubscription extends Error {}
class InvalidAuthorization extends Error {}
class NoTenantIdError extends Error {}
class NoDomainNameError extends Error {}

const logger$9 = IssueReporter$1.loggerFor('simple-auth');

class Auth {
                   
                     
                               
                             
                
                    
                                    
                                         
                         
                  
                       
                       

  constructor() {
    this.expiration = DETAULT_EXPIRATION;
    this.authenticated = false;
    this.minSubscriptionType = null;
    this.BACKEND_WAZO = DEFAULT_BACKEND_USER;
    this.BACKEND_LDAP = BACKEND_LDAP_USER;
  }

  init(clientId        ,
    expiration        ,
    minSubscriptionType         ,
    authorizationName         ,
    mobile         ) {
    this.clientId = clientId;
    this.expiration = expiration;
    this.minSubscriptionType = typeof minSubscriptionType === 'undefined' ? null : minSubscriptionType;
    this.authorizationName = authorizationName;
    this.host = null;
    this.session = null;
    this.mobile = mobile || false;

    setApiClientId(this.clientId);
    setRefreshExpiration(this.expiration);
    setOnRefreshToken((token        , session         ) => {
      logger$9.info('on refresh token done', { token });
      setApiToken(token);
      Wazo.Websocket.updateToken(token);

      if (this.onRefreshTokenCallback) {
        this.onRefreshTokenCallback(token, session);
      }
    });

    setOnRefreshTokenError(error => {
      logger$9.error('on refresh token error', error);

      if (this.onRefreshTokenCallbackError) {
        this.onRefreshTokenCallbackError(error);
      }
    });
  }

  setFetchOptions(options        ) {
    setFetchOptions(options);
  }

  async logIn(username        , password        , backend         , extra                  ) {
    let tenantId = null;
    let domainName = null;
    if (typeof extra === 'string') {
      tenantId = extra;
    }
    if (extra && typeof extra === 'object') {
      domainName = extra.domainName;
    }

    if (backend && backend !== this.BACKEND_WAZO && !tenantId && !domainName) {
      if (!tenantId) {
        throw new NoTenantIdError('No tenant id');
      }

      if (!domainName) {
        throw new NoDomainNameError('No domain name');
      }
    }

    this.authenticated = false;
    this.session = null;
    const rawSession = await getApiClient().auth.logIn({
      username,
      password,
      backend,
      tenantId,
      domainName,
      expiration: this.expiration,
      mobile: this.mobile,
    });

    if (backend) {
      getApiClient().setRefreshBackend(backend);
    }

    if (tenantId) {
      getApiClient().setRefreshTenantId(tenantId);
    }

    if (domainName) {
      getApiClient().setRefreshDomainName(domainName);
    }

    return this._onAuthenticated(rawSession);
  }

  async logInViaRefreshToken(refreshToken        ) {
    const rawSession = await getApiClient().auth.refreshToken(refreshToken, null, this.expiration, this.mobile);
    return this._onAuthenticated(rawSession);
  }

  async validateToken(token        , refreshToken        ) {
    if (!token) {
      return null;
    }

    if (refreshToken) {
      setRefreshToken(refreshToken);
    }

    // Check if the token is valid
    try {
      const rawSession = await getApiClient().auth.authenticate(token);
      return this._onAuthenticated(rawSession);
    } catch (e) {
      logger$9.error('on validate token error', e);
      console.warn(e);
      return false;
    }
  }

  async generateNewToken(refreshToken        ) {
    return getApiClient().auth.refreshToken(refreshToken, null, this.expiration);
  }

  async logout(deleteRefreshToken          = true) {
    try {
      Wazo.Websocket.close(true);

      if (this.clientId && deleteRefreshToken) {
        await getApiClient().auth.deleteRefreshToken(this.clientId);
      }
    } catch (e) {
      // Nothing to
    }

    try {
      await getApiClient().auth.logOut(this.session ? this.session.token : null);
    } catch (e) {
      // Nothing to
    }

    setApiToken(null);
    setRefreshToken(null);

    this.session = null;
    this.authenticated = false;
  }

  setOnRefreshToken(callback          ) {
    this.onRefreshTokenCallback = callback;
  }

  setOnRefreshTokenError(callback          ) {
    this.onRefreshTokenCallbackError = callback;
  }

  checkAuthorizations(session         , authorizationName         ) {
    if (!authorizationName) {
      return;
    }
    const { authorizations } = session;
    if (!authorizations.find(authorization => authorization.rules.find(rule => rule.name === authorizationName))) {
      throw new InvalidAuthorization(`No authorization '${authorizationName || ''}' found for your account.`);
    }
  }

  checkSubscription(session         , minSubscriptionType        ) {
    const userSubscriptionType = session.profile ? session.profile.subscriptionType : null;
    if (userSubscriptionType === null || +userSubscriptionType <= minSubscriptionType) {
      const message = `Invalid subscription ${userSubscriptionType || 'n/a'}, required at least ${minSubscriptionType}`;
      throw new InvalidSubscription(message);
    }
  }

  setHost(host        ) {
    this.host = host;

    setCurrentServer(host);
  }

  setApiToken(token        ) {
    setApiToken(token);
  }

  setRefreshToken(refreshToken        ) {
    setRefreshToken(refreshToken);
  }

  setRefreshTenantId(refreshTenantId        ) {
    console.warn('Use of `setRefreshTenantId` is deprecated, use `setRefreshDomainName` instead.');
    setRefreshTenantId(refreshTenantId);

    getApiClient().setRefreshTenantId(refreshTenantId);
  }

  setRefreshDomainName(domainName        ) {
    setRefreshDomainName(domainName);

    getApiClient().setRefreshDomainName(domainName);
  }

  forceRefreshToken() {
    getApiClient().forceRefreshToken();
  }

  setIsMobile(mobile         ) {
    this.mobile = mobile;
  }

  getHost() {
    return this.host;
  }

  getSession() {
    return this.session;
  }

  getFirstName()         {
    if (!this.session || !this.session.profile) {
      return '';
    }
    return this.session.profile.firstName;
  }

  getLastName()         {
    if (!this.session || !this.session.profile) {
      return '';
    }

    return this.session.profile.lastName;
  }

  setClientId(clientId        ) {
    this.clientId = clientId;

    setApiClientId(this.clientId);
  }

  getName() {
    return `${this.getFirstName()} ${this.getLastName()}`;
  }

  async _onAuthenticated(rawSession         ) {
    if (this.authenticated && this.session) {
      return this.session;
    }
    const session = rawSession;
    if (!session) {
      return null;
    }

    setApiToken(session.token);
    if (session.refreshToken) {
      setRefreshToken(session.refreshToken);
    }

    try {
      const [profile, { wazo_version: engineVersion }] = await Promise.all([
        getApiClient().confd.getUser(session.uuid),
        getApiClient().confd.getInfos(),
      ]);

      session.engineVersion = engineVersion;
      session.profile = profile;

      this.checkAuthorizations(session, this.authorizationName);
      if (this.minSubscriptionType !== null) {
        this.checkSubscription(session, +this.minSubscriptionType);
      }
    } catch (e) {
      // Destroy tokens when validation fails
      if (this.clientId) {
        await getApiClient().auth.deleteRefreshToken(this.clientId);
      }
      if (session) {
        await getApiClient().auth.logOut(session.token);
      }

      throw e;
    }

    try {
      const sipLines = await getApiClient().confd.getUserLinesSip(
        session.uuid,
        // $FlowFixMe
        session.profile.lines.map(line => line.id),
      );

      // $FlowFixMe
      session.profile.sipLines = sipLines.filter(line => !!line);
    } catch (e) {
      // When an user has only a sccp line, getSipLines return a 404
    }

    this.authenticated = true;

    Wazo.Websocket.open(this.host, session);

    this.session = session;

    return session;
  }
}

if (!global.wazoAuthInstance) {
  global.wazoAuthInstance = new Auth();
}

var Auth$1 = global.wazoAuthInstance;

//      

                                     
                 
                  
                         
                           
             
                    
                   
                 
                    
  

                                      
                                      
                
  

                                   
                     
                    
                     
                                        
                    
                       
                         
                  
                   
  

// API adhoc conference
class AdHocAPIConference {
                     

                    

                                        

                   

                    

                       

                      

                 

                  

  constructor({
    phone,
    host,
    participants,
    started,
    finished,
    answerTime,
    conferenceId,
    muted,
    paused,
  }                     ) {
    this.phone = phone;
    this.host = host;
    this.participants = participants || {};
    this.started = started || false;
    this.finished = finished || false;
    this.answerTime = answerTime;
    this.conferenceId = conferenceId || '';
    this.muted = muted || false;
    this.paused = paused || false;

    if (this.host) {
      this.host.setIsConference(true);
    }
  }

  async start() {
    this.started = true;
    // $FlowFixMe
    this.answerTime = Object.values(this.participants).length ? Object.values(this.participants)[0].answerTime : null;

    const participantIds = Object.keys(this.participants);
    const conference = await getApiClient().calld.createAdHocConference(this.host.callId, participantIds);

    this.conferenceId = conference.conference_id;

    return this;
  }

  getParticipants() {
    return Object.values(this.participants);
  }

  async addParticipant(newParticipant             )                              {
    const participantCallId = newParticipant.getTalkingToIds()[0];
    const participants = { ...this.participants, [participantCallId]: newParticipant };

    await getApiClient().calld.addAdHocConferenceParticipant(this.conferenceId, participantCallId);

    return new AdHocAPIConference({
      ...this,
      participants,
    });
  }

  participantHasLeft(leaver             )                     {
    delete this.participants[leaver.getId()];

    return new AdHocAPIConference({ ...this, participants: this.participants });
  }

  hasParticipants() {
    return Object.keys(this.participants).length > 0;
  }

  mute()                     {
    this.muted = true;
    this.phone.mute(this.host);
    return new AdHocAPIConference({
      ...this,
    });
  }

  unmute()                     {
    this.muted = false;
    this.phone.unmute(this.host);
    return new AdHocAPIConference({
      ...this,
    });
  }

  hold()                     {
    this.paused = true;
    this.phone.hold(this.host);
    return new AdHocAPIConference({
      ...this,
    });
  }

  resume()                     {
    this.paused = false;
    this.phone.resume(this.host);
    return new AdHocAPIConference({
      ...this,
    });
  }

  isOnHold()          {
    return this.paused;
  }

  isMuted()          {
    return this.muted;
  }

  async hangup()                              {
    await getApiClient().calld.deleteAdHocConference(this.conferenceId);

    return new AdHocAPIConference({
      ...this,
      finished: true,
      participant: [],
    });
  }

  async removeParticipant(participantToRemove             ) {
    const callId = participantToRemove.getTalkingToIds()[0];
    delete this.participants[callId];

    await getApiClient().calld.removeAdHocConferenceParticipant(this.conferenceId, callId);

    return new AdHocAPIConference({
      ...this,
      participants: this.participants,
    });
  }
}

/*       */

const parseCandidate$1 = (candidate         )          => {
  if (!candidate) {
    return null;
  }
  const result = sdpParser__default['default'].parse(candidate.indexOf('a=') === 0 ? candidate : `a=${candidate}`);

  return result.candidates ? result.candidates[0] : null;
};

const getSrflxOrRelay = (candidates          )           =>
  candidates
    .filter(candidate => candidate && (candidate.type === 'srflx' || candidate.type === 'relay'));

const getVideoDirection = (sdp        )          => {
  const parsedSdp = sdpParser__default['default'].parse(sdp);
  const videoMedia = parsedSdp.media.find(media => media.type === 'video');
  if (!videoMedia) {
    return null;
  }

  return videoMedia.direction;
};

const hasAnActiveVideo = (sdp         )          => {
  if (!sdp) {
    return false;
  }

  const parsedSdp = sdpParser__default['default'].parse(sdp);

  return !!parsedSdp.media.find(media =>
    media.type === 'video' && media.port > 10 && (!media.direction || media.direction !== 'inactive'));
};

const fixSdp = (sdp        , candidates          , forcePort          = true)         => {
  const parsedSdp = sdpParser__default['default'].parse(sdp);
  const mainCandidate = getSrflxOrRelay(candidates)[0];
  const ip = mainCandidate ? mainCandidate.ip : null;

  if (ip) {
    parsedSdp.origin.address = ip;
  }

  parsedSdp.media = parsedSdp.media.map(media => {
    const port = forcePort ? (mainCandidate ? mainCandidate.port : media.port) : media.port;
    return {
      ...media,
      port,
      candidates: (media.candidates || []).concat(candidates),
      direction: port < 10 ? 'inactive' : media.direction,
    };
  });

  let fixed = sdpParser__default['default'].write(parsedSdp);

  if (ip) {
    fixed = fixed.replace(/IN IP4 0.0.0.0/g, `IN IP4 ${ip}`);
  }

  return fixed;
};

const addIcesInAllBundles = (sdp        ) => {
  const parsedSdp = sdpParser__default['default'].parse(sdp);

  const mediaWithCandidate = parsedSdp.media.find(media => !!media.candidates);
  if (!mediaWithCandidate) {
    return sdp;
  }

  const { candidates } = mediaWithCandidate;

  parsedSdp.media = parsedSdp.media.map(media => ({
    ...media,
    candidates: media.candidates || candidates,
  }));

  return sdpParser__default['default'].write(parsedSdp);
};

/* global RTCSessionDescriptionInit, navigator */

const wazoLogger = IssueReporter$1 ? IssueReporter$1.loggerFor('webrtc-sdh') : console;

// Customized mediaStreamFactory allowing to send screensharing stream directory when upgrading
const wazoMediaStreamFactory = (constraints        )                       => {
  // @see sip.js/lib/platform/web/session-description-handler/media-stream-factory-default
  if (!constraints.audio && !constraints.video) {
    return Promise.resolve(new MediaStream());
  }

  if (navigator.mediaDevices === undefined) {
    return Promise.reject(new Error('Media devices not available in insecure contexts.'));
  }

  // We have to make a `getUserMedia` on desktop but a `getDisplayMedia` in browsers when screensharing
  if (constraints.screen && !constraints.desktop) {
    return navigator.mediaDevices.getDisplayMedia.call(navigator.mediaDevices, constraints);
  }

  return navigator.mediaDevices.getUserMedia.call(navigator.mediaDevices, constraints);
};

class WazoSessionDescriptionHandler extends sessionDescriptionHandler.SessionDescriptionHandler {
                                     

  constructor(
    logger        ,
    mediaStreamFactory                    ,
    sessionDescriptionHandlerConfiguration                                         ,
    isWeb         ,
    session         ,
  ) {
    super(logger, mediaStreamFactory, sessionDescriptionHandlerConfiguration);

    this.eventEmitter = new EventEmitter__default['default']();
    this.isWeb = isWeb;
    this.session = session;
  }

  on(event        , callback          ) {
    this.eventEmitter.on(event, callback);
  }

  off(event        , callback          ) {
    this.eventEmitter.removeListener(event, callback);
  }

  // $FlowFixMe
  setRemoteSessionDescription(sessionDescription                           )                {
    try {
      const result = super.setRemoteSessionDescription(sessionDescription);

      this.eventEmitter.emit('setDescription', sessionDescription);

      return result;
    } catch (error) {
      this.logger.error('SessionDescriptionHandler.setRemoteSessionDescription error', error);
      throw error;
    }
  }

  // Overridden to avoid to fix ice-candidates missing in the SDP in react-native and chrome canary.
  getDescription(options          = {}, modifiers                  )               {
    this.logger.debug('SessionDescriptionHandler.getDescription');
    if (this._peerConnection === undefined) {
      return Promise.reject(new Error('Peer connection closed.'));
    }
    // Callback on data channel creation
    this.onDataChannel = options.onDataChannel;

    // ICE will restart upon applying an offer created with the iceRestart option
    const iceRestart = options.offerOptions ? options.offerOptions.iceRestart : false;

    const isConference = options ? !!options.conference : false;
    const audioOnly = options ? !!options.audioOnly : false;

    // We should wait for ice when iceRestart (reinvite) or for the first invite
    // We shouldn't wait for ice when holding or resuming the call
    // We shouldn't wait for ice when receiving a reinvite (eg: pendingReinviteAck = true)
    const shouldWaitForIce = !this.session.pendingReinviteAck && (iceRestart || ('constraints' in options));

    // ICE gathering timeout may be set on a per call basis, otherwise the configured default is used
    const iceTimeout = options.iceGatheringTimeout === undefined
      ? this.sessionDescriptionHandlerConfiguration.iceGatheringTimeout
      : options.iceGatheringTimeout;

    wazoLogger.trace('getting SDP description', { iceRestart, shouldWaitForIce, iceTimeout });

    // Fetch ice ourselves for re-invite
    this.gatheredCandidates = [];
    if (!this.peerConnectionDelegate) {
      this.peerConnectionDelegate = {};
    }
    this.peerConnectionDelegate.onicecandidate = event => {
      wazoLogger.trace('onicecandidate', event.candidate ? event.candidate.candidate : { done: true });
      if (event.candidate) {
        this.gatheredCandidates.push(parseCandidate$1(event.candidate.candidate));

        // When receiving a `srflx` or a `relay` candidate, consider the negotiation done.
        if (event.candidate.candidate.indexOf('srflx') !== -1 || event.candidate.candidate.indexOf('relay') !== -1) {
          wazoLogger.info('A valid ice was found, triggering ice gathering complete callback.', {
            ice: event.candidate.candidate,
          });
          this.iceGatheringComplete();
        }
      }
    };

    return this.getLocalMediaStream(options)
      .then(() => this.updateDirection(options, isConference, audioOnly))
      .then(() => this.createDataChannel(options))
      .then(() => {
        if (isConference && (options.constraints && !options.constraints.video) && !('hold' in options) && !audioOnly) {
          // Add a video an empty bundle to be able to replaceTrack when joining a conference without video
          if (this.peerConnection.addTransceiver) {
            this.peerConnection.addTransceiver('video', { streams: [this._localMediaStream], direction: 'sendrecv' });
          }
        }
      })
      .then(() => this.createLocalOfferOrAnswer(options))
      .then(sessionDescription => this.setLocalSessionDescription(sessionDescription))
      .then(() => this.waitForIceGatheringComplete(iceRestart, iceTimeout))
      .then(() => this.getLocalSessionDescription())
      .then(description => {
        const { sdp } = description;

        // Check if we got ICEs
        if (sdp.indexOf('a=candidate') !== -1) {
          return {
            type: description.type,
            sdp: addIcesInAllBundles(sdp),
          };
        }

        wazoLogger.info('No ICE candidates found in SDP, fixing it with gathered ices', this.gatheredCandidates);

        // @TODO: find a better way to set sdp in answer.
        //  We can't call createAnswer again, so we have to put candidates manually with fixSdp
        // In reinvite, createOffer doesn't update the SDP
        return {
          type: description.type,
          // Fix sdp only when no candidates
          sdp: fixSdp(sdp, this.gatheredCandidates, options && options.constraints ? options.constraints.video : false),
        };
      })
      .then((sessionDescription) => this.applyModifiers(sessionDescription, modifiers))
      .then((sessionDescription) => ({ body: sessionDescription.sdp, contentType: 'application/sdp' }))
      .catch((error) => {
        wazoLogger.error('error when creating media', error);
        this.logger.error(`SessionDescriptionHandler.getDescription failed - ${error}`);
        throw error;
      });
  }

  // Overridden to avoid to use peerConnection.getReceivers and peerConnection.getSenders in react-native
  sendDtmf(tones        , options                                             = {})          {
    if (this.isWeb) {
      return super.sendDtmf(tones, options);
    }

    this.logger.debug(`DTMF sent via INFO: ${tones.toString()}`);

    const body = {
      contentDisposition: 'render',
      contentType: 'application/dtmf-relay',
      content: `Signal=${tones}\r\nDuration=${options.duration || 1000}`,
    };
    const requestOptions = { body };

    return this.session.info({ requestOptions });
  }

  // Overridden to avoid to use peerConnection.getReceivers and peerConnection.getSenders in react-native
  close()       {
    wazoLogger.info('closing sdh');

    if (this.isWeb) {
      return super.close();
    }

    // react-native
    this.logger.debug('SessionDescriptionHandler.close');
    if (this._peerConnection === undefined) {
      return;
    }

    // Closing senders via getLocalStreams
    this.peerConnection.getLocalStreams().forEach(stream => {
      stream.getTracks().forEach((track) => {
        track.stop();
      });
    });

    // Closing receivers via getRemoteStreams
    this.peerConnection.getRemoteStreams().forEach(stream => {
      stream.getTracks().forEach(track => {
        track.stop();
      });
    });

    if (this._dataChannel) {
      this._dataChannel.close();
    }
    this._peerConnection.close();
    this._peerConnection = undefined;
  }

  // Overridden to send `inactive` in conference
  updateDirection(options                                   , isConference          = false,
    audioOnly          = false)                {
    if (this._peerConnection === undefined) {
      return Promise.reject(new Error('Peer connection closed.'));
    }

    // Waiting for `getTransceivers` API on mobile
    if (!this.isWeb) {
      return Promise.resolve();
    }

    switch (this._peerConnection.signalingState) {
      case 'stable': {
        // if we are stable, assume we are creating a local offer
        this.logger.debug('SessionDescriptionHandler.updateDirection - setting offer direction');
        // determine the direction to offer given the current direction and hold state
        const directionToOffer = (currentDirection        , transceiver         /* RTCRtpTransceiver */)         => {
          if (isConference) {
            if (audioOnly && transceiver.receiver.track && transceiver.receiver.track.kind === 'video') {
              return 'sendonly';
            }
            return options && options.hold ? 'sendonly' : 'sendrecv';
          }

          switch (currentDirection) {
            case 'inactive':
              return options && options.hold ? 'inactive' : (isConference && !audioOnly ? 'sendrecv' : 'recvonly');
            case 'recvonly':
              return options && options.hold ? 'inactive' : 'recvonly';
            case 'sendonly':
              return options && options.hold ? 'sendonly' : 'sendrecv';
            case 'sendrecv':
              return options && options.hold ? 'sendonly' : 'sendrecv';
            case 'stopped':
              return 'stopped';
            default:
              throw new Error('Should never happen');
          }
        };
        // set the transceiver direction to the offer direction
        this._peerConnection.getTransceivers().forEach((transceiver) => {
          if (transceiver.direction /* guarding, but should always be true */) {
            const offerDirection = directionToOffer(transceiver.direction, transceiver);
            if (transceiver.direction !== offerDirection) {
              // eslint-disable-next-line no-param-reassign
              transceiver.direction = offerDirection;
            }
          }
        });
      }
        break;
      case 'have-remote-offer': {
        // if we have a remote offer, assume we are creating a local answer
        this.logger.debug('SessionDescriptionHandler.updateDirection - setting answer direction');

        // FIXME: This is not the correct way to determine the answer direction as it is only
        // considering first match in the offered SDP and using that to determine the answer direction.
        // While that may be fine for our current use cases, it is not a generally correct approach.
        // determine the offered direction
        const offeredDirection = (()                                                    => {
          const description = this._peerConnection.remoteDescription;
          if (!description) {
            throw new Error('Failed to read remote offer');
          }
          const searchResult = /a=sendrecv\r\n|a=sendonly\r\n|a=recvonly\r\n|a=inactive\r\n/.exec(description.sdp);
          if (searchResult) {
            switch (searchResult[0]) {
              case 'a=inactive\r\n':
                return 'inactive';
              case 'a=recvonly\r\n':
                return 'recvonly';
              case 'a=sendonly\r\n':
                return 'sendonly';
              case 'a=sendrecv\r\n':
                return 'sendrecv';
              default:
                throw new Error('Should never happen');
            }
          }
          return 'sendrecv';
        })();

        // determine the answer direction based on the offered direction and our hold state
        const answerDirection = (()                                                    => {
          switch (offeredDirection) {
            case 'inactive':
              return 'inactive';
            case 'recvonly':
              return 'sendonly';
            case 'sendonly':
              return options && options.hold ? 'inactive' : 'recvonly';
            case 'sendrecv':
              return options && options.hold ? 'sendonly' : 'sendrecv';
            default:
              throw new Error('Should never happen');
          }
        })();

        // set the transceiver direction to the answer direction
        this._peerConnection.getTransceivers().forEach((transceiver) => {
          if (transceiver.stopped) {
            return;
          }
          if (transceiver.direction /* guarding, but should always be true */) {
            const { receiver } = transceiver;
            if (isConference && audioOnly && receiver.track && receiver.track.kind === 'video') {
              // eslint-disable-next-line no-param-reassign
              transceiver.direction = 'inactive';
              return;
            }

            if (transceiver.direction !== 'stopped' && transceiver.direction !== answerDirection) {
              // eslint-disable-next-line no-param-reassign
              transceiver.direction = answerDirection;
            }
          }
        });
      }
        break;
      case 'have-local-offer':
      case 'have-local-pranswer':
      case 'have-remote-pranswer':
      case 'closed':
      default:
        return Promise.reject(new Error(`Invalid signaling state ${this._peerConnection.signalingState}`));
    }
    return Promise.resolve();
  }

  // Overridden to not reuse video track in SFU mode
  setLocalMediaStream(stream             ) {
    this.logger.debug('SessionDescriptionHandler.setLocalMediaStream');

    if (!this._peerConnection) {
      throw new Error('Peer connection undefined.');
    }
    const pc = this._peerConnection;
    const { sfu } = pc;
    const localStream = this._localMediaStream;

    const trackUpdates                       = [];

    const updateTrack = (newTrack                  )       => {
      const { kind } = newTrack;
      if (kind !== 'audio' && kind !== 'video') {
        throw new Error(`Unknown new track kind ${kind}.`);
      }
      const sender = pc.getSenders && pc.getSenders().find((otherSender) =>
        otherSender.track && otherSender.track.kind === kind);

      // Do not reuse sender video tracks in SFU
      if (sender && (!sfu || newTrack.kind === 'audio')) {
        if (sender.track) {
          // eslint-disable-next-line no-param-reassign
          newTrack.enabled = sender.track.enabled;
        }
        trackUpdates.push(
          new Promise((resolve) => {
            this.logger.debug(`SessionDescriptionHandler.setLocalMediaStream - replacing sender ${kind} track`);
            resolve();
          }).then(() =>
            sender
              .replaceTrack(newTrack)
              .then(() => {
                const oldTrack = localStream.getTracks().find((localTrack) => localTrack.kind === kind);
                if (oldTrack) {
                  oldTrack.stop();
                  localStream.removeTrack(oldTrack);
                  sessionDescriptionHandler.SessionDescriptionHandler.dispatchRemoveTrackEvent(localStream, oldTrack);
                }
                localStream.addTrack(newTrack);
                sessionDescriptionHandler.SessionDescriptionHandler.dispatchAddTrackEvent(localStream, newTrack);
              })
              .catch((error       ) => {
                this.logger.error(
                  `SessionDescriptionHandler.setLocalMediaStream - failed to replace sender ${kind} track`,
                );
                throw error;
              })),
        );
      } else {
        trackUpdates.push(
          new Promise((resolve) => {
            this.logger.debug(`SessionDescriptionHandler.setLocalMediaStream - adding sender ${kind} track`);
            resolve();
          }).then(() => {
            // Review: could make streamless tracks a configurable option?
            // https://developer.mozilla.org/en-US/docs/Web/API/RTCPeerConnection/addTrack#Usage_notes
            try {
              if (pc.addTrack) {
                pc.addTrack(newTrack, localStream);
              } else {
                pc.addStream(localStream);
              }
            } catch (error) {
              this.logger.error(`SessionDescriptionHandler.setLocalMediaStream - failed to add sender ${kind} track`);
              throw error;
            }
            localStream.addTrack(newTrack);
            sessionDescriptionHandler.SessionDescriptionHandler.dispatchAddTrackEvent(localStream, newTrack);
          }),
        );
      }
    };

    // update peer connection audio tracks
    const audioTracks = stream.getAudioTracks();
    if (audioTracks.length) {
      updateTrack(audioTracks[0]);
    }

    // update peer connection video tracks
    const videoTracks = stream.getVideoTracks();
    if (videoTracks.length) {
      updateTrack(videoTracks[0]);
    }

    return trackUpdates.reduce((p, x) => p.then(() => x), Promise.resolve());
  }

  // Overridden to avoid replacing constraints with `localMediaStreamConstraints`
  getLocalMediaStream(options        ) {
    this.logger.debug('WazoSessionDescriptionHandler.getLocalMediaStream');
    if (this._peerConnection === undefined) {
      return Promise.reject(new Error('Peer connection closed.'));
    }
    let constraints = options.constraints ? { ...options.constraints } : {};
    // if we already have a local media stream...
    if (this.localMediaStreamConstraints) {
      // if constraints have not changed, do not get a new media stream
      if (JSON.stringify(this.localMediaStreamConstraints.audio) === JSON.stringify(constraints.audio)
        && JSON.stringify(this.localMediaStreamConstraints.video) === JSON.stringify(constraints.video)) {
        return Promise.resolve();
      }
    } else if (constraints.audio === undefined && constraints.video === undefined) {
      // if no constraints have been specified, default to audio for initial media stream
      constraints = { audio: true };
    }
    this.localMediaStreamConstraints = constraints;
    return this.mediaStreamFactory(constraints, this).then((mediaStream) => this.setLocalMediaStream(mediaStream));
  }
}

//      

const DEFAULT_HEARTBEAT_DELAY = 2000;
const DEFAULT_HEARTBEAT_TIMEOUT = 5000;
const DEFAULT_MAX_HEARTBEATS = 3;

class Heartbeat {
                         
                           
                        

                        
                                     
                                           
                          
                                    
                                

  constructor(heartbeatDelay         = DEFAULT_HEARTBEAT_DELAY, heartbeatTimeout         = DEFAULT_HEARTBEAT_TIMEOUT,
    maxHeartbeats         = DEFAULT_MAX_HEARTBEATS) {
    this.heartbeatDelay = heartbeatDelay;
    this.heartbeatTimeout = heartbeatTimeout;
    this.maxHeartbeats = maxHeartbeats;

    this.hasHeartbeat = false;
    this._heartbeatTries = 0;
  }

  setSendHeartbeat(cb          ) {
    this._sendHeartbeatCallback = cb;
  }

  setOnHeartbeatTimeout(cb          ) {
    this._onTimeoutCallback = cb;
  }

  stop() {
    this.hasHeartbeat = false;

    if (this._heartbeatNotReceivedTimeout) {
      clearTimeout(this._heartbeatNotReceivedTimeout);
    }
    if (this._heartbeatDelayTimeout) {
      clearTimeout(this._heartbeatDelayTimeout);
    }
  }

  start() {
    this.stop();
    this.hasHeartbeat = true;
    this._heartbeatTries = 0;
    this._sendHeartbeat();
  }

  onHeartbeat() {
    this._clearTimeouts();

    if (!this.hasHeartbeat) {
      return;
    }

    this._sendHeartbeat();
  }

  _sendHeartbeat() {
    if (this._heartbeatTries >= this.maxHeartbeats) {
      return;
    }

    this._clearTimeouts();

    this._heartbeatDelayTimeout = setTimeout(() => {
      this._heartbeatTries++;

      if (this._sendHeartbeatCallback) {
        this._sendHeartbeatCallback();
      }
    }, this.heartbeatDelay);

    if (this._onTimeoutCallback) {
      this._heartbeatNotReceivedTimeout = setTimeout(this._onTimeoutCallback, this.heartbeatTimeout);
    }
  }

  _clearTimeouts() {
    if (this._heartbeatNotReceivedTimeout) {
      clearTimeout(this._heartbeatNotReceivedTimeout);
    }

    if (this._heartbeatDelayTimeout) {
      clearTimeout(this._heartbeatDelayTimeout);
    }
  }
}

//      
const lastIndexOf = (array       , method          )         => {
  const start = array.length - 1;

  for (let i = start; i >= 0; i--) {
    if (method(array[i])) {
      return i;
    }
  }
  return -1;
};

//      

// We need to replace 0.0.0.0 to 127.0.0.1 in the sdp to avoid MOH during a createOffer.
const replaceLocalIpModifier = (description        ) => Promise.resolve({
  // description is immutable... so we have to clone it or the `type` attribute won't be returned.
  ...JSON.parse(JSON.stringify(description)),
  sdp: description.sdp.replace('c=IN IP4 0.0.0.0', 'c=IN IP4 127.0.0.1'),
});

const DEFAULT_ICE_TIMEOUT = 3000;
const SEND_STATS_DELAY = 5000;

const states = ['STATUS_NULL', 'STATUS_NEW', 'STATUS_CONNECTING', 'STATUS_CONNECTED', 'STATUS_COMPLETED'];
const logger$8 = IssueReporter$1 ? IssueReporter$1.loggerFor('webrtc-client') : console;
const statsLogger = IssueReporter$1 ? IssueReporter$1.loggerFor('webrtc-stats') : console;

// events
const REGISTERED = 'registered';
const UNREGISTERED = 'unregistered';
const REGISTRATION_FAILED = 'registrationFailed';
const INVITE = 'invite';
const CONNECTED = 'connected';
const DISCONNECTED = 'disconnected';
const TRANSPORT_ERROR = 'transportError';
const MESSAGE = 'message';
const ACCEPTED = 'accepted';
const REJECTED = 'rejected';
const ON_TRACK$1 = 'onTrack';
const ON_EARLY_MEDIA$1 = 'onEarlyMedia';
const ON_REINVITE$1 = 'reinvite';
const ON_ERROR = 'onError';
const ON_SCREEN_SHARING_REINVITE = 'onScreenSharingReinvite';
const ON_NETWORK_STATS$1 = 'onNetworkStats';
const ON_DISCONNECTED$1 = 'onDisconnected';

const events$1 = [REGISTERED, UNREGISTERED, REGISTRATION_FAILED, INVITE];
const transportEvents = [CONNECTED, DISCONNECTED, TRANSPORT_ERROR, MESSAGE];
class CanceledCallError extends Error {}

const MAX_REGISTER_TRIES = 5;

                    
                          
                          
                                
  

                     
                      
               
                
                         
                             
                    
              
                     
                              
               
                               
                             
                           
                         
                           
                        
                        
  

// @see https://github.com/onsip/SIP.js/blob/master/src/Web/Simple.js
class WebRTCClient extends Emitter {
                       
                             
                       
                         
                    
                          
                                                
                          
                       
                               
                            
                       
                                    
                              
                       
                                
                         
                         
                                     
                                     
                        
                                                      
                                            
                       

  // sugar
                        
                     
                       
                              
                 
                    
                       
                          
                  
                   
                   
                   
                      
                   
                                     
                           
                         
                          

  static isAPrivateIp(ip        )          {
    const regex = /^(?:10|127|172\.(?:1[6-9]|2[0-9]|3[01])|192\.168)\..*/;
    return regex.exec(ip) == null;
  }

  static getIceServers(ip        )                                 {
    if (WebRTCClient.isAPrivateIp(ip)) {
      return [
        {
          urls: ['stun:stun.l.google.com:19302', 'stun:stun4.l.google.com:19302'],
        },
      ];
    }
    return [];
  }

  constructor(config              , session          , uaConfigOverrides         ) {
    super();
    this.uaConfigOverrides = uaConfigOverrides;
    this.config = config;
    this.skipRegister = config.skipRegister;

    this._buildConfig(config, session).then((newConfig              ) => {
      this.config = newConfig;
      this.userAgent = this.createUserAgent(uaConfigOverrides);
    });

    this.audioOutputDeviceId = config.audioOutputDeviceId;
    this.audioOutputVolume = config.audioOutputVolume || 1;

    if (config.media) {
      this.configureMedia(config.media);
      this.setMediaConstraints({ audio: config.media.audio, video: config.media.video });
    }

    this.heldSessions = {};
    this.statsIntervals = {};
    this.connectionPromise = null;
    this.sipSessions = {};
    this.conferences = {};
    this.networkMonitoringInterval = {};
    this.sessionNetworkStats = {};
    this.forceClosed = false;

    this._boundOnHeartbeat = this._onHeartbeat.bind(this);
    this.heartbeat = new Heartbeat(config.heartbeatDelay, config.heartbeatTimeout, config.maxHeartbeats);
    this.heartbeat.setSendHeartbeat(this.pingServer.bind(this));
    this.heartbeat.setOnHeartbeatTimeout(this._onHeartbeatTimeout.bind(this));

    // sugar
    this.REGISTERED = REGISTERED;
    this.UNREGISTERED = UNREGISTERED;
    this.REGISTRATION_FAILED = REGISTRATION_FAILED;
    this.INVITE = INVITE;
    this.CONNECTED = CONNECTED;
    this.DISCONNECTED = DISCONNECTED;
    this.TRANSPORT_ERROR = TRANSPORT_ERROR;
    this.MESSAGE = MESSAGE;
    this.ACCEPTED = ACCEPTED;
    this.REJECTED = REJECTED;
    this.ON_TRACK = ON_TRACK$1;
    this.ON_REINVITE = ON_REINVITE$1;
    this.ON_ERROR = ON_ERROR;
    this.ON_SCREEN_SHARING_REINVITE = ON_SCREEN_SHARING_REINVITE;
    this.ON_NETWORK_STATS = ON_NETWORK_STATS$1;
    this.ON_DISCONNECTED = ON_DISCONNECTED$1;
    this.ON_EARLY_MEDIA = ON_EARLY_MEDIA$1;
  }

  configureMedia(media             ) {
    this.hasAudio = !!media.audio;
    this.audioStreams = {};
    this.audioElements = {};
  }

  setMediaConstraints(media                        ) {
    this.video = media.video;
    this.audio = media.audio;
  }

  createUserAgent(configOverrides         )            {
    const webRTCConfiguration = this._createWebRTCConfiguration(configOverrides);
    logger$8.info('sdk webrtc, creating UA', { webRTCConfiguration });

    webRTCConfiguration.delegate = {
      onConnect: this.onConnect.bind(this),
      onDisconnect: this.onDisconnect.bind(this),
      onInvite: (invitation            ) => {
        logger$8.info('sdk webrtc on invite', {
          method: 'delegate.onInvite',
          id: invitation.id,
          remoteURI: invitation.remoteURI,
        });
        this._setupSession(invitation);
        const shouldAutoAnswer = !!invitation.request.getHeader('alert-info');

        this.eventEmitter.emit(INVITE, invitation, this.sessionWantsToDoVideo(invitation), shouldAutoAnswer);
      },
    };

    const ua = new userAgent.UserAgent(webRTCConfiguration);
    if (ua.transport && ua.transport.connectPromise) {
      ua.transport.connectPromise.catch((e => {
        logger$8.warn('Transport connect error', e);
      }));
    }

    ua.transport.onMessage = (rawMessage        ) => {
      const message = parser.Parser.parseMessage(rawMessage, ua.transport.logger);

      // We have to re-sent the message to the UA ...
      ua.onTransportMessage(rawMessage);
      // And now do what we want with the message
      this.eventEmitter.emit(MESSAGE, message);

      if (message && message.method === constants.C.MESSAGE) {
        // We have to manually reply to MESSAGE with a 200 OK or Asterisk will hangup.
        ua.userAgentCore.replyStateless(message, { statusCode: 200 });
      }
    };

    return ua;
  }

  isConnected()          {
    return this.userAgent && this.userAgent.isConnected();
  }

  isConnecting()          {
    return this.userAgent && this.userAgent.transport && this.userAgent.transport.state === transportState.TransportState.Connecting;
  }

  isRegistered()          {
    return this.registerer && this.registerer.state === registererState.RegistererState.Registered;
  }

  onConnect() {
    logger$8.info('sdk webrtc connected', { method: 'delegate.onConnect' });
    this.eventEmitter.emit(CONNECTED);
    if (!this.isRegistered() && this.registerer && this.registerer.waiting) {
      this.registerer.waitingToggle(false);
    }
    return this.register();
  }

  async onDisconnect(error        ) {
    logger$8.info('sdk webrtc disconnected', { method: 'delegate.onConnect', error });
    this.connectionPromise = null;
    // The UA will attempt to reconnect automatically when an error occurred
    this.eventEmitter.emit(DISCONNECTED, error);
    if (this.isRegistered()) {
      await this.unregister();
      if (this.registerer && this.registerer.waiting) {
        this.registerer.waitingToggle(false);
      }
      this.eventEmitter.emit(UNREGISTERED);
    }
  }

  register(tries         = 0)               {
    const logInfo = {
      userAgent: !!this.userAgent,
      registered: this.isRegistered(),
      connectionPromise: !!this.connectionPromise,
      registerer: !!this.registerer,
      waiting: this.registerer && this.registerer.waiting,
      tries,
      skipRegister: this.skipRegister,
    };

    this.forceClosed = false;

    if (this.skipRegister) {
      logger$8.info('sdk webrtc skip register...', logInfo);
      return Promise.resolve();
    }

    logger$8.info('sdk webrtc registering...', logInfo);

    if (!this.userAgent) {
      logger$8.info('sdk webrtc recreating User Agent');
      this.userAgent = this.createUserAgent(this.uaConfigOverrides);
    }
    if (!this.userAgent || this.isRegistered()) {
      logger$8.info('sdk webrtc registering aborted, already registered or no UA can be created');
      return Promise.resolve();
    }

    if (this.connectionPromise || (this.registerer && this.registerer.waiting)) {
      logger$8.info('sdk webrtc registering aborted due to a registration in progress.');
      return Promise.resolve();
    }

    const registerOptions = this._isWeb() ? {} : { extraContactHeaderParams: ['mobility=mobile'] };

    const onRegisterFailed = () => {
      logger$8.info('sdk webrtc registering failed', {
        tries,
        registerer: !!this.registerer,
        forceClosed: this.forceClosed,
      });
      if (this.forceClosed) {
        return;
      }

      this.connectionPromise = null;
      if (this.registerer && this.registerer.waiting) {
        this.registerer.waitingToggle(false);
      }

      if (tries <= MAX_REGISTER_TRIES) {
        logger$8.info('sdk webrtc registering, retrying...', { tries });
        setTimeout(() => this.register(tries + 1), 300);
      }
    };

    return this._connectIfNeeded().then(() => {
      // Avoid race condition with the close method called just before register and setting userAgent to null
      // during the resolution of the primise.
      if (!this.userAgent) {
        logger$8.info('sdk webrtc recreating User Agent after connection');
        this.userAgent = this.createUserAgent(this.uaConfigOverrides);
      }

      logger$8.info('sdk webrtc registering, transport connected', { registerOptions, ua: !!this.userAgent });
      this.registerer = new registerer.Registerer(this.userAgent, registerOptions);
      this.connectionPromise = null;
      this._monkeyPatchRegisterer(this.registerer);

      // Bind registerer events
      this.registerer.stateChange.addListener(newState => {
        logger$8.info('sdk webrtc registering, state changed', { newState });

        if (newState === registererState.RegistererState.Registered && this.registerer
          && this.registerer.state === registererState.RegistererState.Registered) {
          this.eventEmitter.emit(REGISTERED);
        } else if (newState === registererState.RegistererState.Unregistered) {
          this.eventEmitter.emit(UNREGISTERED);
        }
      });

      const options = {
        requestDelegate: {
          onReject: response => {
            logger$8.error('sdk webrtc registering, rejected', { response });

            onRegisterFailed();
          },
        },
      };

      return this.registerer.register(options).catch((e) => {
        logger$8.error('sdk webrtc registering, error', e);

        this.eventEmitter.emit(REGISTRATION_FAILED);
        return e;
      });
    }).catch(error => {
      logger$8.error('sdk webrtc registering, transport error', error);
      onRegisterFailed();
    });
  }

  // Monkey patching sip.js to avoid issues during register.onReject
  _monkeyPatchRegisterer(registerer             ) {
    if (!registerer) {
      return;
    }
    const oldWaitingToggle = registerer.waitingToggle.bind(registerer);
    const oldUnregistered = registerer.unregistered.bind(registerer);

    registerer.waitingToggle = (waiting         ) => {
      if (!registerer || registerer.waiting === waiting) {
        return;
      }
      oldWaitingToggle(waiting);
    };

    registerer.unregistered = () => {
      if (!registerer || registerer.state === registererState.RegistererState.Terminated) {
        return;
      }
      oldUnregistered();
    };
  }

  unregister() {
    logger$8.info('sdk webrtc unregistering..', { userAgent: !!this.userAgent, registerer: !!this.registerer });
    if (!this.registerer) {
      return Promise.resolve();
    }

    try {
      return this.registerer.unregister().then(() => {
        logger$8.info('sdk webrtc unregistered');
        this._cleanupRegister();
      }).catch(e => {
        logger$8.error('sdk webrtc unregistering, promise error', e);
        this._cleanupRegister();
      });
    } catch (e) {
      logger$8.error('sdk webrtc unregistering, error', e);
      // Avoid issue with `undefined is not an object (evaluating 'new.target.prototype')` when triggering a new
      // error when the registerer is in a bad state
      this._cleanupRegister();
    }
  }

  stop()               {
    logger$8.info('sdk webrtc stop', { userAgent: !!this.userAgent });
    if (!this.userAgent) {
      return Promise.resolve();
    }

    return this.userAgent.stop().then(() => {
      return this._cleanupRegister();
    }).catch(e => {
      logger$8.warn('sdk webrtc stop, error', { message: e.message, stack: e.stack });
    });
  }

  call(number        , enableVideo          , audioOnly          = false, conference          = false)          {
    logger$8.info('sdk webrtc creating call', { number, enableVideo, audioOnly, conference });
    const inviterOptions         = {
      sessionDescriptionHandlerOptionsReInvite: {
        conference,
        audioOnly,
      },
      earlyMedia: true,
    };

    if (audioOnly) {
      inviterOptions.sessionDescriptionHandlerModifiersReInvite = [modifiers.stripVideo];
    }

    const session = new inviter.Inviter(this.userAgent, this._makeURI(number), inviterOptions);

    this.storeSipSession(session);

    this._setupSession(session);

    if (conference) {
      this.conferences[this.getSipSessionId(session)] = true;
    }

    const inviteOptions                       = {
      requestDelegate: {
        onAccept: (response                  ) => {
          if (session.sessionDescriptionHandler.peerConnection) {
            session.sessionDescriptionHandler.peerConnection.sfu = conference;
          }
          this._onAccepted(session, response.session, true);
        },
        onProgress: (payload) => {
          if (payload.message.statusCode === 183) {
            this._onEarlyProgress(payload.session);
          }
        },
        onReject: (response                  ) => {
          logger$8.info('on call rejected', { id: session.id, fromTag: session.fromTag });
          this._stopSendingStats(session);
          this.stopNetworkMonitoring(session);

          this.eventEmitter.emit(REJECTED, session, response);
        },
      },
      sessionDescriptionHandlerOptions: this.getMediaConfiguration(enableVideo || false, conference),
    };

    inviteOptions.sessionDescriptionHandlerOptions.audioOnly = audioOnly;

    inviteOptions.sessionDescriptionHandlerModifiers = [replaceLocalIpModifier];
    if (audioOnly) {
      inviteOptions.sessionDescriptionHandlerModifiers.push(modifiers.stripVideo);
    }

    // Do not await invite here or we'll miss the Establishing state transition
    session.invitePromise = session.invite(inviteOptions);
    return session;
  }

  answer(session            , enableVideo          ) {
    logger$8.info('sdk webrtc answer call', { id: session.id, enableVideo });

    if (!session || !session.accept) {
      const error = 'No session to answer, or not an invitation';
      logger$8.warn(error);
      return Promise.reject(new Error(error));
    }
    const options = {
      sessionDescriptionHandlerOptions: this.getMediaConfiguration(enableVideo || false),
    };

    return session.accept(options).then(() => {
      if (session.isCanceled) {
        const message = 'accepted a canceled session (or was canceled during the accept phase).';
        logger$8.error(message, { id: session.id });
        this.onCallEnded(session);

        throw new CanceledCallError(message);
      }
      logger$8.info('sdk webrtc answer, accepted.');
      this._onAccepted(session);
    }).catch(e => {
      logger$8.error(`answer call error for ${session ? session.id : 'n/a'}`, e);

      throw e;
    });
  }

  hangup(session         ) {
    const { state, id } = session;
    logger$8.info('sdk webrtc hangup call', { id, state });

    try {
      this._stopSendingStats(session);

      this._cleanupMedia(session);

      delete this.sipSessions[this.getSipSessionId(session)];

      // Check if Invitation or Inviter (Invitation = incoming call)
      const isInviter = session instanceof inviter.Inviter;
      const cancel = () => session.cancel();
      const reject = () => session.reject();
      const bye = () => session.bye && session.bye();

      // @see github.com/onsip/SIP.js/blob/f11dfd584bc9788ccfc94e03034020672b738975/src/platform/web/simple-user/simple-user.ts#L1004
      const actions = {
        [sessionState.SessionState.Initial]: isInviter ? cancel : reject,
        [sessionState.SessionState.Establishing]: isInviter ? cancel : reject,
        [sessionState.SessionState.Established]: bye,
      };

      // Handle different session status
      if (actions[state]) {
        return actions[state]();
      }

      return bye();
    } catch (error) {
      logger$8.warn('sdk webrtc hangup, error', error);
    }

    return null;
  }

  async getStats(session         )          {
    const pc = session.sessionDescriptionHandler.peerConnection;
    if (!pc) {
      return null;
    }

    return pc.getStats(null);
  }

  // Fetch and emit an event at `interval` with session network stats
  startNetworkMonitoring(session         , interval         = 1000)          {
    const sessionId = this.getSipSessionId(session);
    logger$8.info('starting network inspection', { id: sessionId });

    this.sessionNetworkStats[sessionId] = [];

    this.networkMonitoringInterval[sessionId] = setInterval(() => this._fetchNetworkStats(sessionId), interval);
  }

  stopNetworkMonitoring(session         )          {
    const sessionId = this.getSipSessionId(session);
    const exists = sessionId in this.networkMonitoringInterval;
    logger$8.info('stopping network inspection', { id: sessionId, exists });

    if (exists) {
      clearInterval(this.networkMonitoringInterval[sessionId]);
      delete this.networkMonitoringInterval[sessionId];
      delete this.sessionNetworkStats[sessionId];
    }
  }

  reject(session         ) {
    logger$8.info('sdk webrtc reject call', { id: session.id });

    try {
      return session.reject ? session.reject() : session.cancel();
    } catch (e) {
      logger$8.warn('Error when rejecting call', e.message, e.stack);
    }
  }

  async close(force          = false) {
    logger$8.info('sdk webrtc closing client', { userAgent: !!this.userAgent, force });
    this.forceClosed = force;
    this._cleanupMedia();
    this.connectionPromise = null;

    (Object.values(this.audioElements)     ).forEach((audioElement                  ) => {
      // eslint-disable-next-line
      audioElement.srcObject = null;
      audioElement.pause();
    });

    this.audioElements = {};
    if (!this.userAgent) {
      return null;
    }

    this.stopHeartbeat();
    this.userAgent.delegate = null;
    this.userAgent.stateChange.removeAllListeners();

    await this._disconnectTransport(force);

    this._cleanupRegister();

    try {
      // Don't wait here, It can take ~30s to stop ...
      this.userAgent.stop().catch(console.error);
    } catch (_) {
      // Avoid to raise exception when trying to close with hanged-up sessions remaining
      // eg: "INVITE not rejectable in state Completed"
    }
    this.userAgent = null;
    logger$8.info('sdk webrtc client closed');
  }

  getNumber(session         )          {
    if (!session) {
      return null;
    }

    // eslint-disable-next-line
    return session.remoteIdentity.uri._normal.user;
  }

  mute(session         ) {
    logger$8.info('sdk webrtc mute', { id: session.id });

    this._toggleAudio(session, true);
  }

  unmute(session         ) {
    logger$8.info('sdk webrtc unmute', { id: session.id });

    this._toggleAudio(session, false);
  }

  isAudioMuted(session         )          {
    if (!session || !session.sessionDescriptionHandler) {
      return false;
    }

    let muted = true;
    const pc = session.sessionDescriptionHandler.peerConnection;
    if (!pc) {
      return false;
    }

    if (pc.getSenders) {
      if (!pc.getSenders().length) {
        return false;
      }
      pc.getSenders().forEach(sender => {
        if (sender && sender.track && sender.track.kind === 'audio') {
          muted = muted && !sender.track.enabled;
        }
      });
    } else {
      if (!pc.getLocalStreams().length) {
        return false;
      }
      pc.getLocalStreams().forEach(stream => {
        stream.getAudioTracks().forEach(track => {
          muted = muted && !track.enabled;
        });
      });
    }

    return muted;
  }

  toggleCameraOn(session         ) {
    logger$8.info('sdk webrtc toggle camera on', { id: session.id });

    this._toggleVideo(session, false);
  }

  toggleCameraOff(session         ) {
    logger$8.info('sdk webrtc toggle camera off', { id: session.id });

    this._toggleVideo(session, true);
  }

  hold(session         , isConference          = false, hadVideo          = false) {
    const sessionId = this.getSipSessionId(session);
    const hasVideo = hadVideo || this.hasLocalVideo(sessionId);

    logger$8.info('sdk webrtc hold', {
      sessionId,
      keys: Object.keys(this.heldSessions),
      pendingReinvite: !!session.pendingReinvite,
      isConference,
      hasVideo,
    });

    if (sessionId in this.heldSessions) {
      return Promise.resolve();
    }
    if (session.pendingReinvite) {
      return Promise.resolve();
    }
    this.heldSessions[sessionId] = {
      hasVideo,
      isConference,
    };

    if (isConference) {
      this.mute(session);
    }

    session.sessionDescriptionHandlerOptionsReInvite = {
      hold: true,
      conference: isConference,
    };

    const options = this.getMediaConfiguration(false, isConference);
    if (!this._isWeb()) {
      options.sessionDescriptionHandlerModifiers = [modifiers.holdModifier];
    }
    options.sessionDescriptionHandlerOptions = {
      constraints: options.constraints,
      hold: true,
      conference: isConference,
    };

    // Avoid sdh to create a new stream
    if (session.sessionDescriptionHandler) {
      session.sessionDescriptionHandler.localMediaStreamConstraints = options.constraints;
    }

    // Send re-INVITE
    return session.invite(options);
  }

  unhold(session         , isConference          = false) {
    const sessionId = this.getSipSessionId(session);
    const hasVideo = sessionId in this.heldSessions && this.heldSessions[sessionId].hasVideo;

    logger$8.info('sdk webrtc unhold', {
      sessionId,
      keys: Object.keys(this.heldSessions),
      pendingReinvite: !!session.pendingReinvite,
      isConference,
      hasVideo,
    });

    if (session.pendingReinvite) {
      return Promise.resolve();
    }

    if (isConference) {
      this.unmute(session);
    }

    delete this.heldSessions[this.getSipSessionId(session)];
    session.sessionDescriptionHandlerOptionsReInvite = {
      hold: false,
      conference: isConference,
    };

    const options = this.getMediaConfiguration(false, isConference);
    if (!this._isWeb()) {
      // We should sent an empty `sessionDescriptionHandlerModifiers` or sip.js will take the last sent modifiers
      // (eg: holdModifier)
      options.sessionDescriptionHandlerModifiers = [];
    }
    options.sessionDescriptionHandlerOptions = {
      constraints: options.constraints,
      hold: false,
      conference: isConference,
    };

    // Send re-INVITE
    return session.invite(options);
  }

  // Returns true if a re-INVITE is required
  async upgradeToVideo(session         , constraints         , isConference         )                   {
    const pc = session.sessionDescriptionHandler.peerConnection;

    // Check if a video sender already exists
    let videoSender;
    if (isConference) {
      // We search for the last transceiver without `video-` in the mid (video- means remote transceiver)
      const transceivers = pc.getTransceivers();
      const transceiverIdx = lastIndexOf(transceivers, transceiver =>
        transceiver.sender.track === null && transceiver.mid && transceiver.mid.indexOf('video') === -1);

      videoSender = transceiverIdx !== -1 ? transceivers[transceiverIdx].sender : null;
    } else {
      videoSender = pc && pc.getSenders && pc.getSenders().find(sender => sender.track === null);
    }

    if (!videoSender) {
      // When no video sender found, it means that we're in the first video upgrade in 1:1
      return null;
    }

    // Reuse bidirectional video stream
    const newStream = await this.getStreamFromConstraints(constraints);
    if (!newStream) {
      console.warn(`Can't create media stream with: ${JSON.stringify(constraints || {})}`);
      return false;
    }

    // Add previous local audio track
    if (constraints && !constraints.audio) {
      const localVideoStream = session.sessionDescriptionHandler.localMediaStream;
      const localAudioTrack = localVideoStream.getTracks().find(track => track.kind === 'audio');
      if (localAudioTrack) {
        newStream.addTrack(localAudioTrack);
      }
    }

    const videoTrack = newStream.getVideoTracks()[0];
    if (videoTrack) {
      videoSender.replaceTrack(videoTrack);
    }

    this.setLocalMediaStream(this.getSipSessionId(session), newStream);

    return newStream;
  }

  downgradeToAudio(session         ) {
    // Release local video stream when downgrading to audio
    const localStream = session.sessionDescriptionHandler.localMediaStream;
    const pc = session.sessionDescriptionHandler.peerConnection;
    const videoTracks = localStream.getVideoTracks();

    // Remove video senders
    if (pc.getSenders) {
      pc.getSenders().filter(sender => sender.track && sender.track.kind === 'video').forEach(videoSender => {
        videoSender.replaceTrack(null);
      });
    }

    videoTracks.forEach(videoTrack => {
      videoTrack.enabled = false;
      videoTrack.stop();
      localStream.removeTrack(videoTrack);
    });
  }

  async getStreamFromConstraints(constraints        , conference          = false)                        {
    const video = constraints && constraints.video;
    // $FlowFixMe
    const { constraints: newConstraints } = this.getMediaConfiguration(video, conference, constraints);

    let newStream;
    try {
      newStream = await wazoMediaStreamFactory(newConstraints);
    } catch (e) {
      // Nothing to do when the user cancel the screensharing prompt
    }
    if (!newStream) {
      return null;
    }
    // $FlowFixMe
    newStream.local = true;

    return newStream;
  }

  getHeldSession(sessionId        ) {
    return this.heldSessions[sessionId];
  }

  isCallHeld(session         ) {
    return this.getSipSessionId(session) in this.heldSessions;
  }

  isVideoRemotelyHeld(sessionId        ) {
    const pc = this.getPeerConnection(sessionId);
    const sdp = pc && pc.remoteDescription ? pc.remoteDescription.sdp : null;
    if (!sdp) {
      return false;
    }

    const videoDirection = getVideoDirection(sdp);

    return videoDirection === 'sendonly';
  }

  sendDTMF(session         , tone        ) {
    if (!session.sessionDescriptionHandler) {
      return;
    }
    logger$8.info('Sending DTMF', {
      id: this.getSipSessionId(session),
      tone,
    });
    return session.sessionDescriptionHandler.sendDtmf(tone);
  }

  message(destination        , message        ) {
    const messager$1 = new messager.Messager(this.userAgent, this._makeURI(destination), message);

    return messager$1.message();
  }

  transfer(session         , target        ) {
    this.hold(session);

    logger$8.info('Transfering a session', {
      id: this.getSipSessionId(session),
      target,
    });

    const options = {
      requestDelegate: {
        onAccept: () => {
          this.hangup(session);
        },
      },
    };

    setTimeout(() => {
      session.refer(this._makeURI(target), options);
    }, 50);
  }

  // check https://sipjs.com/api/0.12.0/refer/referClientContext/
  atxfer(session         ) {
    this.hold(session);

    logger$8.info('webrtc transfer started', { id: this.getSipSessionId(session) });

    const result         = {
      newSession: null,
      init: async (target        ) => {
        logger$8.info('webrtc transfer initialized', { id: this.getSipSessionId(session), target });

        result.newSession = await this.call(target);
      },
      complete: () => {
        logger$8.info('webrtc transfer completed', {
          id: this.getSipSessionId(session),
          referId: this.getSipSessionId(result.newSession),
        });

        session.refer(result.newSession);
      },
      cancel: () => {
        this.hangup(result.newSession);
        this.unhold(session);
      },
    };

    return result;
  }

  sendMessage(sipSession          = null, body        , contentType         = 'text/plain') {
    if (!sipSession) {
      return;
    }

    logger$8.info('send WebRTC message', { sipId: sipSession.id, contentType });

    try {
      sipSession.message({
        requestOptions: {
          body: {
            content: body,
            contentType,
          },
        },
      });
    } catch (e) {
      console.warn(e);
    }
  }

  pingServer() {
    if (!this.isConnected()) {
      return;
    }

    const core = this.userAgent.userAgentCore;
    const fromURI = this._makeURI(this.config.authorizationUser || '');
    const toURI = new uri.URI('sip', '', this.config.host);
    const message = core.makeOutgoingRequestMessage('OPTIONS', toURI, fromURI, toURI, {});

    return core.request(message);
  }

  getState() {
    return this.userAgent ? states[this.userAgent.state] : userAgentState.UserAgentState.Stopped;
  }

  getContactIdentifier() {
    return this.userAgent ? `${this.userAgent.configuration.contactName}/${this.userAgent.contact.uri}` : null;
  }

  isFirefox()          {
    return this._isWeb() && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }

  changeAudioOutputVolume(volume        ) {
    logger$8.info('Changing audio output volume', { volume });

    Object.values(this.audioElements).forEach(audioElement => {
      if (audioElement instanceof HTMLAudioElement) {
        // eslint-disable-next-line no-param-reassign
        audioElement.volume = volume;
      }
    });
    this.audioOutputVolume = volume;
  }

  changeAudioOutputDevice(id        ) {
    logger$8.info('Changing audio output device', { id });
    this.audioOutputDeviceId = id;

    Object.values(this.audioElements).forEach(audioElement => {
      // `setSinkId` method is not included in any flow type definitions for HTMLAudioElements but is a valid method
      // audioElement is an array of HTMLAudioElements, and HTMLAudioElement inherits the method from HTMLMediaElement
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement
      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId

      // $FlowFixMe
      if (audioElement.setSinkId) {
        audioElement.setSinkId(id);
      }
    });
  }

  async changeAudioInputDevice(id        , session          , force          ) {
    const currentId = this.getAudioDeviceId();
    logger$8.info('setting audio input device', { id, currentId, session: !!session });

    if (!force && id === currentId) {
      return null;
    }

    // in order to handle an audio track change for default devices
    // we need the actual id of the device (not 'default')
    let deviceId = id;
    if (id === 'default' && navigator.mediaDevices) {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const defaultDevice = devices.find(device => device.deviceId === 'default');
      if (defaultDevice) {
        const deviceLabel = defaultDevice.label.replace('Default - ', '');
        const targetDevice = devices.find(device => device.label === deviceLabel);
        if (targetDevice) {
          deviceId = targetDevice.deviceId;
          if (!force && deviceId === currentId) {
            return null;
          }
        }
      }
    }

    // let's update the local audio value
    if (this.audio) {
      this.audio = {
        deviceId: {
          exact: deviceId,
        },
      };
    }

    if (session && navigator.mediaDevices) {
      const sdh = session.sessionDescriptionHandler;
      const pc = sdh.peerConnection;

      const constraints = { audio: { deviceId: { exact: deviceId } } };
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      const audioTrack = stream.getAudioTracks()[0];
      const sender = pc && pc.getSenders
        && pc.getSenders().find(s => audioTrack && s && s.track && s.track.kind === audioTrack.kind);

      if (sender) {
        if (sender.track) {
          audioTrack.enabled = sender.track.enabled;
        }
        sender.replaceTrack(audioTrack);
      }

      return stream;
    }
  }

  changeVideoInputDevice(id         , session          ) {
    this.setVideoInputDevice(id);

    if (session) {
      return this.changeSessionVideoInputDevice(id, session);
    }
  }

  setVideoInputDevice(id         ) {
    const currentId = this.getVideoDeviceId();
    logger$8.info('setting video input device', { id, currentId });

    if (id === currentId) {
      return null;
    }

    // let's make sure we don't lose other video constraints settings -- width, height, frameRate...
    const videoObject = typeof this.video === 'object' ? this.video : {};
    this.video = {
      ...videoObject,
      deviceId: {
        exact: id,
      },
    };
  }

  changeSessionVideoInputDevice(id         , session         ) {
    if (!this.sessionWantsToDoVideo(session)) {
      return;
    }
    const sdh = session.sessionDescriptionHandler;
    const pc = sdh.peerConnection;
    const sessionId = this.getSipSessionId(session);
    const localStream = this.getLocalStream(sessionId);

    logger$8.info('changing video input device', { id, sessionId });

    // Release old video stream
    if (localStream) {
      localStream.getVideoTracks().forEach(track => {
        track.stop();
      });
    }

    const constraints = {
      video: id ? { deviceId: { exact: id } } : true,
    };
    // $FlowFixMe
    return navigator.mediaDevices.getUserMedia(constraints).then(async stream => {
      const videoTrack = stream.getVideoTracks()[0];
      let sender = pc && pc.getSenders
        && pc.getSenders().find(s => videoTrack && s && s.track && s.track.kind === videoTrack.kind);
      let wasTrackEnabled = false;
      if (!sender) {
        sender = pc && pc.getSenders && pc.getSenders().find(s => !s.track);
      }

      if (sender) {
        // No video track means video not enabled
        wasTrackEnabled = sender.track ? sender.track.enabled : false;
        videoTrack.enabled = wasTrackEnabled;

        if (!wasTrackEnabled) {
          videoTrack.stop();
        }

        sender.replaceTrack(wasTrackEnabled ? videoTrack : null);
      }

      // let's update the local stream
      this.eventEmitter.emit('onVideoInputChange', stream);
      this.setLocalMediaStream(sessionId, stream);

      return stream;
    });
  }

  getAudioDeviceId()          {
    // $FlowFixMe
    return this.audio && typeof this.audio === 'object' && 'deviceId' in this.audio
      ? this.audio.deviceId.exact : undefined;
  }

  getVideoDeviceId()          {
    // $FlowFixMe
    return this.video && typeof this.video === 'object' && 'deviceId' in this.video
      ? this.video.deviceId.exact : undefined;
  }

  reinvite(sipSession         , newConstraints          = null, conference          = false,
    audioOnly          = false, iceRestart          = false) {
    if (!sipSession) {
      return false;
    }

    if (sipSession.pendingReinvite) {
      return false;
    }

    const wasMuted = this.isAudioMuted(sipSession);
    const shouldDoVideo = newConstraints ? newConstraints.video : this.sessionWantsToDoVideo(sipSession);
    const shouldDoScreenSharing = newConstraints && newConstraints.screen;
    const desktop = newConstraints && newConstraints.desktop;

    logger$8.info('Sending reinvite', {
      id: this.getSipSessionId(sipSession),
      newConstraints,
      conference,
      audioOnly,
      wasMuted,
      shouldDoVideo,
      shouldDoScreenSharing,
      desktop,
    });

    // When upgrading to video, remove the `stripVideo` modifiers
    if (newConstraints && newConstraints.video) {
      const modifiers$1 = sipSession.sessionDescriptionHandlerModifiersReInvite;
      sipSession.sessionDescriptionHandlerModifiersReInvite = modifiers$1.filter(modifier =>
        modifier !== modifiers.stripVideo);
    }

    sipSession.sessionDescriptionHandlerOptionsReInvite = {
      ...sipSession.sessionDescriptionHandlerOptionsReInvite,
      conference,
      audioOnly,
    };

    // $FlowFixMe
    const { constraints } = this.getMediaConfiguration(shouldDoVideo, conference, newConstraints);

    return sipSession.invite({
      requestDelegate: {
        onAccept: (response                  ) => {
          // Update the SDP body to be able to call sessionWantsToDoVideo correctly in `_setup[Local|Remote]Media`.
          // Can't set directly sipSession.body because it's a getter.
          if (sipSession instanceof inviter.Inviter) {
            sipSession.outgoingRequestMessage.body.body = response.message.body;
          } else {
            sipSession.incomingInviteRequest.message.body = response.message.body;
          }

          logger$8.info('on re-INVITE accepted', {
            id: this.getSipSessionId(sipSession),
            wasMuted,
            shouldDoScreenSharing,
          });

          this.updateRemoteStream(this.getSipSessionId(sipSession));

          if (wasMuted) {
            this.mute(sipSession);
          }

          this._onAccepted(sipSession, response.session, false);

          if (shouldDoScreenSharing) {
            this.eventEmitter.emit(ON_SCREEN_SHARING_REINVITE, sipSession, response, desktop);
          }

          return this.eventEmitter.emit(ON_REINVITE$1, sipSession, response);
        },
      },
      sessionDescriptionHandlerModifiers: [replaceLocalIpModifier],
      requestOptions: {
        extraHeaders: [`Subject: ${shouldDoScreenSharing ? 'screenshare' : 'upgrade-video'}`],
      },
      sessionDescriptionHandlerOptions: {
        constraints,
        conference,
        audioOnly,
        offerOptions: {
          iceRestart,
        },
      },
    });
  }

  async getUserMedia(constraints        ) {
    const newConstraints = {
      audio: this._getAudioConstraints(),
      video: this._getVideoConstraints(constraints.video),
    };

    // $FlowFixMe
    return navigator.mediaDevices.getUserMedia(newConstraints);
  }

  getPeerConnection(sessionId        ) {
    const sipSession = this.sipSessions[sessionId];
    if (!sipSession) {
      return null;
    }

    return sipSession.sessionDescriptionHandler ? sipSession.sessionDescriptionHandler.peerConnection : null;
  }

  // Local streams
  getLocalStream(sessionId        )               {
    const sipSession = this.sipSessions[sessionId];

    return sipSession && sipSession.sessionDescriptionHandler
      ? sipSession.sessionDescriptionHandler.localMediaStream : null;
  }

  getLocalTracks(sessionId        )                     {
    const localStream = this.getLocalStream(sessionId);
    if (!localStream) {
      return [];
    }

    return localStream.getTracks();
  }

  hasLocalVideo(sessionId        )          {
    return this.getLocalTracks(sessionId).some(this._isVideoTrack);
  }

  // Check if we have at least one video track, even muted or not live
  hasALocalVideoTrack(sessionId        )          {
    return this.getLocalTracks(sessionId).some(track => track.kind === 'video');
  }

  getLocalVideoStream(sessionId        )               {
    return this.hasLocalVideo(sessionId) ? this.getLocalStream(sessionId) : null;
  }

  // Remote streams
  getRemoteStream(sessionId        )               {
    const sipSession = this.sipSessions[sessionId];

    return sipSession && sipSession.sessionDescriptionHandler
      ? sipSession.sessionDescriptionHandler.remoteMediaStream : null;
  }

  getRemoteTracks(sessionId        )                     {
    const remoteStream = this.getRemoteStream(sessionId);
    if (!remoteStream) {
      return [];
    }

    return remoteStream.getTracks();
  }

  hasRemoteVideo(sessionId        )          {
    return this.getRemoteTracks(sessionId).some(this._isVideoTrack);
  }

  // Check if we have at least one video track, even muted or not live
  hasARemoteVideoTrack(sessionId        )          {
    return this.getRemoteTracks(sessionId).some(track => track.kind === 'video');
  }

  getRemoteVideoStream(sessionId        )               {
    if (this.isVideoRemotelyHeld(sessionId)) {
      return null;
    }

    return this.hasRemoteVideo(sessionId) ? this.getRemoteStream(sessionId) : null;
  }

  //  Useful in a react-native environment when remoteMediaStream is not updated
  getRemoteVideoStreamFromPc(sessionId        )               {
    const pc = this.getPeerConnection(sessionId);
    if (!pc) {
      return null;
    }

    return pc.getRemoteStreams().find(stream => !!stream.getVideoTracks().length);
  }

  hasVideo(sessionId        )          {
    return this.hasLocalVideo(sessionId) || this.hasRemoteVideo(sessionId);
  }

  hasAVideoTrack(sessionId        )          {
    return this.hasALocalVideoTrack(sessionId) || this.hasARemoteVideoTrack(sessionId);
  }

  getSipSessionId(sipSession          )         {
    if (!sipSession) {
      return '';
    }
    if (sipSession.message && sipSession.message.callId) {
      return sipSession.message.callId;
    }

    // For Inviter
    if (sipSession.outgoingRequestMessage) {
      return sipSession.outgoingRequestMessage.callId;
    }

    // For Invitation
    return (sipSession.id || '').substr(0, 36);
  }

  async waitForRegister() {
    return new Promise(resolve => this.on(REGISTERED, resolve));
  }

  // eslint-disable-next-line no-unused-vars
  sessionWantsToDoVideo(session         ) {
    if (!session) {
      return false;
    }
    const { body } = session.request || session;
    // Sometimes with InviteClientContext the body is in the body attribute ...
    const sdp = typeof body === 'object' && body ? body.body : body;

    return hasAnActiveVideo(sdp);
  }

  hasHeartbeat() {
    return this.heartbeat.hasHeartbeat;
  }

  startHeartbeat() {
    logger$8.info('sdk webrtc start heartbeat', { userAgent: !!this.userAgent });
    if (!this.userAgent) {
      this.heartbeat.stop();
      return;
    }

    this.eventEmitter.off(MESSAGE, this._boundOnHeartbeat);
    this.eventEmitter.on(MESSAGE, this._boundOnHeartbeat);

    this.heartbeat.start();
  }

  stopHeartbeat() {
    logger$8.info('sdk webrtc stop heartbeat');
    this.heartbeat.stop();
  }

  setOnHeartbeatTimeout(cb          ) {
    this.heartbeatTimeoutCb = cb;
  }

  setOnHeartbeatCallback(cb          ) {
    this.heartbeatCb = cb;
  }

  onCallEnded(session         ) {
    this._cleanupMedia(session);
    delete this.sipSessions[this.getSipSessionId(session)];

    this._stopSendingStats(session);
    this.stopNetworkMonitoring(session);
  }

  attemptReconnection()       {
    logger$8.info('attempt reconnection', { userAgent: !!this.userAgent });
    if (!this.userAgent) {
      return;
    }
    this.userAgent.attemptReconnection();
  }

  storeSipSession(session         ) {
    this.sipSessions[this.getSipSessionId(session)] = session;
  }

  getSipSession(id        )           {
    return id in this.sipSessions ? this.sipSessions[id] : null;
  }

  getSipSessionIds()           {
    return Object.keys(this.sipSessions);
  }

  setLocalMediaStream(sipSessionId        , newStream             ) {
    const sipSession = this.sipSessions[sipSessionId];
    if (!sipSession) {
      return;
    }

    logger$8.info('setting local media stream', {
      sipSessionId,
      tracks: newStream ? newStream.getTracks() : null,
    });

    // eslint-disable-next-line no-underscore-dangle
    sipSession.sessionDescriptionHandler._localMediaStream = newStream;
  }

  updateLocalStream(sipSessionId        , newStream             ) {
    const sipSession = this.sipSessions[sipSessionId];
    if (!sipSession) {
      return;
    }

    const oldStream = this.getLocalStream(sipSessionId);

    logger$8.info('updating local stream', {
      sipSessionId,
      oldStream: !!oldStream,
      tracks: newStream.getTracks(),
    });

    if (oldStream) {
      this._cleanupStream(oldStream);
    }

    this.setLocalMediaStream(sipSessionId, newStream);

    // Update the local video element
    this._setupMedias(sipSession, newStream);
  }

  updateRemoteStream(sessionId        ) {
    const remoteStream = this.getRemoteStream(sessionId);
    const pc = this.getPeerConnection(sessionId);

    logger$8.info('Updating remote stream', {
      sessionId,
      tracks: remoteStream ? remoteStream.getTracks() : null,
      receiverTracks: pc && pc.getReceivers ? pc.getReceivers().map(receiver => receiver.track) : null,
    });

    if (!pc || !remoteStream) {
      return;
    }

    remoteStream.getTracks().forEach(track => {
      remoteStream.removeTrack(track);
    });

    if (pc.getReceivers) {
      pc.getReceivers().forEach(receiver => {
        remoteStream.addTrack(receiver.track);
      });
    }
  }

  getMediaConfiguration(enableVideo         , conference          = false, constraints          = null)         {
    const screenSharing = constraints && 'screen' in constraints ? constraints.screen : false;
    const isDesktop = constraints && 'desktop' in constraints ? constraints.desktop : false;
    const withAudio = constraints && 'audio' in constraints ? constraints.audio : true;
    const mandatoryVideo = constraints && typeof constraints.video === 'object' ? constraints.video.mandatory : {};

    logger$8.info('Retrieving media a configuration', { enableVideo, screenSharing, isDesktop, withAudio, constraints });

    return {
      constraints: {
        // Exact constraint are not supported with `getDisplayMedia` and we must have a video=false in desktop screenshare
        audio: screenSharing ? !isDesktop : (withAudio ? this._getAudioConstraints() : false),
        video: screenSharing ? (isDesktop
          ? ({ mandatory: { chromeMediaSource: 'desktop', ...(mandatoryVideo || {}) } }) : { cursor: 'always' })
          : this._getVideoConstraints(enableVideo),
        screen: screenSharing,
        desktop: isDesktop,
        conference,
      },
      enableVideo,
      conference,
      offerOptions: {
        OfferToReceiveAudio: this._hasAudio(),
        OfferToReceiveVideo: enableVideo,
        mandatory: {
          OfferToReceiveAudio: this._hasAudio(),
          OfferToReceiveVideo: enableVideo,
        },
      },
    };
  }

  isConference(sessionId        ) {
    return sessionId in this.conferences;
  }

  createAudioElementFor(sessionId        ) {
    const audio      = document.createElement('audio');
    audio.setAttribute('id', `audio-${sessionId}`);

    if (audio.setSinkId && this.audioOutputDeviceId) {
      audio.setSinkId(this.audioOutputDeviceId);
    }

    if (document.body) {
      document.body.appendChild(audio);
    }
    this.audioElements[sessionId] = audio;

    audio.volume = this.audioOutputVolume;
    audio.autoplay = true;

    return audio;
  }

  _onTransportError() {
    logger$8.error('on transport error');
    this.eventEmitter.emit(TRANSPORT_ERROR);
    this.attemptReconnection();
  }

  _onHeartbeat(message                 ) {
    const body = message && typeof message === 'object' ? message.data : message;
    if (body && body.indexOf('200 OK') !== -1) {
      if (this.hasHeartbeat()) {
        logger$8.info('on heartbeat received from Asterisk', { hasHeartbeat: this.hasHeartbeat() });

        this.heartbeat.onHeartbeat();
        if (this.heartbeatCb) {
          this.heartbeatCb();
        }
      }
    }
  }

  async _onHeartbeatTimeout() {
    logger$8.warn('sdk webrtc heartbeat timed out', { userAgent: !!this.userAgent, cb: !!this.heartbeatTimeoutCb });

    if (this.heartbeatTimeoutCb) {
      this.heartbeatTimeoutCb();
    }

    if (this.userAgent && this.userAgent.transport) {
      // Disconnect from WS and triggers events, but do not trigger disconnect if already disconnecting...
      if (!this.userAgent.transport.transitioningState && !this.userAgent.transport.disconnectPromise) {
        try {
          await this.userAgent.transport.disconnect();
        } catch (e) {
          logger$8.error('Transport disconnection after heartbeat timeout, error', e);
        }
      }

      // We can invoke disconnect() with an error that can be catcher by `onDisconnect`, so we have to trigger it here.
      this._onTransportError();
    }
  }

  _isWeb() {
    return typeof window === 'object' && typeof document === 'object';
  }

  _isVideoTrack(track                  ) {
    return track.kind === 'video' && track.readyState === 'live';
  }

  _hasAudio() {
    return this.hasAudio;
  }

  _getAudioConstraints() {
    return this.audio && this.audio.deviceId && this.audio.deviceId.exact ? this.audio : true;
  }

  _getVideoConstraints(video          = false) {
    if (!video) {
      return false;
    }
    return this.video && this.video.deviceId && this.video.deviceId.exact ? this.video : true;
  }

  _connectIfNeeded()                {
    logger$8.info('connect if needed, checking', { connected: this.isConnected() });
    if (!this.userAgent) {
      logger$8.info('need to recreate User Agent');
      this.userAgent = this.createUserAgent(this.uaConfigOverrides);
    }

    if (this.isConnected()) {
      logger$8.info('webrtc sdk, already connected');
      return Promise.resolve();
    }

    if (this.isConnecting()) {
      logger$8.info('webrtc sdk, already connecting...');

      this.connectionPromise = this.userAgent.transport.connectPromise;
      return this.connectionPromise;
    }

    if (this.connectionPromise) {
      logger$8.info('webrtc sdk, connection promise connecting...');
      // $FlowFixMe
      return this.connectionPromise;
    }

    logger$8.info('WebRTC UA needs to connect');

    // Force UA to reconnect
    if (this.userAgent && this.userAgent.state !== userAgentState.UserAgentState.Stopped) {
      this.userAgent.transitionState(userAgentState.UserAgentState.Stopped);
    }
    if (this.userAgent.transport && this.userAgent.transport.state !== transportState.TransportState.Disconnected) {
      this.userAgent.transport.transitionState(transportState.TransportState.Disconnected);
    }
    this.connectionPromise = this.userAgent.start().catch(console.error);

    return this.connectionPromise;
  }

  _buildConfig(config              , session          )                        {
    // If no session provided, return the configuration directly
    if (!session) {
      return new Promise(resolve => resolve(config));
    }

    const client = new ApiClient({ server: config.host });
    client.setToken(session.token);
    client.setRefreshToken(session.refreshToken);

    return client.confd.getUserLineSipFromToken(session.uuid).then(sipLine => ({
      authorizationUser: sipLine.username,
      password: sipLine.secret,
      uri: `${sipLine.username}@${config.host}`,
      ...config,
    }));
  }

  _createWebRTCConfiguration(configOverrides         = {}) {
    let { host } = this.config;
    let port = this.config.port || 443;

    if (this.config.websocketSip) {
      [host, port = 443] = this.config.websocketSip.split(':');
    }

    const config         = {
      authorizationUsername: this.config.authorizationUser,
      authorizationPassword: this.config.password,
      displayName: this.config.displayName,
      autoStart: true,
      hackIpInContact: true,
      contactParams: {
        transport: 'wss',
      },
      logBuiltinEnabled: this.config.log ? this.config.log.builtinEnabled : null,
      logLevel: this.config.log ? this.config.log.logLevel : null,
      logConnector: this.config.log ? this.config.log.connector : null,
      uri: this._makeURI(this.config.authorizationUser || ''),
      userAgentString: this.config.userAgentString || 'wazo-sdk',
      reconnectionAttempts: 10000,
      reconnectionDelay: 5,
      sessionDescriptionHandlerFactory: (session         , options                                          = {}) => {
        const uaLogger = session.userAgent.getLogger('sip.WazoSessionDescriptionHandler');
        const isWeb = this._isWeb();
        const iceGatheringTimeout = 'peerConnectionOptions' in options
          ? options.peerConnectionOptions.iceGatheringTimeout || DEFAULT_ICE_TIMEOUT : DEFAULT_ICE_TIMEOUT;

        const sdhOptions                                         = {
          ...options,
          iceGatheringTimeout,
          peerConnectionConfiguration: {
            ...peerConnectionConfigurationDefault.defaultPeerConnectionConfiguration(),
            ...(options.peerConnectionConfiguration || {}),
          },
        };

        return new WazoSessionDescriptionHandler(uaLogger, wazoMediaStreamFactory, sdhOptions, isWeb, session);
      },
      transportOptions: {
        traceSip: configOverrides.traceSip || false,
        wsServers: `wss://${host}:${port}/api/asterisk/ws`,
      },
      sessionDescriptionHandlerFactoryOptions: {
        modifiers: [replaceLocalIpModifier],
        alwaysAcquireMediaFirst: this.isFirefox(),
        constraints: {
          audio: this._getAudioConstraints(),
          video: this._getVideoConstraints(),
        },
        peerConnectionOptions: {
          iceCheckingTimeout: this.config.iceCheckingTimeout || 1000,
          iceGatheringTimeout: this.config.iceCheckingTimeout || 1000,
          rtcConfiguration: {
            rtcpMuxPolicy: 'require',
            iceServers: WebRTCClient.getIceServers(this.config.host),
            ...this._getRtcOptions(),
            ...configOverrides.peerConnectionOptions || {},
          },
        },
        // Configuration used in SDH to create the PeerConnection
        peerConnectionConfiguration: {
          rtcpMuxPolicy: 'require',
          iceServers: WebRTCClient.getIceServers(this.config.host),
          ...configOverrides.peerConnectionOptions || {},
        },
      },
    };

    return { ...config, ...configOverrides };
  }

  // eslint-disable-next-line no-unused-vars
  _getRtcOptions() {
    return {
      mandatory: {
        OfferToReceiveAudio: this._hasAudio(),
        OfferToReceiveVideo: false,
      },
    };
  }

  // Invitation and Inviter extends Session
  _setupSession(session         ) {
    const sipSessionId = this.getSipSessionId(session);

    // When receiving an Invitation, the delegate is not defined.
    if (!session.delegate) {
      session.delegate = {};
    }

    session.delegate.onSessionDescriptionHandler = (sdh                           ) => {
      sdh.on('error', e => {
        this.eventEmitter.emit(ON_ERROR, e);
      });

      sdh.peerConnectionDelegate = {
        onicecandidateerror: (error        ) => {
          logger$8.error('on icecandidate error', {
            address: error.address,
            port: error.port,
            errorCode: error.errorCode,
            errorText: error.errorText,
            url: error.url,
          });
        },
      };
    };

    const oldInviteRequest = session.onInviteRequest.bind(session);
    let hadRemoteVideo = false;

    // Monkey patch `onInviteRequest` to be able to know if there was a remote video stream before `onInvite` is called
    // Because when `onInvite` is called we already got the video track
    session.onInviteRequest = (request) => {
      hadRemoteVideo = this.hasARemoteVideoTrack(sipSessionId);

      oldInviteRequest(request);
    };

    session.delegate.onInvite = (request                        ) => {
      let updatedCalleeName = null;
      let updatedNumber = null;
      if (session.assertedIdentity) {
        updatedNumber = session.assertedIdentity.uri.normal.user;
        updatedCalleeName = session.assertedIdentity.displayName || updatedNumber;
      }
      logger$8.info('re-invite received', { updatedCalleeName, updatedNumber, hadRemoteVideo });

      // Useful to know if it's a video upgrade or an unhold from a remote peer with a video stream

      // Update SDP
      // Remote video is handled by the `track` event. Here we're dealing with video stream removal.
      if (session.incomingInviteRequest) {
        session.incomingInviteRequest.message.body = request.body;
      } else {
        session.outgoingInviteRequest.message.body.body = request.body;
      }

      this.updateRemoteStream(sipSessionId);

      this._setupMedias(session);

      return this.eventEmitter.emit(ON_REINVITE$1, session, request, updatedCalleeName, updatedNumber, hadRemoteVideo);
    };
  }

  _onEarlyProgress(session               ) {
    this._setupMedias(session);

    const sessionId = this.getSipSessionId(session).substr(0, 20);
    this.updateRemoteStream(sessionId);

    logger$8.info('Early media progress progress received', { sessionId });

    this.eventEmitter.emit(ON_EARLY_MEDIA$1, session);
  }

  _onAccepted(session         , sessionDialog                , withEvent          = true) {
    logger$8.info('on call accepted', { id: session.id, remoteTag: session.remoteTag });

    this.storeSipSession(session);

    this._setupMedias(session);

    this.updateRemoteStream(this.getSipSessionId(session));

    const pc = session.sessionDescriptionHandler.peerConnection;
    const onTrack = (event     ) => {
      const isAudioOnly = this._isAudioOnly(session);
      const { kind, label, readyState, id, muted } = event.track;
      logger$8.info('on track event', { isAudioOnly, kind, label, readyState, id, muted });

      // Stop video track in audio only mode
      if (isAudioOnly && kind === 'video') {
        event.track.stop();
      }

      this.eventEmitter.emit(ON_TRACK$1, session, event);
    };

    if (session.sessionDescriptionHandler.peerConnection) {
      session.sessionDescriptionHandler.peerConnection.addEventListener('track', onTrack);
    }

    session.sessionDescriptionHandler.remoteMediaStream.onaddtrack = onTrack;

    if (pc) {
      pc.oniceconnectionstatechange = () => {
        logger$8.info('on ice connection state changed', { state: pc.iceConnectionState });
        if (pc.iceConnectionState === 'disconnected') {
          this.eventEmitter.emit(ON_DISCONNECTED$1);
        }
      };
    }

    if (withEvent) {
      this.eventEmitter.emit(ACCEPTED, session, sessionDialog);
    }

    this._startSendingStats(session);
  }

  _isAudioOnly(session         )          {
    return session.sessionDescriptionHandlerModifiersReInvite.find(modifier => modifier === modifiers.stripVideo);
  }

  _setupMedias(session         , newStream              ) {
    // Safari hack, because you cannot call .play() from a non user action
    const sessionId = this.getSipSessionId(session);
    const isConference = this.isConference(sessionId);

    if (sessionId in this.audioElements) {
      logger$8.info('html element already exists for session', { sessionId });
      return;
    }

    if (this._hasAudio() && this._isWeb() && !(sessionId in this.audioElements)) {
      this.createAudioElementFor(sessionId);
    }

    const audioElement = this.audioElements[sessionId];
    const sipSession = this.sipSessions[session.callId];
    const removeStream = this.getRemoteStream(sessionId);
    const earlyStream = sipSession && sipSession.sessionDescriptionHandler
      ? sipSession.sessionDescriptionHandler.remoteMediaStream : null;
    const stream = newStream || removeStream || earlyStream;

    if (!this._isWeb() || !stream) {
      return;
    }

    if (isConference) {
      // Conference local stream is handled in Room
      return;
    }

    if (audioElement.currentTime > 0 && !audioElement.paused && !audioElement.ended && audioElement.readyState > 2) {
      audioElement.pause();
    }
    audioElement.srcObject = stream;
    audioElement.volume = this.audioOutputVolume;
    audioElement.play().catch(() => {});
  }

  _cleanupMedia(session         ) {
    const sessionId = this.getSipSessionId(session);
    const localStream = this.getLocalStream(sessionId);
    if (localStream) {
      this._cleanupStream(localStream);
    }

    const cleanLocalElement = id => {
      const element = this.audioElements[id];
      if (!element) {
        return;
      }

      element.pause();
      if (element.parentNode) {
        element.parentNode.removeChild(element);
      }
      element.srcObject = null;

      delete this.audioElements[id];
    };

    if (this._hasAudio() && this._isWeb()) {
      if (session) {
        cleanLocalElement(this.getSipSessionId(session));
      } else {
        Object.keys(this.audioElements).forEach(id => cleanLocalElement(id));
      }
    }
  }

  _cleanupStream(stream             ) {
    stream.getTracks().forEach(track => track.stop());
  }

  _toggleAudio(session         , muteAudio         ) {
    const pc = session.sessionDescriptionHandler ? session.sessionDescriptionHandler.peerConnection : null;
    if (!pc) {
      return;
    }

    if (pc.getSenders) {
      pc.getSenders().forEach(sender => {
        if (sender && sender.track && sender.track.kind === 'audio') {
          // eslint-disable-next-line
          sender.track.enabled = !muteAudio;
        }
      });
    } else {
      pc.getLocalStreams().forEach(stream => {
        stream.getAudioTracks().forEach(track => {
          // eslint-disable-next-line
          track.enabled = !muteAudio;
        });
      });
    }
  }

  _toggleVideo(session         , muteCamera         ) {
    const pc = session.sessionDescriptionHandler.peerConnection;

    if (pc.getSenders) {
      pc.getSenders().forEach(sender => {
        if (sender && sender.track && sender.track.kind === 'video') {
          // eslint-disable-next-line
          sender.track.enabled = !muteCamera;
        }
      });
    } else {
      pc.getLocalStreams().forEach(stream => {
        stream.getVideoTracks().forEach(track => {
          // eslint-disable-next-line
          track.enabled = !muteCamera;
        });
      });
    }
  }

  /**
   * @param pc RTCPeerConnection
   */
  _getRemoteStream(pc     ) {
    let remoteStream;

    if (pc && pc.getReceivers) {
      remoteStream = typeof global !== 'undefined' && global.window && global.window.MediaStream
        ? new global.window.MediaStream() : new window.MediaStream();
      pc.getReceivers().forEach(receiver => {
        const { track } = receiver;
        if (track) {
          remoteStream.addTrack(track);
        }
      });
    } else if (pc) {
      [remoteStream] = pc.getRemoteStreams();
    }

    return remoteStream;
  }

  _cleanupRegister() {
    if (this.registerer) {
      this.registerer.stateChange.removeAllListeners();
      this.registerer = null;
    }
  }

  _startSendingStats(session         ) {
    const pc = session.sessionDescriptionHandler.peerConnection;
    if (!pc) {
      return;
    }
    const sessionId = this.getSipSessionId(session);

    getStats__default['default'](pc, (result        ) => {
      const { results, internal, nomore, ...stats } = result;
      this.statsIntervals[sessionId] = nomore;

      statsLogger.trace('stats', {
        sessionId,
        ...stats,
      });
    }, SEND_STATS_DELAY);
  }

  _stopSendingStats(session         ) {
    const sessionId = this.getSipSessionId(session);
    logger$8.trace('Check for stopping stats', { sessionId, ids: Object.keys(this.statsIntervals) });

    if (sessionId in this.statsIntervals) {
      logger$8.trace('Stop sending stats for call', { sessionId });
      this.statsIntervals[sessionId]();
      delete this.statsIntervals[sessionId];
    }
  }

  _makeURI(target        )      {
    return userAgent.UserAgent.makeURI(`sip:${target}@${this.config.host}`);
  }

  async _disconnectTransport(force          = false) {
    if (force && this.userAgent && this.userAgent.transport) {
      // Bypass sip.js state machine that prevent to close WS with the state `Connecting`
      this.userAgent.transport.disconnectResolve = () => {};

      if (this.userAgent.transport._ws) {
        this.userAgent.transport._ws.close(1000);
      }

      return;
    }

    // Check if `disconnectPromise` is not present to avoid `Disconnect promise must not be defined` errors.
    if (this.userAgent && this.userAgent.transport && !this.userAgent.transport.disconnectPromise) {
      try {
        await this.userAgent.transport.disconnect();
      } catch (e) {
        logger$8.error('WebRTC transport disconnect, error', e);
      }
    }
  }

  async _fetchNetworkStats(sessionId        ) {
    const session = this.getSipSession(sessionId);

    const stats = session ? await this.getStats(session) : null;
    if (!stats || !(sessionId in this.sessionNetworkStats)) {
      return;
    }

    const networkStats         = {
      audioBytesSent: 0,
      videoBytesSent: 0,
      videoBytesReceived: 0,
      audioBytesReceived: 0,
    };
    const nbStats = this.sessionNetworkStats[sessionId].length;
    const lastNetworkStats = this.sessionNetworkStats[sessionId][nbStats - 1];
    const lastAudioSent = lastNetworkStats ? lastNetworkStats.audioBytesSent : 0;
    const lastAudioContentSent = lastNetworkStats ? lastNetworkStats.audioContentSent : 0;
    const lastVideoSent = lastNetworkStats ? lastNetworkStats.videoBytesSent : 0;
    const lastAudioReceived = lastNetworkStats ? lastNetworkStats.audioBytesReceived : 0;
    const lastAudioContentReceived = lastNetworkStats ? lastNetworkStats.audioContentReceived : 0;
    const lastVideoReceived = lastNetworkStats ? lastNetworkStats.videoBytesReceived : 0;
    const lastTransportSent = lastNetworkStats ? lastNetworkStats.transportSent : 0;
    const lastTransportReceived = lastNetworkStats ? lastNetworkStats.transportReceived : 0;
    let audioBytesSent = 0; // content + header
    let audioBytesReceived = 0; // content + header
    let audioContentSent = 0; // useful to detect blank call
    let audioContentReceived = 0;
    let videoBytesSent = 0;
    let videoBytesReceived = 0;
    let transportSent = 0;
    let transportReceived = 0;
    let packetsLost = 0;

    stats.forEach(report => {
      if (report.type === 'outbound-rtp' && report.kind === 'audio') {
        audioBytesSent += Number(report.bytesSent) + Number(report.headerBytesSent);
        audioContentSent += Number(report.bytesSent);
      }
      if (report.type === 'remote-outbound-rtp' && report.kind === 'audio') {
        audioBytesSent += Number(report.bytesSent);
      }
      if (report.type === 'outbound-rtp' && report.kind === 'video') {
        videoBytesSent += Number(report.bytesSent) + Number(report.headerBytesSent);
      }
      if (report.type === 'inbound-rtp' && report.kind === 'audio') {
        packetsLost += Number(report.packetsLost);
        networkStats.packetsReceived = Number(report.packetsReceived);
        audioBytesReceived += Number(report.bytesReceived) + Number(report.headerBytesReceived);
        audioContentReceived += Number(report.bytesReceived);
      }
      if (report.type === 'inbound-rtp' && report.kind === 'video') {
        videoBytesReceived += Number(report.bytesReceived) + Number(report.headerBytesReceived);
      }
      if (report.type === 'outbound-rtp' && report.kind === 'video') {
        if ('framesPerSecond' in report) {
          networkStats.framesPerSecond = Number(report.framesPerSecond);
        }
        if ('framerateMean' in report) {
          // framerateMean is only available in FF
          networkStats.framesPerSecond = Math.round(report.framerateMean);
        }
      }
      if (report.type === 'remote-inbound-rtp' && report.kind === 'audio') {
        packetsLost += Number(report.packetsLost);
        networkStats.roundTripTime = Number(report.roundTripTime);
        networkStats.jitter = Number(report.jitter);
      }
      if (report.type === 'remote-inbound-rtp' && report.kind === 'video') {
        packetsLost += Number(report.packetsLost);
      }
      if (report.type === 'transport') {
        transportSent += Number(report.bytesSent);
        transportReceived += Number(report.bytesReceived);
      }
    });

    networkStats.packetsLost = packetsLost;

    networkStats.totalAudioBytesSent = audioBytesSent;
    networkStats.audioBytesSent = audioBytesSent - lastAudioSent;
    networkStats.totalAudioBytesReceived = audioBytesReceived - lastAudioReceived;
    networkStats.audioBytesReceived = audioBytesReceived;

    networkStats.totalAudioContentSent = audioContentSent;
    networkStats.audioContentSent = audioContentSent - lastAudioContentSent;
    networkStats.totalAudioBytesReceived = audioContentReceived - lastAudioContentReceived;
    networkStats.audioContentReceived = audioContentReceived;

    networkStats.totalVideoBytesSent = videoBytesSent;
    networkStats.videoBytesSent = videoBytesSent - lastVideoSent;
    networkStats.totalVideoBytesReceived = videoBytesReceived;
    networkStats.videoBytesReceived = videoBytesReceived - lastVideoReceived;
    networkStats.totalTransportSent = transportSent - lastTransportSent;
    networkStats.transportSent = transportSent;
    networkStats.totalTransportReceived = transportReceived;
    networkStats.transportReceived = transportReceived - lastTransportReceived;

    networkStats.bandwidth = networkStats.audioBytesSent + networkStats.audioBytesReceived
      + networkStats.videoBytesSent + networkStats.videoBytesReceived + networkStats.transportReceived
      + networkStats.transportSent;

    this.eventEmitter.emit(ON_NETWORK_STATS$1, session, networkStats, this.sessionNetworkStats[sessionId]);
    this.sessionNetworkStats[sessionId].push(networkStats);
  }

}

/* eslint-disable no-param-reassign */

const ON_USER_AGENT = 'onUserAgent';
const ON_REGISTERED = 'onRegistered';
const ON_UNREGISTERED = 'onUnRegistered';
const ON_PROGRESS = 'onProgress';
const ON_CALL_ACCEPTED = 'onCallAccepted';
const ON_CALL_ANSWERED = 'onCallAnswered';
const ON_CALL_INCOMING = 'onCallIncoming';
const ON_CALL_OUTGOING = 'onCallOutgoing';
const ON_CALL_MUTED = 'onCallMuted';
const ON_CALL_UNMUTED = 'onCallUnmuted';
const ON_CALL_RESUMED = 'onCallResumed';
const ON_CALL_HELD = 'onCallHeld';
const ON_CALL_UNHELD = 'onCallUnHeld';
const ON_CAMERA_DISABLED = 'onCameraDisabled';
const ON_CAMERA_RESUMED = 'onCameraResumed';
const ON_CALL_CANCELED = 'onCallCanceled';
const ON_CALL_FAILED = 'onCallFailed';
const ON_CALL_REJECTED = 'onCallRejected';
const ON_CALL_ENDED = 'onCallEnded';
const ON_CALL_ENDING = 'onCallEnding';
const ON_MESSAGE = 'onMessage';
const ON_REINVITE = 'reinvite';
const ON_TRACK = 'onTrack';
const ON_AUDIO_STREAM = 'onAudioStream';
const ON_VIDEO_STREAM = 'onVideoStream';
const ON_REMOVE_STREAM = 'onRemoveStream';
const ON_SHARE_SCREEN_STARTED = 'onScreenShareStarted';
const ON_SHARE_SCREEN_ENDING = 'onScreenShareEnding';
const ON_SHARE_SCREEN_ENDED = 'onScreenShareEnded';
const ON_TERMINATE_SOUND = 'terminateSound';
const ON_PLAY_RING_SOUND = 'playRingingSound';
const ON_PLAY_INBOUND_CALL_SIGNAL_SOUND = 'playInboundCallSignalSound';
const ON_PLAY_HANGUP_SOUND = 'playHangupSound';
const ON_PLAY_PROGRESS_SOUND = 'playProgressSound';
const ON_VIDEO_INPUT_CHANGE = 'videoInputChange';
const ON_CALL_ERROR = 'onCallError';
const ON_MESSAGE_TRACK_UPDATED = 'onTrackUpdated';
const ON_NETWORK_STATS = 'onNetworkStats';
const ON_CHAT = 'phone/ON_CHAT';
const ON_SIGNAL = 'phone/ON_SIGNAL';
const ON_DISCONNECTED = 'onDisconnected';
const ON_EARLY_MEDIA = 'onEarlyMedia';

const MESSAGE_TYPE_CHAT = 'message/TYPE_CHAT';
const MESSAGE_TYPE_SIGNAL = 'message/TYPE_SIGNAL';

const events = [
  ON_USER_AGENT,
  ON_REGISTERED,
  ON_UNREGISTERED,
  ON_PROGRESS,
  ON_CALL_ACCEPTED,
  ON_CALL_ANSWERED,
  ON_CALL_INCOMING,
  ON_CALL_OUTGOING,
  ON_CALL_MUTED,
  ON_CALL_UNMUTED,
  ON_CALL_RESUMED,
  ON_CALL_HELD,
  ON_CALL_UNHELD,
  ON_CAMERA_DISABLED,
  ON_CALL_FAILED,
  ON_CALL_ENDED,
  ON_CALL_REJECTED,
  ON_MESSAGE,
  ON_REINVITE,
  ON_TRACK,
  ON_AUDIO_STREAM,
  ON_VIDEO_STREAM,
  ON_REMOVE_STREAM,
  ON_SHARE_SCREEN_ENDED,
  ON_TERMINATE_SOUND,
  ON_PLAY_RING_SOUND,
  ON_PLAY_INBOUND_CALL_SIGNAL_SOUND,
  ON_PLAY_HANGUP_SOUND,
  ON_PLAY_PROGRESS_SOUND,
  ON_VIDEO_INPUT_CHANGE,
  ON_SHARE_SCREEN_STARTED,
  ON_CALL_ERROR,
  ON_CHAT,
  ON_SIGNAL,
  ON_NETWORK_STATS,
  ON_DISCONNECTED,
  ON_EARLY_MEDIA,
];

const logger$7 = IssueReporter$1.loggerFor('webrtc-phone');

class WebRTCPhone extends Emitter                  {
                           

                      

                                          

                             

                             

                                   

                               

                             

                            

                          

                          

                           

                           

                          

                             

                          

                              

  constructor(
    client                  ,
    audioOutputDeviceId         ,
    allowVideo          = false,
    audioRingDeviceId         ,
  ) {
    super();

    this.client = client;
    this.allowVideo = allowVideo;
    this.callSessions = {};
    this.audioOutputDeviceId = audioOutputDeviceId;
    this.audioRingDeviceId = audioRingDeviceId || audioOutputDeviceId;
    this.audioOutputVolume = 1;
    this.audioRingVolume = 1;
    this.incomingSessions = [];
    this.ringingEnabled = true;
    this.shouldSendReinvite = false;

    this.bindClientEvents();

    this.acceptedSessions = {};
    this.rejectedSessions = {};
    this.ignoredSessions = {};
  }

  register() {
    if (!this.client) {
      return Promise.resolve();
    }

    return this.client.register().then(() => {
      return this.bindClientEvents();
    }).catch(error => {
      // Avoid exception on `t.server.scheme` in sip transport when losing the webrtc socket connection
      console.error('register error', error, error.message, error.stack);
      logger$7.error('WebRTC register error', { message: error.message, stack: error.stack });
    });
  }

  unregister() {
    if (!this.client || !this.client.isRegistered()) {
      return null;
    }
    return this.client.unregister();
  }

  stop() {
    if (!this.client) {
      return;
    }
    logger$7.info('WebRTC phone stop');
    this.client.stop();
  }

  removeIncomingSessions(id        ) {
    this.incomingSessions = this.incomingSessions.filter(sessionId => sessionId !== id);
  }

  isWebRTC() {
    return true;
  }

  async sendReinvite(callSession              , constraints          = null, conference          = false,
    audioOnly          = false, iceRestart          = false) {
    const sipSession = this.findSipSession(callSession);
    logger$7.info('WebRTC phone - send reinvite', {
      sessionId: sipSession ? sipSession.id : null,
      constraints,
      audioOnly,
      conference,
      iceRestart,
    });

    if (!sipSession) {
      return false;
    }

    // $FlowFixMe
    const shouldScreenShare = constraints && constraints.screen;
    const isUpgrade = shouldScreenShare || (constraints && constraints.video);

    // Downgrade
    if (constraints && !isUpgrade) {
      // No reinvite needed
      this._downgradeToAudio(callSession);
      return false;
    }

    if (isUpgrade) {
      const shouldReinvite = await this._upgradeToVideo(callSession, constraints, conference);
      if (!shouldReinvite) {
        return false;
      }
    }

    return this.client.reinvite(sipSession, constraints, conference, audioOnly, iceRestart);
  }

  getUserAgent() {
    return (this.client && this.client.config && this.client.config.userAgentString) || 'webrtc-phone';
  }

  startHeartbeat() {
    logger$7.info('WebRTC phone - start heartbeat', { client: !!this.client, hasHeartbeat: this.client.hasHeartbeat() });
    if (!this.client || this.client.hasHeartbeat()) {
      return;
    }

    this.client.startHeartbeat();
  }

  stopHeartbeat() {
    logger$7.info('WebRTC phone - stopHeartbeat', { client: !!this.client });
    if (!this.client) {
      return;
    }

    this.client.stopHeartbeat();
  }

  setOnHeartbeatTimeout(cb          ) {
    this.client.setOnHeartbeatTimeout(cb);
  }

  setOnHeartbeatCallback(cb          ) {
    this.client.setOnHeartbeatCallback(cb);
  }

  reconnect() {
    logger$7.info('WebRTC phone - reconnect', { client: !!this.client });
    if (!this.client) {
      return;
    }
    this.client.attemptReconnection();
  }

  getOptions()                        {
    return {
      accept: true,
      decline: true,
      mute: true,
      hold: true,
      transfer: true,
      sendKey: true,
      addParticipant: false,
      record: true,
      merge: true,
    };
  }

  onConnect() {
    if (!this.client) {
      return Promise.reject(new Error('No webrtc client'));
    }
    return this.client.onConnect();
  }

  onDisconnect() {
    if (!this.client) {
      return Promise.reject(new Error('No webrtc client'));
    }
    return this.client.onDisconnect();
  }

  _downgradeToAudio(callSession              , withMessage          = true) {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return false;
    }

    logger$7.info('Downgrade to video', { id: callSession ? callSession.getId() : null, withMessage });

    this.client.downgradeToAudio(sipSession);

    if (callSession) {
      callSession.cameraEnabled = false;
      this._updateCallSession(callSession);
    }

    if (withMessage) {
      this._sendReinviteMessage(callSession, false);
    }

    return true;
  }

  // Returns true if we need to send a re-INVITE request
  async _upgradeToVideo(callSession              , constraints         , isConference         )                   {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return Promise.resolve(false);
    }

    logger$7.info('Upgrade to video', {
      id: callSession ? callSession.getId() : null,
      constraints,
      isConference,
    });

    const shouldScreenShare = constraints && !!constraints.screen;
    const desktop = constraints && constraints.desktop;
    const options = sipSession.sessionDescriptionHandlerOptionsReInvite;
    const wasAudioOnly = options && options.audioOnly;

    const newStream = await this.client.upgradeToVideo(sipSession, constraints, isConference);

    if (callSession) {
      callSession.cameraEnabled = true;
      this._updateCallSession(callSession);
    }

    // If no stream is returned, it means we have to reinvite
    if (!newStream) {
      return true;
    }

    this._sendReinviteMessage(callSession, true);

    if (shouldScreenShare) {
      this._onScreenSharing(newStream, sipSession, callSession, false, desktop);
    }

    // We have to reinvite to change the direction on the bundle when upgrading from an audioOnly conference
    if (isConference && wasAudioOnly) {
      return true;
    }

    // No reinvite needed here
    return false;
  }

  _sendReinviteMessage(callSession              , isUpgrade         ) {
    const sipSession = this.findSipSession(callSession);
    logger$7.info('Sending reinvite message', {
      id: callSession ? callSession.getId() : null,
      isUpgrade,
    });

    // Have to send the message after a delay due to latency to update the remote peer
    setTimeout(() => {
      this.sendMessage(sipSession, JSON.stringify({
        type: MESSAGE_TYPE_SIGNAL,
        content: {
          type: ON_MESSAGE_TRACK_UPDATED,
          update: isUpgrade ? 'upgrade' : 'downgrade',
          sipCallId: this.getSipSessionId(sipSession),
          callId: callSession ? callSession.callId : null,
          number: callSession ? callSession.number : null,
          callerNumber: callSession ? callSession.callerNumber : null,
        },
      }));
    }, 2500);
  }

  _bindEvents(sipSession         ) {
    if (sipSession._onCancel) {
      // Monkey patch to know when canceled with the CANCEL message
      const onCancel = sipSession._onCancel.bind(sipSession);
      sipSession._onCancel = (message                        ) => {
        logger$7.trace('on sip session canceled', { callId: message.callId });

        onCancel(message);
        const elsewhere = message.data.indexOf('cause=26') !== -1 && message.data.indexOf('completed elsewhere') !== -1;
        const callSession = this._createCallSession(sipSession);
        delete this.callSessions[callSession.getId()];

        this.eventEmitter.emit(ON_CALL_CANCELED, callSession, elsewhere);
      };
    } else if (sipSession instanceof invitation.Invitation) {
      console.warn('sipSession._onCancel not found, please update the wazo SDK accordingly');
    }

    sipSession.stateChange.addListener((newState              ) => {
      switch (newState) {
        case sessionState.SessionState.Establishing:
          if (sipSession instanceof invitation.Invitation) {
            // No need to trigger progress for an invitation (eg: when we answer the call).
            return;
          }
          // When receiving a progress event, we know we are the caller so we have to force incoming to false
          return this.eventEmitter.emit(
            ON_PROGRESS,
            this._createCallSession(sipSession, null, { incoming: false, ringing: true }),
            this.audioOutputDeviceId,
            this.audioOutputVolume,
          );
        case sessionState.SessionState.Terminating:
          logger$7.info('WebRTC phone - call terminating', { sipId: sipSession.id });

          this.eventEmitter.emit(ON_CALL_ENDING, this._createCallSession(sipSession));

          break;
        case sessionState.SessionState.Terminated: {
          logger$7.info('WebRTC phone - call terminated', { sipId: sipSession.id });

          // Should be called before `_onCallTerminated` or the callCount will not decrement...
          const callSession = this._createCallSession(sipSession);
          callSession.endTime = new Date();
          const wasCurrentSession = this._onCallTerminated(sipSession);

          return this.eventEmitter.emit(ON_CALL_ENDED, callSession, wasCurrentSession);
        }
      }
    });

    if (!sipSession.sessionDescriptionHandler) {
      return;
    }

    // Video events
    const { peerConnection } = sipSession.sessionDescriptionHandler;
    peerConnection.ontrack = rawEvent => {
      const event = rawEvent;
      const [stream] = event.streams;
      const kind = event && event.track && event.track.kind;

      logger$7.info('on track stream called on the peer connection', {
        callId: this.getSipSessionId(sipSession),
        streamId: stream ? stream.id : null,
        tracks: stream ? stream.getTracks() : null,
        kind,
      });

      if (kind === 'audio') {
        return this.eventEmitter.emit(ON_AUDIO_STREAM, stream);
      }

      // not sure this does anything
      if (kind === 'video') {
        event.track.enabled = false;
      }

      return this.eventEmitter.emit(ON_VIDEO_STREAM, stream, event.track.id, event, sipSession);
    };

    peerConnection.onremovestream = event => {
      logger$7.info('on remove stream called on the peer connection', {
        id: event.stream.id,
        tracks: event.stream.getTracks(),
      });

      this.eventEmitter.emit(ON_REMOVE_STREAM, event.stream);
    };
  }

  async startScreenSharing(constraints        , callSession              ) {
    logger$7.info('WebRTC - start screen sharing', { constraints, id: callSession ? callSession.getId() : null });

    const screenShareStream = await this.client.getStreamFromConstraints(constraints);
    if (!screenShareStream) {
      throw new Error(`Can't create media stream for screensharing with: ${JSON.stringify(constraints)}`);
    }

    const screenTrack = screenShareStream.getVideoTracks()[0];
    const sipSession = this.currentSipSession;
    const pc = this.client.getPeerConnection(this.getSipSessionId(sipSession));
    const sender = pc && pc.getSenders && pc.getSenders().find(s => s && s.track && s.track.kind === 'video');
    const localStream = this.client.getLocalStream(this.getSipSessionId(sipSession));
    const videoTrack = localStream ? localStream.getTracks().find(track => track.kind === 'video') : null;
    const hadVideo = !!videoTrack;

    // Stop local video tracks
    if (videoTrack && localStream) {
      videoTrack.enabled = false;
      videoTrack.stop();
      localStream.removeTrack(videoTrack);
    }

    if (localStream) {
      localStream.addTrack(screenTrack);
    }

    if (sender) {
      sender.replaceTrack(screenTrack);
    }

    this._onScreenSharing(screenShareStream, sipSession, callSession, hadVideo, constraints.desktop);

    return screenShareStream;
  }

  async stopScreenSharing(restoreLocalStream          = true, callSession               ) {
    if (!this.currentScreenShare) {
      return;
    }

    logger$7.info('WebRTC phone - stop screen sharing', {
      restoreLocalStream,
    });

    let reinvited = false;

    try {
      if (this.currentScreenShare.stream) {
        this.currentScreenShare.stream.getTracks().forEach(track => track.stop());
      }

      if (restoreLocalStream) {
        const targetCallSession = callSession || this.currentCallSession;
        const conference = this.isConference(targetCallSession);

        // When stopping screenshare and we had video before that, we have to re-upgrade
        // When upgrading directly to screenshare (eg: we don't have a videoLocalStream to replace)
        // We have to downgrade to audio.
        const screenshareStopped = this.currentScreenShare.hadVideo;
        const constraints = { audio: false, video: screenshareStopped };

        // We have to remove the video sender to be able to re-upgrade to video in `sendReinvite` below
        this._downgradeToAudio(targetCallSession, false);
        // Wait for the track to be removed, unless the video sender won't have a null track in `_upgradeToVideo`.
        await new Promise(resolve => setTimeout(resolve, 500));

        reinvited = await this.sendReinvite(targetCallSession, constraints, conference);
      }
    } catch (e) {
      console.warn(e);
    }

    const sipSession = this.currentSipSession;

    this.eventEmitter.emit(
      ON_SHARE_SCREEN_ENDED,
      callSession ? this._createCallSession(sipSession, callSession, { screensharing: false }) : null,
    );

    this.currentScreenShare = null;

    return reinvited;
  }

  _onScreenSharing(screenStream        ,
    sipSession         ,
    callSession              ,
    hadVideo         ,
    desktop            = false) {
    const screenTrack = screenStream.getVideoTracks()[0];
    const sipSessionId = this.getSipSessionId(sipSession);
    const pc = this.client.getPeerConnection(sipSessionId);
    const sender = pc && pc.getSenders && pc.getSenders().find(s => s && s.track && s.track.kind === 'video');

    logger$7.info('WebRTC phone - on screensharing', {
      hadVideo,
      id: this.getSipSessionId(sipSession),
      screenTrack,
    });

    if (screenTrack) {
      screenTrack.onended = () => {
        logger$7.info('WebRTC phone - on screenshare ended', {
          hadVideo,
          id: this.getSipSessionId(sipSession),
          screenTrack,
        });

        this.eventEmitter.emit(
          ON_SHARE_SCREEN_ENDING,
          this._createCallSession(sipSession, callSession),
        );
      };
    }

    this.currentScreenShare = {
      stream: screenStream,
      hadVideo,
      sender,
      sipSessionId,
      desktop,
    };

    this.client.setLocalMediaStream(this.getSipSessionId(sipSession), screenStream);

    this.eventEmitter.emit(
      ON_SHARE_SCREEN_STARTED,
      this._createCallSession(sipSession, callSession, { screensharing: true }),
      screenStream,
    );
  }

  _onCallAccepted(sipSession         , cameraEnabled         )              {
    logger$7.info('WebRTC phone - on call accepted', { sipId: sipSession.id, cameraEnabled });

    const callSession = this._createAcceptedCallSession(sipSession, cameraEnabled);
    this.currentSipSession = sipSession;
    this.currentCallSession = callSession;

    this.eventEmitter.emit(ON_TERMINATE_SOUND, callSession, 'call accepted');
    const sipSessionId = this.getSipSessionId(sipSession);
    if (sipSessionId) {
      this.removeIncomingSessions(sipSessionId);
    }

    callSession.answerTime = new Date();
    this._updateCallSession(callSession);
    this.eventEmitter.emit(ON_CALL_ACCEPTED, callSession, cameraEnabled);

    return callSession;
  }

  changeAudioDevice(id        ) {
    logger$7.info('WebRTC phone - change audio device', { deviceId: id });
    this.audioOutputDeviceId = id;
    this.client.changeAudioOutputDevice(id);
  }

  createAudioElementFor(sessionId        ) {
    return this.client.createAudioElementFor(sessionId);
  }

  changeRingDevice(id        ) {
    logger$7.info('WebRTC phone - changing ring device', { id });

    this.audioRingDeviceId = id;
  }

  // volume is a value between 0 and 1
  changeAudioVolume(volume        ) {
    logger$7.info('WebRTC phone - changing audio volume', { volume });

    this.audioOutputVolume = volume;
    this.client.changeAudioOutputVolume(volume);
  }

  // volume is a value between 0 and 1
  changeRingVolume(volume        ) {
    logger$7.info('WebRTC phone - changing ring volume', { volume });

    this.audioRingVolume = volume;
  }

  changeAudioInputDevice(id        , force          ) {
    logger$7.info('WebRTC phone - changeAudio input device', { deviceId: id });

    return this.client.changeAudioInputDevice(id, this.currentSipSession, force);
  }

  changeVideoInputDevice(id         ) {
    logger$7.info('WebRTC phone - change video input device', { deviceId: id });

    return this.client.changeVideoInputDevice(id, this.currentSipSession);
  }

  changeSessionVideoInputDevice(id         ) {
    logger$7.info('WebRTC phone - change session video input device', { deviceId: id });

    return this.client.changeSessionVideoInputDevice(id, this.currentSipSession);
  }

  _onCallTerminated(sipSession         ) {
    logger$7.info('WebRTC phone - on call terminated', { sipId: sipSession.id });

    const sipSessionId = this.getSipSessionId(sipSession);
    const callSession = this._createCallSession(sipSession);
    const isCurrentSession = this.isCurrentCallSipSession(callSession);
    const isCurrentIncomingCall = callSession.is(this.getIncomingCallSession());

    // If the terminated call was an incoming call, we have to re-trigger if it's was the first incoming call
    // Otherwise, we have to re-trigger an incoming call event if another call is incoming
    const shouldRetrigger = isCurrentSession ? this.incomingSessions.length : isCurrentIncomingCall;

    // Terminate incoming sound only for the ringing call
    // (so another terminated call won't stop the incoming call sound)
    if (isCurrentIncomingCall) {
      setTimeout(() => {
        // Avoid race condition when the other is calling and hanging up immediately
        this.eventEmitter.emit(ON_TERMINATE_SOUND, callSession, 'call terminated');
      }, 5);
    }

    if (sipSessionId) {
      this.removeIncomingSessions(sipSessionId);
    }

    delete this.callSessions[callSession.getId()];

    if (isCurrentSession) {
      this.currentSipSession = undefined;
      this.currentCallSession = undefined;
    }

    const hasIncomingCallSession = this.hasIncomingCallSession();

    // Re-trigger incoming call event for remaining incoming calls
    logger$7.info('WebRTC phone - check to re-trigger incoming call', {
      sipId: sipSession.id,
      shouldRetrigger,
      hasIncomingCallSession,
    });

    this.client.onCallEnded(sipSession);

    if (hasIncomingCallSession && shouldRetrigger) {
      const nextCallSession = this.getIncomingCallSession();
      // Avoid race condition
      setTimeout(() => {
        if (this.ringingEnabled) {
          if (!this.currentCallSession) {
            this.eventEmitter.emit(ON_PLAY_RING_SOUND, this.audioRingDeviceId, this.audioRingVolume, nextCallSession);
          } else {
            this.eventEmitter.emit(ON_PLAY_INBOUND_CALL_SIGNAL_SOUND,
              this.audioOutputDeviceId,
              this.audioOutputVolume,
              nextCallSession);
          }
        }

        // $FlowFixMe
        this.eventEmitter.emit(ON_CALL_INCOMING, nextCallSession, nextCallSession.cameraEnabled);
      }, 100);
    }

    if (callSession.getId() in this.ignoredSessions) {
      return;
    }

    if (!sipSession.isCanceled) {
      setTimeout(() => {
        this.eventEmitter.emit(ON_PLAY_HANGUP_SOUND, this.audioOutputDeviceId, this.audioOutputVolume, callSession);
      }, 10);
    }

    return isCurrentSession;
  }

  setActiveSipSession(callSession             ) {
    const sipSessionId = this.findSipSession(callSession);
    if (!sipSessionId) {
      return;
    }

    this.currentSipSession = sipSessionId;
    this.currentCallSession = callSession;
  }

  hasAnActiveCall() {
    return !!this.currentSipSession;
  }

  // /!\ In some case with react-native webrtc the session will have only one audio stream set
  // Maybe due to https://github.com/react-native-webrtc/react-native-webrtc/issues/401
  hasActiveRemoteVideoStream() {
    const sipSession = this.currentSipSession;
    if (!sipSession) {
      return false;
    }

    const { peerConnection } = sipSession.sessionDescriptionHandler;
    const remoteStream = peerConnection.getRemoteStreams().find(stream => !!stream.getVideoTracks().length);

    return remoteStream && remoteStream.getVideoTracks().some(track => !track.muted);
  }

  callCount() {
    return Object.keys(this.callSessions).length;
  }

  isCurrentCallSipSession(callSession             )          {
    if (!this.currentSipSession) {
      return false;
    }

    return this.currentSipSession && this.getSipSessionId(this.currentSipSession) === callSession.getId();
  }

  hasVideo(callSession             )          {
    return this.client.hasVideo(callSession.getId());
  }

  hasAVideoTrack(callSession             )          {
    return this.client.hasAVideoTrack(callSession.getId());
  }

  // Deprecated
  getLocalStreamForCall(callSession             )               {
    logger$7.warn('WebRTCPhone.getLocalStreamForCall is deprecated, use WebRTCPhone.getLocalStream instead');

    return this.getLocalStream(callSession);
  }

  // Deprecated
  getRemoteStreamForCall(callSession             )               {
    logger$7.warn('WebRTCPhone.getRemoteStreamForCall is deprecated, use WebRTCPhone.getRemoteStream instead');

    return this.getRemoteVideoStream(callSession);
  }

  getRemoteStreamsForCall(callSession             )               {
    logger$7.warn('WebRTCPhone.getRemoteStreamsForCall is deprecated, use WebRTCPhone.getRemoteStreams instead');

    return this.getRemoteStream(callSession);
  }

  accept(callSession             , cameraEnabled          )                         {
    logger$7.info('WebRTC phone - accept call', { id: callSession ? callSession.getId() : 'n/a', cameraEnabled });
    if (this.currentSipSession) {
      this.holdSipSession(
        this.currentSipSession,
        this.currentCallSession,
        true,
      );
    }

    if (!callSession) {
      logger$7.warn('no CallSession to accept.');
      return Promise.resolve(null);
    }

    const sipSessionId = this.getSipSessionIdFromCallSession(callSession);
    if (sipSessionId && !(sipSessionId in this.callSessions)) {
      logger$7.warn('Call session already ended or not found, can\'t accept it.', { sipSessionId });
      return Promise.resolve(null);
    }

    if (callSession.getId() in this.acceptedSessions) {
      logger$7.warn('CallSession already accepted.', { id: callSession ? callSession.getId() : 'n/a' });
      return Promise.resolve(callSession.sipCallId);
    }

    this.shouldSendReinvite = false;
    callSession.answerTime = new Date();
    this._updateCallSession(callSession);
    this.acceptedSessions[callSession.getId()] = true;

    this.eventEmitter.emit(ON_CALL_ANSWERED, callSession);

    const sipSession = this.client.getSipSession(callSession.getId());
    if (sipSession) {
      if (sipSession.state === sessionState.SessionState.Terminated || sipSession.state === sessionState.SessionState.Terminating) {
        logger$7.warn('Trying to answer a terminated sipSession.');

        return Promise.resolve(null);
      }

      logger$7.info('accept call, session found', { sipId: sipSession.id });

      // $FlowFixMe
      return this.client.answer(sipSession, this.allowVideo ? cameraEnabled : false).then(() => {
        return callSession.sipCallId;
      }).catch(e => {
        logger$7.error(e);
        this.endCurrentCall(callSession);
        throw e;
      });
    }

    logger$7.warn('no CallSession found to accept.', { id: callSession ? callSession.getId() : 'n/a' });

    return Promise.resolve(null);
  }

  isAccepted(callSession             )          {
    return callSession && callSession.getId() in this.acceptedSessions;
  }

  async reject(callSession             )                {
    logger$7.info('reject WebRTC called', { id: callSession.getId() });

    this.eventEmitter.emit(ON_TERMINATE_SOUND, callSession, 'call rejected locally');
    if (!callSession || callSession.getId() in this.rejectedSessions) {
      return;
    }

    this.shouldSendReinvite = false;
    this.rejectedSessions[callSession.getId()] = true;

    const sipSession = this.findSipSession(callSession);
    if (sipSession) {
      logger$7.info('WebRTC rejecting', { sipId: sipSession.id });

      this.client.hangup(sipSession);
    }
  }

  async ignore(callSession             )                {
    logger$7.info('WebRTC ignore', { id: callSession.getId() });

    // kill the ring
    this.eventEmitter.emit(ON_TERMINATE_SOUND, callSession, 'ignoring call');
    this.ignoredSessions[callSession.getId()] = true;
    callSession.ignore();
  }

  atxfer(callSession             )          {
    const sipSession = this.findSipSession(callSession);

    if (sipSession) {
      logger$7.info('WebRTC atxfer', { sipId: sipSession.id });

      return this.client.atxfer(sipSession);
    }
  }

  hold(callSession             , withEvent          = true)                {
    logger$7.info('WebRTC hold', { id: callSession.getId() });

    const sipSession = this.findSipSession(callSession);

    return sipSession ? this.holdSipSession(sipSession, callSession, withEvent) : null;
  }

  // @Deprecated
  unhold(callSession             , withEvent          = true)                {
    console.warn('Please note that `phone.unhold()` is being deprecated; `phone.resume()` is the preferred method');

    return this.resume(callSession, withEvent);
  }

  resume(callSession              , withEvent          = true)               {
    logger$7.info('WebRTC resume called', { id: callSession ? callSession.getId() : null });

    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return new Promise((resolve, reject) => reject(new Error('No session to resume')));
    }

    logger$7.info('WebRTC resuming', { sipId: sipSession.id });

    // Hold current session if different from the current one (we don't want 2 sessions active at the same time).
    if (this.currentSipSession && this.currentSipSession.id !== sipSession.id) {
      logger$7.info('WebRTC hold call after resume', { id: this.currentSipSession.id });
      this.holdSipSession(
        this.currentSipSession,
        this.currentCallSession,
        withEvent,
      );
    }

    const promise = this.unholdSipSession(sipSession, callSession, withEvent);
    this.currentSipSession = sipSession;
    if (callSession) {
      this.currentCallSession = callSession;
    }

    return promise;
  }

  async holdSipSession(
    sipSession         ,
    callSession              ,
    withEvent          = true,
  )               {
    if (!sipSession) {
      return new Promise((resolve, reject) => reject(new Error('No session to hold')));
    }
    const sessionId = this.getSipSessionId(sipSession);
    const hasVideo = this.client.hasLocalVideo(sessionId);

    logger$7.info('WebRTC hold sip session', { sipId: sipSession.id, hasVideo });

    // Stop screenshare if needed
    if (this.currentScreenShare && this.currentScreenShare.sipSessionId === sessionId) {
      this.lastScreenShare = this.currentScreenShare;
      await this.stopScreenSharing(false, callSession);
    }

    // Downgrade to audio if needed
    if (hasVideo) {
      await this.client.downgradeToAudio(sipSession);
    }

    const isConference = !!callSession && callSession.isConference();

    const promise = this.client.hold(sipSession, isConference, hasVideo);
    if (withEvent) {
      this.eventEmitter.emit(ON_CALL_HELD, this._createCallSession(sipSession, callSession));
    }

    return promise;
  }

  async unholdSipSession(
    sipSession         ,
    callSession              ,
    withEvent          = true,
  )               {
    if (!sipSession) {
      return new Promise((resolve, reject) => reject(new Error('No session to unhold')));
    }

    const isConference = !!callSession && callSession.isConference();

    const sessionId = this.getSipSessionId(sipSession);
    logger$7.info('WebRTC unhold sip session', { sessionId, isConference });

    const { hasVideo } = this.client.getHeldSession(sessionId) || {};
    const wasScreensharing = this.lastScreenShare && this.lastScreenShare.sipSessionId === sessionId;
    const wasDesktop = this.lastScreenShare && this.lastScreenShare.desktop;
    const promise = this.client.unhold(sipSession, isConference);

    if (hasVideo) {
      const constraints = {
        audio: false,
        video: true,
        screen: wasScreensharing,
        desktop: wasDesktop,
      };

      await this.client.upgradeToVideo(sipSession, constraints, isConference);
    }

    const onScreenSharing = stream => {
      const hadVideo = this.lastScreenShare && this.lastScreenShare.hadVideo;
      if (stream) {
        this._onScreenSharing(stream, sipSession, callSession, hadVideo);
      }
      this.lastScreenShare = null;
    };

    if (withEvent) {
      const updatedCallSession = this._createCallSession(sipSession, callSession);
      // Deprecated event
      this.eventEmitter.emit(ON_CALL_UNHELD, updatedCallSession);
      this.eventEmitter.emit(ON_CALL_RESUMED, updatedCallSession);
    }

    return promise.then(() => {
      const stream = callSession ? this.getLocalVideoStream(callSession) : null;
      if (wasScreensharing) {
        onScreenSharing(stream);
      }

      return stream;
    });
  }

  mute(callSession              , withEvent          = true)       {
    logger$7.info('WebRTC mute called', { id: callSession ? callSession.getId() : null });

    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return;
    }

    logger$7.info('WebRTC muting', { sipId: sipSession.id });
    this.client.mute(sipSession);
    const newCallSession = this._createCallSession(sipSession, callSession, { muted: true });

    if (this.currentCallSession && newCallSession.is(this.currentCallSession)) {
      this.currentCallSession = newCallSession;
    }

    if (withEvent) {
      this.eventEmitter.emit(ON_CALL_MUTED, newCallSession);
    }
  }

  unmute(callSession              , withEvent          = true)       {
    logger$7.info('WebRTC unmute called', { id: callSession ? callSession.getId() : null });

    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return;
    }

    logger$7.info('WebRTC unmuting', { sipId: sipSession.id });
    this.client.unmute(sipSession);
    const newCallSession = this._createCallSession(sipSession, callSession, { muted: false });

    if (this.currentCallSession && newCallSession.is(this.currentCallSession)) {
      this.currentCallSession = newCallSession;
    }

    if (withEvent) {
      this.eventEmitter.emit(ON_CALL_UNMUTED, newCallSession);
    }
  }

  isAudioMuted(callSession             )          {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return true;
    }

    return this.client.isAudioMuted(sipSession);
  }

  turnCameraOn(callSession              )       {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return;
    }
    logger$7.info('WebRTC turn camera on', { sipId: sipSession.id });

    this.client.toggleCameraOn(sipSession);

    this.eventEmitter.emit(ON_CAMERA_RESUMED, this._createCameraResumedCallSession(sipSession, callSession));
  }

  turnCameraOff(callSession              )       {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return;
    }
    logger$7.info('WebRTC turn camera off', { sipId: sipSession.id });

    this.client.toggleCameraOff(sipSession);
    this.eventEmitter.emit(ON_CAMERA_DISABLED, this._createCameraDisabledCallSession(sipSession, callSession));
  }

  sendKey(callSession              , tone        )       {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return;
    }

    logger$7.info('WebRTC send key', { sipId: sipSession.id, tone });
    this.client.sendDTMF(sipSession, tone);
  }

  // Should be async to match CTIPhone definition
  // @TODO: line is not used here
  async makeCall(number        , line     , cameraEnabled          ,
    audioOnly          = false, conference          = false)                        {
    logger$7.info('make WebRTC call', { number, lineId: line ? line.id : null, cameraEnabled, audioOnly, conference });
    if (!number) {
      return Promise.resolve(null);
    }

    if (!this.client.isRegistered()) {
      await this.client.register();
    }
    if (this.currentSipSession) {
      this.holdSipSession(
        this.currentSipSession,
        this.currentCallSession,
        true,
      ).catch(e => {
        logger$7.warn('Unable to hold current session when making another call', e);
      });
    }

    let sipSession         ;
    try {
      sipSession = this.client.call(number, this.allowVideo ? cameraEnabled : false, audioOnly, conference);
      this._bindEvents(sipSession);
    } catch (error) {
      console.warn(error);
      logger$7.warn('make WebRTC call, error', { message: error.message, stack: error.stack });
      return Promise.resolve(null);
    }
    const callSession = this._createOutgoingCallSession(sipSession, cameraEnabled || false);
    callSession.setIsConference(conference);
    callSession.creationTime = new Date();
    this._updateCallSession(callSession);

    this.eventEmitter.emit(ON_PLAY_PROGRESS_SOUND, this.audioOutputDeviceId, this.audioOutputVolume);

    this.currentSipSession = sipSession;
    this.currentCallSession = callSession;

    this.eventEmitter.emit(ON_CALL_OUTGOING, callSession);

    // If an invite promise exists, catch exceptions on it to trigger error like OverConstraintsError.
    if (sipSession.invitePromise) {
      sipSession.invitePromise.catch(error => {
        this.eventEmitter.emit(ON_CALL_ERROR, error, callSession);
      });
    }

    return Promise.resolve(callSession);
  }

  transfer(callSession              , target        )       {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      return;
    }

    logger$7.info('WebRTC transfer', { sipId: sipSession.id, target });

    this.client.transfer(sipSession, target);
  }

  async indirectTransfer(source             , destination             )                   {
    const sipSession = this.client.getSipSession(source.sipCallId);
    const sipSessionTarget = this.client.getSipSession(destination.sipCallId);

    logger$7.info('WebRTC indirect transfer', {
      sipId: sipSession ? sipSession.id : null,
      target: sipSessionTarget ? sipSessionTarget.id : null,
    });

    if (!sipSessionTarget) {
      return Promise.reject();
    }

    return new Promise(resolve => {
      const options = {
        requestDelegate: {
          onAccept: () => {
            // Wait a little so the REFER will take effect
            setTimeout(() => {
              this.hangup(destination).then(resolve);
            }, 200);
          },
        },
      };

      return sipSessionTarget.refer(sipSession, options);
    });
  }

  initiateCTIIndirectTransfer() {}

  cancelCTIIndirectTransfer() {}

  confirmCTIIndirectTransfer() {}

  async hangup(callSession              )                   {
    const sipSession = this.findSipSession(callSession);
    if (!sipSession) {
      console.error('Call is unknown to the WebRTC phone', callSession ? callSession.sipCallId : null,
        callSession ? callSession.callId : null);
      return false;
    }

    logger$7.info('WebRTC hangup', { sipId: sipSession.id });

    const sipSessionId = this.getSipSessionId(sipSession);

    await this.client.hangup(sipSession);
    if (callSession) {
      // Removal of `this.callSessions` will be done in `_onCallTerminated`.
      this.endCurrentCall(callSession);
    } else if (sipSessionId) {
      if (callSession) {
        delete this.callSessions[callSession.getId()];
      }
    }

    this.shouldSendReinvite = false;
    return true;
  }

  async getStats(callSession              )                   {
    const sipSession = this.findSipSession(callSession);

    return sipSession ? this.client.getStats(sipSession) : null;
  }

  startNetworkMonitoring(callSession              , interval         = 1000) {
    const sipSession = this.findSipSession(callSession);

    return sipSession ? this.client.startNetworkMonitoring(sipSession, interval) : null;
  }

  stopNetworkMonitoring(callSession              ) {
    const sipSession = this.findSipSession(callSession);

    return sipSession ? this.client.stopNetworkMonitoring(sipSession) : null;
  }

  forceCancel(sipSession         )       {
    if (!sipSession || !sipSession.outgoingInviteRequest) {
      return;
    }
    sipSession.outgoingInviteRequest.cancel();
  }

  endCurrentCall(callSession             )       {
    const isCurrent = this.isCurrentCallSipSession(callSession);

    logger$7.info('Ending current call', {
      id: callSession ? callSession.getId() : null,
      isCurrent,
    });

    if (isCurrent) {
      this.currentSipSession = undefined;
      this.currentCallSession = null;
    }

    this.eventEmitter.emit(ON_TERMINATE_SOUND, callSession, 'locally ended');
  }

  onConnectionMade()       {}

  isConference(callSession              )          {
    if (!callSession) {
      return false;
    }

    return this.client && this.client.isConference(callSession.sipCallId);
  }

  async close(force          = false)                {
    logger$7.info('WebRTC close');

    try {
      await Promise.race([
        this.unregister(),
        new Promise((resolve, reject) => setTimeout(() => reject(new Error('Unregister, timed out')), 3000)),
      ]);
    } catch (e) {
      logger$7.error('WebRTC close, unregister error', e);
    }

    this.client.close(force);
    this.unbind();

    this.incomingSessions = [];
    this.currentSipSession = null;
    this.currentCallSession = null;
    this.shouldSendReinvite = false;
    this.rejectedSessions = {};
  }

  isRegistered()          {
    return this.client && this.client.isRegistered();
  }

  enableRinging()                       {
    logger$7.info('WebRTC enable ringing');
    this.ringingEnabled = true;
  }

  disableRinging()                       {
    logger$7.info('WebRTC disable ringing');
    this.ringingEnabled = false;
  }

  getCurrentCallSession()               {
    if (!this.currentSipSession) {
      return null;
    }

    return this._createCallSession(this.currentSipSession, this.currentCallSession);
  }

  hasIncomingCallSession()          {
    return this.incomingSessions.length > 0;
  }

  getIncomingCallSession()               {
    if (!this.hasIncomingCallSession()) {
      return null;
    }

    const sessionId = this.incomingSessions[0];
    const sipSession = this.client.getSipSession(sessionId);
    if (!sipSession) {
      return null;
    }

    return this._createCallSession(sipSession);
  }

  sendMessage(sipSession          = null, body        , contentType         = 'text/plain') {
    return this.client.sendMessage(sipSession, body, contentType);
  }

  getLocalStream(callSession             )               {
    return callSession ? this.client.getLocalStream(callSession.sipCallId) : null;
  }

  getLocalVideoStream(callSession             )               {
    return callSession ? this.client.getLocalVideoStream(callSession.sipCallId) : null;
  }

  // Deprecated
  getLocalMediaStream(callSession             ) {
    logger$7.warn('WebRTCPhone.getLocalMediaStream is deprecated, use WebRTCPhone.getLocalStream instead');
    return this.getLocalStream(callSession);
  }

  hasLocalVideo(callSession             ) {
    return callSession ? this.client.hasLocalVideo(callSession.sipCallId) : null;
  }

  hasALocalVideoTrack(callSession             ) {
    return callSession ? this.client.hasALocalVideoTrack(callSession.sipCallId) : null;
  }

  getRemoteStream(callSession             )               {
    return callSession ? this.client.getRemoteStream(callSession.sipCallId) : null;
  }

  getRemoteVideoStream(callSession             )               {
    return callSession ? this.client.getRemoteVideoStream(callSession.sipCallId) : null;
  }

  getRemoteVideoStreamFromPc(callSession             )               {
    return callSession ? this.client.getRemoteVideoStreamFromPc(callSession.sipCallId) : null;
  }

  hasRemoteVideo(callSession             )          {
    return callSession ? this.client.hasRemoteVideo(callSession.sipCallId) : false;
  }

  setMediaConstraints(media                        ) {
    this.client.setMediaConstraints(media);
  }

  isVideoRemotelyHeld(callSession             ) {
    return callSession ? this.client.isVideoRemotelyHeld(callSession.sipCallId) : null;
  }

  bindClientEvents() {
    this.client.unbind();

    this.client.on(this.client.INVITE, (sipSession         , wantsToDoVideo         ) => {
      const autoAnswer = sipSession.request.getHeader('Answer-Mode') === 'Auto';
      const withVideo = this.allowVideo ? wantsToDoVideo : false;
      logger$7.info('WebRTC invite received', { sipId: sipSession.id, withVideo, autoAnswer });

      const callSession = this._createIncomingCallSession(sipSession, withVideo, null, autoAnswer);
      this.incomingSessions.push(callSession.getId());
      this._bindEvents(sipSession);

      this.client.storeSipSession(sipSession);

      if (!this.currentSipSession) {
        if (this.ringingEnabled) {
          this.eventEmitter.emit(ON_PLAY_RING_SOUND, this.audioRingDeviceId, this.audioRingVolume, callSession);
        }
      } else {
        this.eventEmitter.emit(ON_PLAY_INBOUND_CALL_SIGNAL_SOUND,
          this.audioOutputDeviceId,
          this.audioOutputVolume,
          callSession);
      }

      callSession.creationTime = new Date();
      this._updateCallSession(callSession);

      this.eventEmitter.emit(ON_CALL_INCOMING, callSession, wantsToDoVideo);
    });

    this.client.on(this.client.ON_REINVITE, (...args) => {
      logger$7.info('WebRTC on reinvite', {
        sessionId: args[0].id,
        inviteId: args[1].id,
        updatedCalleeName: args[2],
        updatedNumber: args[3],
      });

      const sipSession = args[0];

      // Give some time for the stream to be mounted.
      // if `_createCallSession` is called too soon `hasVideo` will return false because the stream doesn't exists yet
      setTimeout(() => {
        // Update callSession
        this._createCallSession(sipSession, this.callSessions[this.getSipSessionId(sipSession)]);

        this.eventEmitter.emit.apply(this.eventEmitter, [this.client.ON_REINVITE, ...args]);
      }, 2000);
    });

    this.client.on(this.client.ACCEPTED, (sipSession         ) => {
      const sessionId = this.getSipSessionId(sipSession);
      const hasSession = sessionId in this.callSessions;

      logger$7.info('WebRTC call accepted', { sipId: sessionId, hasSession });

      if (!hasSession) {
        logger$7.warn('Call accepted ignored, session is no longer present in the WebRtcPhone', { sessionId });
        return;
      }

      this._onCallAccepted(sipSession, this.client.hasVideo(sessionId));

      if (this.audioOutputDeviceId) {
        this.client.changeAudioOutputDevice(this.audioOutputDeviceId);
      }
    });
    this.client.on('ended', () => {});

    this.client.on(this.client.ON_ERROR, e => {
      logger$7.error('WebRTC error', e);
      this.eventEmitter.emit(ON_CALL_ERROR, e);
    });

    this.client.on(this.client.REJECTED, session => {
      logger$7.info('WebRTC call rejected', session.id);
      const callSession = this._createCallSession(session);
      callSession.endTime = new Date();
      this._updateCallSession(callSession);

      this.eventEmitter.emit(ON_CALL_REJECTED, callSession);
    });

    this.client.on(this.client.UNREGISTERED, () => {
      logger$7.info('WebRTC unregistered');
      this.eventEmitter.emit(ON_UNREGISTERED);
    });

    this.client.on(this.client.ON_DISCONNECTED, () => {
      logger$7.info('WebRTC disconnected');
      this.eventEmitter.emit(ON_DISCONNECTED);
    });
    this.client.on(this.client.ON_EARLY_MEDIA, session => {
      logger$7.info('WebRTC early media');
      const callSession = this._createCallSession(session);
      this.eventEmitter.emit(ON_EARLY_MEDIA, callSession);
    });

    this.client.on(this.client.REGISTERED, () => {
      logger$7.info('WebRTC registered', {
        shouldSendReinvite: this.shouldSendReinvite,
        state: this.currentSipSession ? this.currentSipSession.state : null,
        currentSipSession: !!this.currentSipSession,
      });
      this.stopHeartbeat();
      this.eventEmitter.emit(ON_REGISTERED);

      // If the phone registered with a current callSession (eg: when switching network):
      // send a reinvite to renegociate ICE with new IP
      if (this.shouldSendReinvite && this.currentSipSession
        && this.currentSipSession.state === sessionState.SessionState.Established) {
        this.shouldSendReinvite = false;
        const pc = this.currentSipSession.sessionDescriptionHandler.peerConnection;
        const isConference = pc ? pc.sfu : false;
        const hasVideo = this.currentCallSession && this.currentCallSession.cameraEnabled;

        try {
          // Send reinvite with iceRestart
          this.sendReinvite(this.currentCallSession, null, isConference, !hasVideo, true);
        } catch (e) {
          logger$7.error('WebRTC reinvite after register, error', { message: e.message, stack: e.stack });
        }
      }
    });

    this.client.on(this.client.CONNECTED, () => {
      logger$7.info('WebRTC client connected');

      this.stopHeartbeat();
    });

    this.client.on(this.client.DISCONNECTED, () => {
      logger$7.info('WebRTC client disconnected');

      this.eventEmitter.emit(ON_UNREGISTERED);

      // Do not trigger heartbeat if already running
      if (!this.client.hasHeartbeat()) {
        this.startHeartbeat();
      }

      // Tell to send reinvite when reconnecting
      this.shouldSendReinvite = true;
    });

    this.client.on(this.client.ON_TRACK, (session, event) => {
      this.eventEmitter.emit(ON_TRACK, session, event);
    });

    this.client.on('onVideoInputChange', stream => {
      this.eventEmitter.emit(ON_VIDEO_INPUT_CHANGE, stream);
    });

    this.client.on(this.client.MESSAGE, (message         ) => {
      this._onMessage(message);
      this.eventEmitter.emit(ON_MESSAGE, message);
    });

    this.client.on(this.client.ON_NETWORK_STATS, (session, stats, previousStats) => {
      const callSession = this.getCallSession(this.getSipSessionId(session));

      this.eventEmitter.emit(ON_NETWORK_STATS, callSession, stats, previousStats);
    });

    // Used when upgrading directly in screenshare mode
    this.client.on(this.client.ON_SCREEN_SHARING_REINVITE, (sipSession         , response     , desktop         ) => {
      const sipSessionId = this.getSipSessionId(sipSession);
      const localStream = this.client.getLocalStream(sipSessionId);
      const callSession = this.callSessions[sipSessionId];

      logger$7.info('Updrading directly in screensharing mode', {
        sipSessionId,
        tracks: localStream ? localStream.getTracks() : null,
      });

      this._onScreenSharing(localStream, sipSession, callSession, false, desktop);
    });
  }

  // Find a corresponding sipSession from a CallSession
  findSipSession(callSession              )           {
    const keys = this.client.getSipSessionIds();
    const keyIndex = keys.findIndex(sessionId => callSession && callSession.isId(sessionId));

    if (keyIndex === -1) {
      const currentSipSessionId = this.currentSipSession
        ? this.getSipSessionId(this.currentSipSession)
        : this.client.getSipSessionIds()[0];
      return currentSipSessionId ? this.client.getSipSession(currentSipSessionId) : null;
    }

    return this.client.getSipSession(keys[keyIndex]);
  }

  getCallSession(sipSessionId        )               {
    return this.callSessions[sipSessionId];
  }

  getSipSessionId(sipSession         ) {
    return this.client.getSipSessionId(sipSession);
  }

  getSipSessionIdFromCallSession(callSession             ) {
    const sipSession = this.findSipSession(callSession);

    return sipSession ? this.getSipSessionId(sipSession) : null;
  }

  _updateCallSession(callSession             ) {
    const sipSessionId = this.getSipSessionIdFromCallSession(callSession);

    if (sipSessionId) {
      this.callSessions[sipSessionId] = callSession;
    }
  }

  _onMessage(message         ) {
    if (!message || message.method !== 'MESSAGE') {
      return;
    }

    let body;

    try {
      body = JSON.parse(message.body);
    } catch (e) {
      return;
    }

    const { type, content } = body;

    switch (type) {
      case MESSAGE_TYPE_CHAT:
        this.eventEmitter.emit(ON_CHAT, content);
        break;

      case MESSAGE_TYPE_SIGNAL: {
        this.eventEmitter.emit(ON_SIGNAL, content);
        break;
      }
    }
  }

  _createIncomingCallSession(
    sipSession         ,
    cameraEnabled         ,
    fromSession               ,
    autoAnswer          = false,
  )              {
    return this._createCallSession(sipSession, fromSession, {
      incoming: true,
      ringing: true,
      cameraEnabled,
      autoAnswer,
    });
  }

  _createOutgoingCallSession(
    sipSession         ,
    cameraEnabled         ,
    fromSession              ,
  )              {
    return this._createCallSession(sipSession, fromSession, { incoming: false, ringing: true, cameraEnabled });
  }

  _createAcceptedCallSession(
    sipSession         ,
    cameraEnabled          ,
    fromSession              ,
  )              {
    return this._createCallSession(sipSession, fromSession, {
      cameraEnabled: cameraEnabled !== undefined ? cameraEnabled : false,
    });
  }

  _createMutedCallSession(sipSession         , fromSession              )              {
    return this._createCallSession(sipSession, fromSession, {
      muted: true,
    });
  }

  _createUnmutedCallSession(sipSession         , fromSession              )              {
    return this._createCallSession(sipSession, fromSession, {
      muted: false,
    });
  }

  _createCameraResumedCallSession(sipSession         , fromSession              )              {
    return this._createCallSession(sipSession, fromSession, {
      videoMuted: false,
    });
  }

  _createCameraDisabledCallSession(sipSession         , fromSession              )              {
    return this._createCallSession(sipSession, fromSession, {
      videoMuted: true,
    });
  }

  _createCallSession(sipSession         , fromSession               , extra         = {})              {
    // eslint-disable-next-line
    const identity = sipSession ? sipSession.remoteIdentity || sipSession.assertedIdentity : null;
    const number = identity ? identity.uri._normal.user : null;
    const { state } = sipSession || {};
    const sessionId = this.getSipSessionId(sipSession);
    fromSession = fromSession || this.callSessions[sessionId];

    const callSession = new CallSession({
      callId: fromSession && fromSession.callId,
      sipCallId: sessionId,
      sipStatus: state,
      displayName: identity ? identity.displayName || number : number,
      startTime: fromSession ? fromSession.startTime : new Date(),
      creationTime: fromSession ? fromSession.creationTime : null,
      answerTime: fromSession ? fromSession.answerTime : null,
      endTime: fromSession ? fromSession.endTime : null,
      answered: state === sessionState.SessionState.Established,
      paused: this.client.isCallHeld(sipSession),
      isCaller: fromSession ? fromSession.isCaller : ('incoming' in extra ? !extra.incoming : false),
      cameraEnabled: fromSession ? fromSession.isCameraEnabled() : this.client.hasVideo(sessionId),
      number,
      ringing: false,
      muted: fromSession ? fromSession.isMuted() : this.client.isAudioMuted(sipSession),
      videoMuted: fromSession ? fromSession.isVideoMuted() : false,
      recording: fromSession ? fromSession.isRecording() : false,
      recordingPaused: false, // @TODO
      sipSession,
      conference: !!fromSession && fromSession.isConference(),
      ...extra,
    });

    this.callSessions[callSession.getId()] = callSession;

    return callSession;
  }
}

var PHONE_EVENTS = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ON_USER_AGENT: ON_USER_AGENT,
  ON_REGISTERED: ON_REGISTERED,
  ON_UNREGISTERED: ON_UNREGISTERED,
  ON_PROGRESS: ON_PROGRESS,
  ON_CALL_ACCEPTED: ON_CALL_ACCEPTED,
  ON_CALL_ANSWERED: ON_CALL_ANSWERED,
  ON_CALL_INCOMING: ON_CALL_INCOMING,
  ON_CALL_OUTGOING: ON_CALL_OUTGOING,
  ON_CALL_MUTED: ON_CALL_MUTED,
  ON_CALL_UNMUTED: ON_CALL_UNMUTED,
  ON_CALL_RESUMED: ON_CALL_RESUMED,
  ON_CALL_HELD: ON_CALL_HELD,
  ON_CALL_UNHELD: ON_CALL_UNHELD,
  ON_CAMERA_DISABLED: ON_CAMERA_DISABLED,
  ON_CAMERA_RESUMED: ON_CAMERA_RESUMED,
  ON_CALL_CANCELED: ON_CALL_CANCELED,
  ON_CALL_FAILED: ON_CALL_FAILED,
  ON_CALL_REJECTED: ON_CALL_REJECTED,
  ON_CALL_ENDED: ON_CALL_ENDED,
  ON_CALL_ENDING: ON_CALL_ENDING,
  ON_MESSAGE: ON_MESSAGE,
  ON_REINVITE: ON_REINVITE,
  ON_TRACK: ON_TRACK,
  ON_AUDIO_STREAM: ON_AUDIO_STREAM,
  ON_VIDEO_STREAM: ON_VIDEO_STREAM,
  ON_REMOVE_STREAM: ON_REMOVE_STREAM,
  ON_SHARE_SCREEN_STARTED: ON_SHARE_SCREEN_STARTED,
  ON_SHARE_SCREEN_ENDING: ON_SHARE_SCREEN_ENDING,
  ON_SHARE_SCREEN_ENDED: ON_SHARE_SCREEN_ENDED,
  ON_TERMINATE_SOUND: ON_TERMINATE_SOUND,
  ON_PLAY_RING_SOUND: ON_PLAY_RING_SOUND,
  ON_PLAY_INBOUND_CALL_SIGNAL_SOUND: ON_PLAY_INBOUND_CALL_SIGNAL_SOUND,
  ON_PLAY_HANGUP_SOUND: ON_PLAY_HANGUP_SOUND,
  ON_PLAY_PROGRESS_SOUND: ON_PLAY_PROGRESS_SOUND,
  ON_VIDEO_INPUT_CHANGE: ON_VIDEO_INPUT_CHANGE,
  ON_CALL_ERROR: ON_CALL_ERROR,
  ON_MESSAGE_TRACK_UPDATED: ON_MESSAGE_TRACK_UPDATED,
  ON_NETWORK_STATS: ON_NETWORK_STATS,
  ON_CHAT: ON_CHAT,
  ON_SIGNAL: ON_SIGNAL,
  ON_DISCONNECTED: ON_DISCONNECTED,
  ON_EARLY_MEDIA: ON_EARLY_MEDIA,
  MESSAGE_TYPE_CHAT: MESSAGE_TYPE_CHAT,
  MESSAGE_TYPE_SIGNAL: MESSAGE_TYPE_SIGNAL,
  events: events,
  'default': WebRTCPhone
});

/*       */
class SFUNotAvailableError extends Error {
  constructor(message         = 'Sorry your user is not configured to support video conference') {
    super(message);
    this.name = 'SFUNotAvailableError';
  }
}

//      

const logger$6 = IssueReporter$1.loggerFor('simple-phone');
const sipLogger = IssueReporter$1.loggerFor('sip.js');
const protocolLogger = IssueReporter$1.loggerFor('sip');

const protocolDebugMessages = ['Received WebSocket text message:', 'Sending WebSocket message:'];

class Phone extends Emitter {
                           
                      
                   
                    

                  
                    
                       

  constructor() {
    super();

    // Sugar syntax for `Wazo.Phone.EVENT_NAME`
    Object.keys(PHONE_EVENTS).forEach(key => {
      // $FlowFixMe
      this[key] = PHONE_EVENTS[key];
    });

    this.SessionState = sessionState.SessionState;
  }

  async connect(options         = {}, sipLine           = null) {
    if (this.phone) {
      // Already connected

      // let's update media constraints if they're being fed
      if (options.media) {
        this.phone.setMediaConstraints(options.media);
      }

      return;
    }

    const server = Wazo.Auth.getHost();
    const session = Wazo.Auth.getSession();
    if (!server || !session) {
      throw new Error('Please connect to the server using `Wazo.Auth.logIn` or `Wazo.Auth.authenticate` '
        + 'before using Room.connect().');
    }

    this.session = session;
    this.sipLine = sipLine || this.getPrimaryWebRtcLine();

    if (!this.sipLine) {
      throw new Error('Sorry, no sip lines found for this user');
    }

    this.connectWithCredentials(server, this.sipLine, session.displayName(), options);
  }

  connectWithCredentials(server        , sipLine         , displayName        , rawOptions         = {}) {
    if (this.phone) {
      // Already connected
      return;
    }
    const [host, port = 443] = server.split(':');

    const options = rawOptions;
    options.media = options.media || { audio: true, video: false };
    options.uaConfigOverrides = options.uaConfigOverrides || {};

    if (IssueReporter$1.enabled) {
      options.uaConfigOverrides.traceSip = true;
      options.log = options.log || {};

      options.log.builtinEnabled = false;
      options.log.logLevel = 'debug';
      options.log.connector = (level, className, label, content) => {
        const protocolIndex = content && content.indexOf
          ? protocolDebugMessages.findIndex(prefix => content.indexOf(prefix) !== -1) : -1;

        if (className === 'sip.Transport' && protocolIndex !== -1) {
          const direction = protocolIndex === 0 ? 'receiving' : 'sending';
          const message = content.replace(`${protocolDebugMessages[protocolIndex]}\n\n`, '').replace('\r\n', '\n');

          protocolLogger.trace(message, { className, direction });
        } else {
          sipLogger.trace(content, { className });
        }
      };
    }

    this.client = new WebRTCClient({
      host,
      port,
      displayName,
      authorizationUser: sipLine.username,
      password: sipLine.secret,
      uri: `${sipLine.username}@${server}`,
      ...options,
    }, null, options.uaConfigOverrides);

    this.phone = new WebRTCPhone(this.client, options.audioDeviceOutput, true, options.audioDeviceRing);

    this._transferEvents();
  }

  async disconnect() {
    if (this.phone) {
      if (this.phone.hasAnActiveCall()) {
        logger$6.info('hangup call on disconnect');
        // $FlowFixMe
        await this.phone.hangup();
      }
      // $FlowFixMe
      await this.phone.close();
    }

    this.phone = null;
  }

  // If audioOnly is set to true, all video stream will be deactivated, even remotes ones.
  async call(extension        , withCamera          = false, rawSipLine           = null, audioOnly          = false,
    conference          = false) {
    if (!this.phone) {
      return;
    }
    const sipLine = rawSipLine || this.getPrimaryWebRtcLine();

    return this.phone.makeCall(extension, sipLine, withCamera, audioOnly, conference);
  }

  async hangup(callSession             ) {
    logger$6.info('hangup via simple phone', { callId: callSession.getId() });

    return this.phone && this.phone.hangup(callSession);
  }

  async accept(callSession             , cameraEnabled          ) {
    logger$6.info('accept via simple phone', { callId: callSession.getId(), cameraEnabled });

    return this.phone && this.phone.accept(callSession, cameraEnabled);
  }

  async startConference(host             , otherCalls               )                              {
    const participants = [host, ...otherCalls].reduce((acc        , participant             ) => {
      acc[participant.getTalkingToIds()[0]] = participant;
      return acc;
    }, {});

    if (!this.phone) {
      return Promise.reject();
    }

    const adHocConference = new AdHocAPIConference({ phone: this.phone, host, participants });

    return adHocConference.start();
  }

  mute(callSession             , withApi          = true) {
    if (withApi) {
      this.muteViaAPI(callSession);
    }

    return this.phone && this.phone.mute(callSession);
  }

  unmute(callSession             , withApi          = true) {
    if (withApi) {
      this.unmuteViaAPI(callSession);
    }

    return this.phone && this.phone.unmute(callSession);
  }

  muteViaAPI(callSession             ) {
    if (callSession && callSession.callId) {
      Wazo.getApiClient().calld.mute(callSession.callId).catch(e => {
        logger$6.error('Mute via API, error', e);
      });
    }
  }

  unmuteViaAPI(callSession             ) {
    if (callSession && callSession.callId) {
      Wazo.getApiClient().calld.unmute(callSession.callId).catch(e => {
        logger$6.error('Unmute via API, error', e);
      });
    }
  }

  hold(callSession             ) {
    return this.phone && this.phone.hold(callSession, true);
  }

  unhold(callSession             ) {
    return this.phone && this.phone.unhold(callSession, true);
  }

  resume(callSession             ) {
    return this.phone && this.phone.resume(callSession);
  }

  reject(callSession             ) {
    return this.phone && this.phone.reject(callSession);
  }

  transfer(callSession             , target        ) {
    return this.phone && this.phone.transfer(callSession, target);
  }

  atxfer(sipSession                      ) {
    return this.phone && this.phone.atxfer(sipSession);
  }

  async reinvite(callSession             , constraints         = null, conference          = false) {
    return this.phone ? this.phone.sendReinvite(callSession, constraints, conference) : null;
  }

  async getStats(callSession             ) {
    return this.phone ? this.phone.getStats(callSession) : null;
  }

  startNetworkMonitoring(callSession             , interval         = 1000) {
    return this.phone ? this.phone.startNetworkMonitoring(callSession, interval) : null;
  }

  stopNetworkMonitoring(callSession             ) {
    return this.phone ? this.phone.stopNetworkMonitoring(callSession) : null;
  }

  getSipSessionId(sipSession         )          {
    return this.phone ? this.phone.getSipSessionId(sipSession) : null;
  }

  sendMessage(body        , sipSession                       = null, contentType         = 'text/plain') {
    const toSipSession = sipSession || this.getCurrentSipSession();
    if (!toSipSession || !this.phone) {
      return null;
    }

    return this.phone.sendMessage(toSipSession, body, contentType);
  }

  sendChat(content        , sipSession                       = null) {
    return this.sendMessage(
      JSON.stringify({ type: MESSAGE_TYPE_CHAT, content }),
      sipSession,
      'application/json',
    );
  }

  sendSignal(content     , sipSession                       = null) {
    return this.sendMessage(
      JSON.stringify({ type: MESSAGE_TYPE_SIGNAL, content }),
      sipSession,
      'application/json',
    );
  }

  turnCameraOff(callSession             ) {
    return this.phone && this.phone.turnCameraOff(callSession);
  }

  turnCameraOn(callSession             ) {
    return this.phone && this.phone.turnCameraOn(callSession);
  }

  async startScreenSharing(constraints        , callSession              ) {
    return this.phone && this.phone.startScreenSharing(constraints, callSession);
  }

  stopScreenSharing(callSession              , restoreLocalStream          = true) {
    return this.phone && this.phone.stopScreenSharing(restoreLocalStream, callSession);
  }

  sendDTMF(tone        , callSession             ) {
    return this.phone && this.phone.sendKey(callSession, tone);
  }

  getLocalStream(callSession             ) {
    return this.phone && this.phone.getLocalStream(callSession);
  }

  hasLocalVideo(callSession             ) {
    return this.phone && this.phone.hasLocalVideo(callSession);
  }

  hasALocalVideoTrack(callSession             ) {
    return this.phone && this.phone.hasALocalVideoTrack(callSession);
  }

  // @Deprecated
  getLocalMediaStream(callSession             ) {
    logger$6.warn('Phone.getLocalMediaStream is deprecated, use Phone.getLocalStream instead');

    return this.phone && this.phone.getLocalStream(callSession);
  }

  getLocalVideoStream(callSession             ) {
    return this.phone && this.phone.getLocalVideoStream(callSession);
  }

  getRemoteStream(callSession             ) {
    return this.phone ? this.phone.getRemoteStream(callSession) : null;
  }

  getRemoteVideoStream(callSession             ) {
    return this.phone ? this.phone.getRemoteVideoStream(callSession) : null;
  }

  isVideoRemotelyHeld(callSession             ) {
    return this.phone ? this.phone.isVideoRemotelyHeld(callSession) : null;
  }

  // @Deprecated
  getRemoteStreamForCall(callSession             ) {
    logger$6.warn('Phone.getRemoteStreamForCall is deprecated, use Phone.getRemoteStream instead');
    return this.getRemoteStream(callSession);
  }

  // Returns remote streams directly from the peerConnection
  // @Deprecated
  getRemoteStreamsForCall(callSession             ) {
    logger$6.warn('Phone.getRemoteStreamsForCall is deprecated, use Phone.getLocalStream instead');
    return this.getLocalStream(callSession);
  }

  // @Deprecated
  getRemoteVideoStreamForCall(callSession             ) {
    logger$6.warn('Phone.getRemoteVideoStreamForCall is deprecated, use Phone.getRemoteVideoStream instead');

    return this.getRemoteVideoStream(callSession);
  }

  //  Useful in a react-native environment when remoteMediaStream is not updated
  getRemoteVideoStreamFromPc(callSession             ) {
    return this.phone ? this.phone.getRemoteVideoStreamFromPc(callSession) : false;
  }

  hasVideo(callSession             )          {
    return this.phone ? this.phone.hasVideo(callSession) : false;
  }

  hasAVideoTrack(callSession             )          {
    return this.phone ? this.phone.hasAVideoTrack(callSession) : false;
  }

  getCurrentSipSession() {
    return this.phone ? this.phone.currentSipSession : null;
  }

  getPrimaryWebRtcLine() {
    const session = Wazo.Auth.getSession();
    return session ? session.primaryWebRtcLine() : null;
  }

  getOutputDevice() {
    return this.phone ? this.phone.audioOutputDeviceId : null;
  }

  getPrimaryLine() {
    const session = Wazo.Auth.getSession();
    return session ? session.primarySipLine() : null;
  }

  getLineById(lineId        ) {
    return this.getSipLines().find(line => line && line.id === lineId);
  }

  getSipLines() {
    const session = Wazo.Auth.getSession();
    if (!session) {
      return [];
    }

    return session.profile ? session.profile.sipLines : [];
  }

  hasSfu() {
    return this.sipLine && this.sipLine.hasVideoConference();
  }

  checkSfu() {
    if (!this.hasSfu()) {
      throw new SFUNotAvailableError();
    }
  }

  _transferEvents() {
    this.unbind();
    [...events$1, ...transportEvents].forEach(event => {
      this.client.on(event, (...args) =>
        this.eventEmitter.emit.apply(this.eventEmitter.emit, [`client-${event}`, ...args]));
    });

    Object.values(PHONE_EVENTS).forEach(event => {
      if (typeof event !== 'string' || !this.phone) {
        return;
      }
      this.phone.on(event, (...args) => this.eventEmitter.emit.apply(this.eventEmitter, [event, ...args]));
    });
  }
}

if (!global.wazoTelephonyInstance) {
  global.wazoTelephonyInstance = new Phone();
}

var Phone$1 = global.wazoTelephonyInstance;

//      

const SOCKET_EVENTS$1 = {
  ON_OPEN: 'onopen',
  ON_MESSAGE: 'onmessage',
  ON_ERROR: 'onerror',
  ON_CLOSE: 'onclose',
  INITIALIZED: 'initialized',
  ON_AUTH_FAILED: 'on_auth_failed',
};

                  
               
                
                        
                   
               
                  
                    
                
    
  

const AUTH_SESSION_EXPIRE_SOON = 'auth_session_expire_soon';
const FAVORITE_ADDED = 'favorite_added';
const FAVORITE_DELETED = 'favorite_deleted';
const USER_STATUS_UPDATE = 'user_status_update';
const CHAT_MESSAGE_SENT = 'chat_message_sent';
const CHAT_MESSAGE_RECEIVED = 'chat_message_received';
const ENDPOINT_STATUS_UPDATE = 'endpoint_status_update';
const USERS_FORWARDS_BUSY_UPDATED = 'users_forwards_busy_updated';
const USERS_FORWARDS_NOANSWER_UPDATED = 'users_forwards_noanswer_updated';
const USERS_FORWARDS_UNCONDITIONAL_UPDATED = 'users_forwards_unconditional_updated';
const USERS_SERVICES_DND_UPDATED = 'users_services_dnd_updated';
const USER_VOICEMAIL_MESSAGE_CREATED = 'user_voicemail_message_created';
const USER_VOICEMAIL_MESSAGE_UPDATED = 'user_voicemail_message_updated';
const USER_VOICEMAIL_MESSAGE_DELETED = 'user_voicemail_message_deleted';
const CALL_LOG_USER_CREATED = 'call_log_user_created';
const CALL_CREATED = 'call_created';
const CALL_ANSWERED = 'call_answered';
const CALL_DTMF_CREATED = 'call_dtmf_created';
const CALL_ENDED = 'call_ended';
const CALL_UPDATED = 'call_updated';
const CALL_HELD = 'call_held';
const CALL_RESUMED = 'call_resumed';
const AUTH_USER_EXTERNAL_AUTH_ADDED = 'auth_user_external_auth_added';
const AUTH_USER_EXTERNAL_AUTH_DELETED = 'auth_user_external_auth_deleted';
const CHATD_PRESENCE_UPDATED = 'chatd_presence_updated';
const CHATD_USER_ROOM_MESSAGE_CREATED = 'chatd_user_room_message_created';
const CHATD_USER_ROOM_CREATED = 'chatd_user_room_created';
const CONFERENCE_USER_PARTICIPANT_JOINED = 'conference_user_participant_joined';
const CONFERENCE_USER_PARTICIPANT_LEFT = 'conference_user_participant_left';
const CONFERENCE_USER_PARTICIPANT_TALK_STARTED = 'conference_user_participant_talk_started';
const CONFERENCE_USER_PARTICIPANT_TALK_STOPPED = 'conference_user_participant_talk_stopped';
const MEETING_USER_PARTICIPANT_JOINED = 'meeting_user_participant_joined';
const MEETING_USER_PARTICIPANT_LEFT = 'meeting_user_participant_left';
const SWITCHBOARD_QUEUED_CALLS_UPDATED = 'switchboard_queued_calls_updated';
const SWITCHBOARD_QUEUED_CALL_ANSWERED = 'switchboard_queued_call_answered';
const SWITCHBOARD_HELD_CALLS_UPDATED = 'switchboard_held_calls_updated';
const SWITCHBOARD_HELD_CALL_ANSWERED = 'switchboard_held_call_answered';
const FAX_OUTBOUND_USER_CREATED = 'fax_outbound_user_created';
const FAX_OUTBOUND_USER_SUCCEEDED = 'fax_outbound_user_succeeded';
const FAX_OUTBOUND_USER_FAILED = 'fax_outbound_user_failed';
const APPLICATION_CALL_DTMF_RECEIVED = 'application_call_dtmf_received';
const APPLICATION_CALL_ENTERED = 'application_call_entered';
const APPLICATION_CALL_INITIATED = 'application_call_initiated';
const APPLICATION_CALL_DELETED = 'application_call_deleted';
const APPLICATION_CALL_UPDATED = 'application_call_updated';
const APPLICATION_CALL_ANSWERED = 'application_call_answered';
const APPLICATION_PROGRESS_STARTED = 'application_progress_started';
const APPLICATION_PROGRESS_STOPPED = 'application_progress_stopped';
const APPLICATION_DESTINATION_NODE_CREATED = 'application_destination_node_created';
const APPLICATION_NODE_CREATED = 'application_node_created';
const APPLICATION_NODE_DELETED = 'application_node_deleted';
const APPLICATION_NODE_UPDATED = 'application_node_updated';
const APPLICATION_PLAYBACK_CREATED = 'application_playback_created';
const APPLICATION_PLAYBACK_DELETED = 'application_playback_deleted';
const APPLICATION_SNOOP_CREATED = 'application_snoop_created';
const APPLICATION_SNOOP_DELETED = 'application_snoop_deleted';
const APPLICATION_SNOOP_UPDATED = 'application_snoop_updated';
const APPLICATION_USER_OUTGOING_CALL_CREATED = 'application_user_outgoing_call_created';
const TRUNK_STATUS_UPDATED = 'trunk_status_updated';
const LINE_STATUS_UPDATED = 'line_status_updated';
const AGENT_STATUS_UPDATE = 'agent_status_update';
const AGENT_PAUSED = 'agent_paused';
const AGENT_UNPAUSED = 'agent_unpaused';
const CONFERENCE_ADHOC_PARTICIPANT_LEFT = 'conference_adhoc_participant_left';
const CONFERENCE_ADHOC_DELETED = 'conference_adhoc_deleted';
const MEETING_USER_PROGRESS = 'meeting_user_progress';
const MEETING_USER_GUEST_AUTHORIZATION_CREATED = 'meeting_user_guest_authorization_created';

const BLACKLIST_EVENTS = [
  CHAT_MESSAGE_SENT,
  CHAT_MESSAGE_RECEIVED,
  CHATD_USER_ROOM_MESSAGE_CREATED,
  CHATD_USER_ROOM_CREATED,
];

const HEARTBEAT_ENGINE_VERSION = '20.09';
const logger$5 = IssueReporter$1.loggerFor('wazo-ws');
const messageLogger = IssueReporter$1.loggerFor('wazo-ws-message');

class WebSocketClient extends Emitter {
                       
                
                  
                 
                        
                  
                                 
                              
                       
                               
                        
                       

                                   

  /**
   *
   * @param host
   * @param token
   * @param events
   * @param version
   * @param heartbeat
   * @param options @see https://github.com/pladaria/reconnecting-websocket#available-options
   */
  constructor({ host, token, version = 1, events = [], heartbeat = {} }           , options         = {}) {
    super();
    this.initialized = false;

    this.socket = null;
    this.host = host;
    this.token = token;
    this.events = events;
    this.options = options;
    this.version = version;

    this._boundOnHeartbeat = this._onHeartbeat.bind(this);
    const { delay, timeout, max } = heartbeat;
    this.heartbeat = new Heartbeat(delay, timeout, max);
    this.heartbeat.setSendHeartbeat(this.pingServer.bind(this));
    this.heartbeat.setOnHeartbeatTimeout(this._onHeartbeatTimeout.bind(this));

    this.eventLists = WebSocketClient.eventLists;
  }

  connect() {
    logger$5.info('connect method started', { host: this.host, token: this.token });
    this.socket = new ReconnectingWebSocket__default['default'](this._getUrl.bind(this), [], this.options);
    if (this.options.binaryType) {
      this.socket.binaryType = this.options.binaryType;
    }

    this.socket.onopen = () => {
      logger$5.info('on Wazo WS open', { method: 'connect', host: this.host });
      this.eventEmitter.emit(SOCKET_EVENTS$1.ON_OPEN);
    };

    this.socket.onerror = event => {
      logger$5.error('on Wazo WS error', event.target);
      this.eventEmitter.emit(SOCKET_EVENTS$1.ON_ERROR, event);
    };

    this.socket.onmessage = (event              ) => {
      this.eventEmitter.emit(SOCKET_EVENTS$1.ON_MESSAGE, event.data);

      const message = JSON.parse(typeof event.data === 'string' ? event.data : '{}');
      let { name } = message;
      if (message.data && message.data.name) {
        // eslint-disable-next-line
        name = message.data.name;
      }

      if (BLACKLIST_EVENTS.indexOf(name) === -1) {
        // $FlowFixMe
        messageLogger.trace(IssueReporter$1.removeSlashes(event.data), { method: 'onmessage' });
      } else {
        messageLogger.trace(`{"name": "${name}", "info": "content not shown"}`, { method: 'onmessage' });
      }

      if (!this.initialized) {
        this._handleInitMessage(message, this.socket);
      } else {
        this._handleMessage(message);
      }
    };

    this.socket.onclose = event => {
      // Can't be converted to JSON (circular structure)
      logger$5.info('on Wazo WS close', {
        reason: event.reason,
        code: event.code,
        readyState: event.target.readyState,
        host: this.host,
        token: this.token,
      });
      this.initialized = false;
      this.eventEmitter.emit(SOCKET_EVENTS$1.ON_CLOSE, event);

      switch (event.code) {
        case 4002:
          this.eventEmitter.emit(SOCKET_EVENTS$1.ON_AUTH_FAILED);
          break;
      }
    };

    this.socket.onerror = event => {
      logger$5.info('Wazo WS error', { message: event.message, code: event.code, readyState: event.target.readyState });
    };
  }

  close(force          = false)       {
    logger$5.info('Wazo WS close', { socket: !!this.socket, host: this.host, token: this.token });

    if (!this.socket) {
      return;
    }

    this.socket.close();
    this.initialized = false;

    if (force) {
      this.host = null;
      this.token = null;
      this.socket = null;
    }
  }

  updateToken(token        ) {
    this.token = token;
    logger$5.info('Wazo WS updating token', { url: this._getUrl(), token, socket: !!this.socket });

    if (this.socket) {
      // If still connected, send the token to the WS
      if (this.isConnected() && this.version >= 2) {
        // $FlowFixMe
        this.socket.send(JSON.stringify({ op: 'token', data: { token } }));
      } else if (!this.isConnected()) {
        this.reconnect('token refreshed');
      }
    }
  }

  hasHeartbeat() {
    return this.heartbeat.hasHeartbeat;
  }

  startHeartbeat() {
    logger$5.info('Wazo WS start heartbeat', { host: this.host, token: this.token });

    if (!this.socket) {
      this.heartbeat.stop();
      return;
    }

    this.off('pong', this._boundOnHeartbeat);
    this.on('pong', this._boundOnHeartbeat);

    this.heartbeat.start();
  }

  stopHeartbeat() {
    logger$5.info('Wazo WS stop heartbeat', { host: this.host, token: this.token });

    this.heartbeat.stop();
  }

  setOnHeartbeatTimeout(cb          ) {
    this.onHeartBeatTimeout = cb;
  }

  setOnHeartbeatCallback(cb          ) {
    this.heartbeatCb = cb;
  }

  pingServer() {
    if (!this.socket || !this.isConnected()) {
      return;
    }

    try {
      this.socket.send(JSON.stringify({ op: 'ping', data: { payload: 'pong' } }));
    } catch (_) {
      // Nothing to do
    }
  }

  isConnected() {
    return this.socket && this.socket.readyState === this.socket.OPEN;
  }

  reconnect(reason        ) {
    logger$5.info('Wazo WS reconnect', { reason, socket: !!this.socket, host: this.host, token: this.token });
    if (!this.socket) {
      return;
    }
    this.socket.reconnect(reason);
  }

  _handleInitMessage(message                  , sock                       ) {
    switch (message.op) {
      case 'init':
        this.events.forEach(event => {
          const op = {
            op: 'subscribe',
            data: { event_name: event },
          };

          sock.send(JSON.stringify(op));
        });

        sock.send(JSON.stringify({ op: 'start' }));
        break;
      case 'subscribe':
        break;
      case 'start':
        this.initialized = true;
        this.eventEmitter.emit(SOCKET_EVENTS$1.INITIALIZED);
        break;
      default:
        this.eventEmitter.emit('message', message);
    }
  }

  _handleMessage(message        ) {
    if (message.op === 'pong') {
      this.eventEmitter.emit('pong', message.data);
      if (this.heartbeatCb) {
        this.heartbeatCb();
      }
      return;
    }

    if (this.version === 1) {
      this.eventEmitter.emit(message.name, message);
      return;
    }

    if (this.version >= 2 && message.op === 'event') {
      this.eventEmitter.emit(message.data.name, message.data);
    }
  }

  _getUrl() {
    if (!this.host || !this.token) {
      this.close();
    }
    const url = `wss://${this.host || ''}/api/websocketd/?token=${this.token || ''}&version=${this.version}`;
    logger$5.info('Wazo WS url computed to reconnect', { url });

    return url;
  }

  _onHeartbeat(message        ) {
    if (message.payload === 'pong') {
      this.heartbeat.onHeartbeat();
      logger$5.log('on heartbeat received from Wazo WS');
    }
  }

  async _onHeartbeatTimeout() {
    logger$5.log('heartbeat timed out', { host: this.host, token: this.token });

    this.close();
    this.eventEmitter.emit(SOCKET_EVENTS$1.ON_CLOSE, new Error('Websocket ping failure.'));

    if (this.onHeartBeatTimeout) {
      this.onHeartBeatTimeout();
    }
  }
}

// Can't use static
WebSocketClient.eventLists = [
  AUTH_SESSION_EXPIRE_SOON,
  FAVORITE_ADDED,
  FAVORITE_DELETED,
  USER_STATUS_UPDATE,
  CHAT_MESSAGE_SENT,
  CHAT_MESSAGE_RECEIVED,
  ENDPOINT_STATUS_UPDATE,
  USERS_FORWARDS_BUSY_UPDATED,
  USERS_FORWARDS_NOANSWER_UPDATED,
  USERS_FORWARDS_UNCONDITIONAL_UPDATED,
  USERS_SERVICES_DND_UPDATED,
  USER_VOICEMAIL_MESSAGE_CREATED,
  USER_VOICEMAIL_MESSAGE_UPDATED,
  USER_VOICEMAIL_MESSAGE_DELETED,
  CALL_LOG_USER_CREATED,
  CALL_ANSWERED,
  CALL_CREATED,
  CALL_DTMF_CREATED,
  CALL_ENDED,
  CALL_UPDATED,
  CALL_HELD,
  CALL_RESUMED,
  AUTH_USER_EXTERNAL_AUTH_ADDED,
  AUTH_USER_EXTERNAL_AUTH_DELETED,
  CHATD_PRESENCE_UPDATED,
  CHATD_USER_ROOM_MESSAGE_CREATED,
  CHATD_USER_ROOM_CREATED,
  CONFERENCE_USER_PARTICIPANT_JOINED,
  CONFERENCE_USER_PARTICIPANT_LEFT,
  MEETING_USER_PARTICIPANT_JOINED,
  MEETING_USER_PARTICIPANT_LEFT,
  CONFERENCE_USER_PARTICIPANT_TALK_STARTED,
  CONFERENCE_USER_PARTICIPANT_TALK_STOPPED,
  SWITCHBOARD_QUEUED_CALLS_UPDATED,
  SWITCHBOARD_QUEUED_CALL_ANSWERED,
  SWITCHBOARD_HELD_CALLS_UPDATED,
  SWITCHBOARD_HELD_CALL_ANSWERED,
  FAX_OUTBOUND_USER_CREATED,
  FAX_OUTBOUND_USER_SUCCEEDED,
  FAX_OUTBOUND_USER_FAILED,
  APPLICATION_CALL_DTMF_RECEIVED,
  APPLICATION_CALL_ENTERED,
  APPLICATION_CALL_INITIATED,
  APPLICATION_CALL_DELETED,
  APPLICATION_CALL_UPDATED,
  APPLICATION_CALL_ANSWERED,
  APPLICATION_PROGRESS_STARTED,
  APPLICATION_PROGRESS_STOPPED,
  APPLICATION_DESTINATION_NODE_CREATED,
  APPLICATION_NODE_CREATED,
  APPLICATION_NODE_DELETED,
  APPLICATION_NODE_UPDATED,
  APPLICATION_PLAYBACK_CREATED,
  APPLICATION_PLAYBACK_DELETED,
  APPLICATION_SNOOP_CREATED,
  APPLICATION_SNOOP_DELETED,
  APPLICATION_SNOOP_UPDATED,
  APPLICATION_USER_OUTGOING_CALL_CREATED,
  TRUNK_STATUS_UPDATED,
  LINE_STATUS_UPDATED,
  AGENT_STATUS_UPDATE,
  AGENT_PAUSED,
  AGENT_UNPAUSED,
  CONFERENCE_ADHOC_PARTICIPANT_LEFT,
  CONFERENCE_ADHOC_DELETED,
  MEETING_USER_PROGRESS,
  MEETING_USER_GUEST_AUTHORIZATION_CREATED,
];

var WebSocketClient$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SOCKET_EVENTS: SOCKET_EVENTS$1,
  AUTH_SESSION_EXPIRE_SOON: AUTH_SESSION_EXPIRE_SOON,
  FAVORITE_ADDED: FAVORITE_ADDED,
  FAVORITE_DELETED: FAVORITE_DELETED,
  USER_STATUS_UPDATE: USER_STATUS_UPDATE,
  CHAT_MESSAGE_SENT: CHAT_MESSAGE_SENT,
  CHAT_MESSAGE_RECEIVED: CHAT_MESSAGE_RECEIVED,
  ENDPOINT_STATUS_UPDATE: ENDPOINT_STATUS_UPDATE,
  USERS_FORWARDS_BUSY_UPDATED: USERS_FORWARDS_BUSY_UPDATED,
  USERS_FORWARDS_NOANSWER_UPDATED: USERS_FORWARDS_NOANSWER_UPDATED,
  USERS_FORWARDS_UNCONDITIONAL_UPDATED: USERS_FORWARDS_UNCONDITIONAL_UPDATED,
  USERS_SERVICES_DND_UPDATED: USERS_SERVICES_DND_UPDATED,
  USER_VOICEMAIL_MESSAGE_CREATED: USER_VOICEMAIL_MESSAGE_CREATED,
  USER_VOICEMAIL_MESSAGE_UPDATED: USER_VOICEMAIL_MESSAGE_UPDATED,
  USER_VOICEMAIL_MESSAGE_DELETED: USER_VOICEMAIL_MESSAGE_DELETED,
  CALL_LOG_USER_CREATED: CALL_LOG_USER_CREATED,
  CALL_CREATED: CALL_CREATED,
  CALL_ANSWERED: CALL_ANSWERED,
  CALL_DTMF_CREATED: CALL_DTMF_CREATED,
  CALL_ENDED: CALL_ENDED,
  CALL_UPDATED: CALL_UPDATED,
  CALL_HELD: CALL_HELD,
  CALL_RESUMED: CALL_RESUMED,
  AUTH_USER_EXTERNAL_AUTH_ADDED: AUTH_USER_EXTERNAL_AUTH_ADDED,
  AUTH_USER_EXTERNAL_AUTH_DELETED: AUTH_USER_EXTERNAL_AUTH_DELETED,
  CHATD_PRESENCE_UPDATED: CHATD_PRESENCE_UPDATED,
  CHATD_USER_ROOM_MESSAGE_CREATED: CHATD_USER_ROOM_MESSAGE_CREATED,
  CHATD_USER_ROOM_CREATED: CHATD_USER_ROOM_CREATED,
  CONFERENCE_USER_PARTICIPANT_JOINED: CONFERENCE_USER_PARTICIPANT_JOINED,
  CONFERENCE_USER_PARTICIPANT_LEFT: CONFERENCE_USER_PARTICIPANT_LEFT,
  CONFERENCE_USER_PARTICIPANT_TALK_STARTED: CONFERENCE_USER_PARTICIPANT_TALK_STARTED,
  CONFERENCE_USER_PARTICIPANT_TALK_STOPPED: CONFERENCE_USER_PARTICIPANT_TALK_STOPPED,
  MEETING_USER_PARTICIPANT_JOINED: MEETING_USER_PARTICIPANT_JOINED,
  MEETING_USER_PARTICIPANT_LEFT: MEETING_USER_PARTICIPANT_LEFT,
  SWITCHBOARD_QUEUED_CALLS_UPDATED: SWITCHBOARD_QUEUED_CALLS_UPDATED,
  SWITCHBOARD_QUEUED_CALL_ANSWERED: SWITCHBOARD_QUEUED_CALL_ANSWERED,
  SWITCHBOARD_HELD_CALLS_UPDATED: SWITCHBOARD_HELD_CALLS_UPDATED,
  SWITCHBOARD_HELD_CALL_ANSWERED: SWITCHBOARD_HELD_CALL_ANSWERED,
  FAX_OUTBOUND_USER_CREATED: FAX_OUTBOUND_USER_CREATED,
  FAX_OUTBOUND_USER_SUCCEEDED: FAX_OUTBOUND_USER_SUCCEEDED,
  FAX_OUTBOUND_USER_FAILED: FAX_OUTBOUND_USER_FAILED,
  APPLICATION_CALL_DTMF_RECEIVED: APPLICATION_CALL_DTMF_RECEIVED,
  APPLICATION_CALL_ENTERED: APPLICATION_CALL_ENTERED,
  APPLICATION_CALL_INITIATED: APPLICATION_CALL_INITIATED,
  APPLICATION_CALL_DELETED: APPLICATION_CALL_DELETED,
  APPLICATION_CALL_UPDATED: APPLICATION_CALL_UPDATED,
  APPLICATION_CALL_ANSWERED: APPLICATION_CALL_ANSWERED,
  APPLICATION_PROGRESS_STARTED: APPLICATION_PROGRESS_STARTED,
  APPLICATION_PROGRESS_STOPPED: APPLICATION_PROGRESS_STOPPED,
  APPLICATION_DESTINATION_NODE_CREATED: APPLICATION_DESTINATION_NODE_CREATED,
  APPLICATION_NODE_CREATED: APPLICATION_NODE_CREATED,
  APPLICATION_NODE_DELETED: APPLICATION_NODE_DELETED,
  APPLICATION_NODE_UPDATED: APPLICATION_NODE_UPDATED,
  APPLICATION_PLAYBACK_CREATED: APPLICATION_PLAYBACK_CREATED,
  APPLICATION_PLAYBACK_DELETED: APPLICATION_PLAYBACK_DELETED,
  APPLICATION_SNOOP_CREATED: APPLICATION_SNOOP_CREATED,
  APPLICATION_SNOOP_DELETED: APPLICATION_SNOOP_DELETED,
  APPLICATION_SNOOP_UPDATED: APPLICATION_SNOOP_UPDATED,
  APPLICATION_USER_OUTGOING_CALL_CREATED: APPLICATION_USER_OUTGOING_CALL_CREATED,
  TRUNK_STATUS_UPDATED: TRUNK_STATUS_UPDATED,
  LINE_STATUS_UPDATED: LINE_STATUS_UPDATED,
  AGENT_STATUS_UPDATE: AGENT_STATUS_UPDATE,
  AGENT_PAUSED: AGENT_PAUSED,
  AGENT_UNPAUSED: AGENT_UNPAUSED,
  CONFERENCE_ADHOC_PARTICIPANT_LEFT: CONFERENCE_ADHOC_PARTICIPANT_LEFT,
  CONFERENCE_ADHOC_DELETED: CONFERENCE_ADHOC_DELETED,
  MEETING_USER_PROGRESS: MEETING_USER_PROGRESS,
  MEETING_USER_GUEST_AUTHORIZATION_CREATED: MEETING_USER_GUEST_AUTHORIZATION_CREATED,
  HEARTBEAT_ENGINE_VERSION: HEARTBEAT_ENGINE_VERSION,
  'default': WebSocketClient
});

//      

const { SOCKET_EVENTS, ...OTHER_EVENTS } = WebSocketClient$1;
const ALL_EVENTS = [...Object.values(SOCKET_EVENTS), ...Object.values(OTHER_EVENTS)];

const logger$4 = IssueReporter$1.loggerFor('simple-ws-client');

class Websocket extends Emitter {
                           
                       

  constructor() {
    super();

    // Sugar syntax for `Wazo.WebSocket.EVENT_NAME`
    Object.keys(OTHER_EVENTS).forEach(key => {
      // $FlowFixMe
      this[key] = OTHER_EVENTS[key];
    });
    Object.keys(SOCKET_EVENTS).forEach(key => {
      // $FlowFixMe
      this[key] = SOCKET_EVENTS[key];
    });
    this.eventLists = WebSocketClient.eventLists;

    this.ws = null;
  }

  open(host        , session         ) {
    logger$4.info('open simple WebSocket', { host, token: session.token });
    this.ws = new WebSocketClient(
      {
        host,
        token: session.token,
        events: ['*'],
        version: 2,
      },
      {
        rejectUnauthorized: false,
        binaryType: 'arraybuffer',
      },
    );

    this.ws.connect();

    // Re-emit all events
    ALL_EVENTS.forEach((event     ) => {
      if (!this.ws) {
        return;
      }
      this.ws.on(event, (payload        ) => {
        this.eventEmitter.emit(event, payload);
      });
    });
  }

  updateToken(token        ) {
    logger$4.info('update token via simple Websocket', { token, ws: !!this.ws });

    if (!this.ws) {
      return;
    }
    this.ws.updateToken(token);
  }

  isOpen() {
    return this.ws && this.ws.isConnected();
  }

  close(force          = false) {
    if (this.ws) {
      this.ws.close(force);
    }
    this.unbind();
  }
}

if (!global.wazoWebsocketInstance) {
  global.wazoWebsocketInstance = new Websocket();
}

var Websocket$1 = global.wazoWebsocketInstance;

//      

const logger$3 = IssueReporter$1.loggerFor('room');

class Participant extends Emitter {
             
               
               
                 
                 
                     
                 
                      
                      
                      
                         
                    
                  
                

                     
                           
                          
                        
                               
                                 
                         
                           
                         
                           
                           
                                
                          
                  
                    
                 

  /**
   * @param room Room The room where the participant is
   * @param rawParticipant string Participant sent via the Wazo WS
   * @param extra Object extra status of the participant
   */
  constructor(room      , rawParticipant         = {}, extra         = {}) {
    super();

    this.room = room;

    this.uuid = rawParticipant.user_uuid;
    this.name = (rawParticipant.caller_id_name || '').replace("\\'", "'");
    this.number = rawParticipant.caller_id_number;
    this.callId = rawParticipant.call_id;
    this.isTalking = false;
    this.streams = [];
    this.videoStreams = [];
    this.audioMuted = false;
    this.videoMuted = false;
    this.screensharing = false;
    this.isOnHold = false;
    this.extra = extra;
    this.banned = false;

    this.ON_UPDATED = 'participant/ON_UPDATED';
    this.ON_START_TALKING = 'participant/ON_START_TALKING';
    this.ON_STOP_TALKING = 'participant/ON_STOP_TALKING';
    this.ON_DISCONNECT = 'participant/ON_DISCONNECT';
    this.ON_STREAM_SUBSCRIBED = 'participant/ON_STREAM_SUBSCRIBED';
    this.ON_STREAM_UNSUBSCRIBED = 'participant/ON_STREAM_UNSUBSCRIBED';
    this.ON_AUDIO_MUTED = 'participant/ON_AUDIO_MUTED';
    this.ON_AUDIO_UNMUTED = 'participant/ON_AUDIO_UNMUTED';
    this.ON_VIDEO_MUTED = 'participant/ON_VIDEO_MUTED';
    this.ON_VIDEO_UNMUTED = 'participant/ON_VIDEO_UNMUTED';
    this.ON_SCREENSHARING = 'participant/ON_SCREENSHARING';
    this.ON_STOP_SCREENSHARING = 'participant/ON_STOP_SCREENSHARING';
    this.ON_EXTRA_CHANGE = 'participant/ON_EXTRA_CHANGE';
    this.ON_HOLD = 'participant/ON_HOLD';
    this.ON_RESUME = 'participant/ON_RESUME';
    this.ON_BAN = 'participant/ON_BAN';
  }

  triggerEvent(name        , ...args       ) {
    this.eventEmitter.emit.apply(this.eventEmitter, [name, ...args]);
    this.eventEmitter.emit.apply(this.eventEmitter, [this.ON_UPDATED, ...args]);
  }

  triggerUpdate(eventType        , broadcast          = true) {
    const status         = { callId: this.callId };

    switch (eventType) {
      case this.ON_START_TALKING:
      case this.ON_STOP_TALKING: {
        status.isTalking = this.isTalking;
        break;
      }
      case this.ON_AUDIO_MUTED:
      case this.ON_AUDIO_UNMUTED: {
        status.audioMuted = this.audioMuted;
        break;
      }
      case this.ON_VIDEO_MUTED:
      case this.ON_VIDEO_UNMUTED: {
        status.videoMuted = this.videoMuted;
        break;
      }
      case this.ON_SCREENSHARING:
      case this.ON_STOP_SCREENSHARING: {
        status.screensharing = this.screensharing;
        break;
      }
      case this.ON_HOLD:
      case this.ON_RESUME: {
        status.isOnHold = this.isOnHold;
        break;
      }
      case this.ON_EXTRA_CHANGE: {
        status.extra = this.extra;
        break;
      }
      case this.ON_BAN: {
        status.banned = true;
        break;
      }
    }

    if (broadcast) {
      this.broadcastStatus(status);
    }

    this.eventEmitter.emit(eventType, status);
    this.eventEmitter.emit(this.ON_UPDATED, eventType, status);
  }

  onTalking(isTalking         ) {
    logger$3.info('on participant talking', { name: this.name, isTalking, callId: this.callId });
    this.isTalking = isTalking;
    // you may notice we're not broadcasting: since all participants are getting this info
    // directly from asterisk, there's no need to do so
    this.triggerUpdate(this.isTalking ? this.ON_START_TALKING : this.ON_STOP_TALKING, false);
  }

  onDisconnect() {
    return this.triggerEvent(this.ON_DISCONNECT);
  }

  onStreamSubscribed(stream     ) {
    return this.triggerEvent(this.ON_STREAM_SUBSCRIBED, stream);
  }

  onStreamUnSubscribed(stream     ) {
    return this.triggerEvent(this.ON_STREAM_UNSUBSCRIBED, stream);
  }

  onAudioMuted(broadcast          = true) {
    if (this.audioMuted) {
      return;
    }
    this.audioMuted = true;

    this.triggerUpdate(this.ON_AUDIO_MUTED, broadcast);
  }

  onAudioUnMuted(broadcast          = true) {
    if (!this.audioMuted) {
      return;
    }
    this.audioMuted = false;

    this.triggerUpdate(this.ON_AUDIO_UNMUTED, broadcast);
  }

  onVideoMuted(broadcast          = true) {
    if (this.videoMuted) {
      return;
    }
    this.videoMuted = true;

    this.triggerUpdate(this.ON_VIDEO_MUTED, broadcast);
  }

  onVideoUnMuted(broadcast          = true) {
    if (!this.videoMuted) {
      return;
    }
    this.videoMuted = false;

    this.triggerUpdate(this.ON_VIDEO_UNMUTED, broadcast);
  }

  onScreensharing(broadcast          = true) {
    if (this.screensharing) {
      return;
    }
    this.screensharing = true;

    this.triggerUpdate(this.ON_SCREENSHARING, broadcast);
  }

  onStopScreensharing(broadcast          = true) {
    if (!this.screensharing) {
      return;
    }
    this.screensharing = false;

    this.triggerUpdate(this.ON_STOP_SCREENSHARING, broadcast);
  }

  onHold(broadcast          = true) {
    if (this.isOnHold) {
      return;
    }
    this.isOnHold = true;

    this.triggerUpdate(this.ON_HOLD, broadcast);
  }

  onResume(broadcast          = true) {
    if (!this.isOnHold) {
      return;
    }
    this.isOnHold = false;

    this.triggerUpdate(this.ON_RESUME, broadcast);
  }

  onBan(broadcast          = true) {
    this.banned = true;
    this.triggerUpdate(this.ON_BAN, broadcast);
  }

  getStatus() {
    return {
      callId: this.callId,
      audioMuted: this.audioMuted,
      videoMuted: this.videoMuted,
      screensharing: this.screensharing,
      isTalking: this.isTalking,
      extra: this.extra,
    };
  }

  updateStatus(status        , broadcast          = true) {
    logger$3.info('updating participant status', { name: this.name, status });

    if (typeof status.audioMuted !== 'undefined' && status.audioMuted !== this.audioMuted) {
      if (status.audioMuted) {
        this.onAudioMuted(broadcast);
      } else {
        this.onAudioUnMuted(broadcast);
      }
    }

    if (typeof status.videoMuted !== 'undefined' && status.videoMuted !== this.videoMuted) {
      if (status.videoMuted) {
        this.onVideoMuted(broadcast);
      } else {
        this.onVideoUnMuted(broadcast);
      }
    }

    if (typeof status.screensharing !== 'undefined' && status.screensharing !== this.screensharing) {
      if (status.screensharing) {
        this.onScreensharing(broadcast);
      } else {
        this.onStopScreensharing(broadcast);
      }
    }

    if (typeof status.isOnHold !== 'undefined' && status.isOnHold !== this.isOnHold) {
      if (status.isOnHold) {
        this.onHold(broadcast);
      } else {
        this.onResume(broadcast);
      }
    }

    if (status.banned) {
      this.onBan(false);
    }

    // Poor man's object comparison
    if (typeof status.extra !== 'undefined' && JSON.stringify(this.extra) !== JSON.stringify(status.extra)) {
      this.extra = { ...this.extra, ...status.extra };

      if (this.extra.contact && !(this.extra.contact instanceof Contact)) {
        this.extra.contact = new Contact(this.extra.contact);
      }

      this.triggerUpdate(this.ON_EXTRA_CHANGE, broadcast);
    }
  }

  broadcastStatus(inboundStatus         = null, sendReinvite          ) {
    const status = inboundStatus || this.getStatus();
    logger$3.info('broadcasting participant status', { callId: this.callId, status });

    if (sendReinvite && !this.streams.length && Phone$1.phone) {
      // eslint-disable-next-line no-underscore-dangle
      Phone$1.phone._sendReinviteMessage(this.room.callSession, false);
    }

    this.room.sendSignal({
      type: SIGNAL_TYPE_PARTICIPANT_UPDATE,
      origin: this.callId,
      status,
    });
  }

  resetStreams(streams       ) {
    this.streams = streams;
    this.videoStreams = streams;
  }

  async ban(apiRequestDelay          = null) {
    const { meetingUuid } = this.room;
    if (!meetingUuid) {
      throw new Error('Attempting to ban a participant without a `meetingUuid`');
    }

    // this notifies all that someone is being banned
    this.onBan(true);

    // this allows to delay the actual ban, in order for the banned participant as well as others to react to the situation
    if (apiRequestDelay) {
      await this.delay(apiRequestDelay);
    }

    // proceed with the actual kick
    return getApiClient().calld.banMeetingParticipant(meetingUuid, this.callId);
  }

  async delay(ms        ) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}

//      

class RemoteParticipant extends Participant {
  constructor(room      , rawParticipant         = {}, extra         = {}) {
    super(room, rawParticipant, extra);
    if (this.name === '<unknown>') {
      this.name = this.number;
    }
  }
}

//      

class LocalParticipant extends Participant {
}

//      

const SIGNAL_TYPE_PARTICIPANT_UPDATE = 'signal/PARTICIPANT_UPDATE';
const SIGNAL_TYPE_PARTICIPANT_REQUEST = 'signal/PARTICIPANT_REQUEST';

const logger$2 = IssueReporter$1.loggerFor('sdk-room');

class Room$1 extends Emitter {
                            
               
                    
                    
                       
                              
                  
                     
                                 
                             
                                    
                                    
                                      
                                    
                            
                         
                           
                                       
                             
                    
                
  // video tag representing the room audio stream
                        

                                             
                                           
                                          
                                        
                                
                     
                  
                    
                          
                          
                           
                          
                    
                                

  /**
   *
   * @param callSession CallSession
   * @param extension string
   * @param sourceId number
   * @param callId string
   * @param meetingUuid string
   * @param extra Object
   */
  constructor(
    callSession             ,
    extension        ,
    sourceId         ,
    callId         ,
    meetingUuid         ,
    extra         = {},
  ) {
    super();
    logger$2.info('room initialized', { callId, extension, sourceId, meetingUuid });

    // Represents the room callSession
    this.callSession = callSession;
    this.extension = extension;
    this.sourceId = sourceId;
    this.meetingUuid = meetingUuid;
    this.callId = callId;
    this.participants = [];
    this.connected = false;
    this.localParticipant = null;
    // [callId]: streamId
    this._callIdStreamIdMap = {};
    // Stream not yet associated to a participant, [streamId]: stream
    this._unassociatedVideoStreams = {};
    // Participant not yet associated to a stream, [participant.callId = label in setDescription]: Participant
    this._unassociatedParticipants = {};

    // The shared audio stream of the room
    this.audioStream = null;
    // Extra values passed to local participant
    this.extra = extra;

    // Sugar syntax for `room.EVENT_NAME`
    this.CONFERENCE_USER_PARTICIPANT_JOINED = Wazo.Websocket.CONFERENCE_USER_PARTICIPANT_JOINED;
    this.CONFERENCE_USER_PARTICIPANT_LEFT = Wazo.Websocket.CONFERENCE_USER_PARTICIPANT_LEFT;
    this.MEETING_USER_PARTICIPANT_JOINED = Wazo.Websocket.MEETING_USER_PARTICIPANT_JOINED;
    this.MEETING_USER_PARTICIPANT_LEFT = Wazo.Websocket.MEETING_USER_PARTICIPANT_LEFT;
    this.ON_SHARE_SCREEN_ENDED = Wazo.Phone.ON_SHARE_SCREEN_ENDED;
    this.ON_MESSAGE = Wazo.Phone.ON_MESSAGE;
    this.ON_CHAT = Wazo.Phone.ON_CHAT;
    this.ON_SIGNAL = Wazo.Phone.ON_SIGNAL;

    this.ON_AUDIO_STREAM = Wazo.Phone.ON_AUDIO_STREAM;
    this.ON_VIDEO_STREAM = Wazo.Phone.ON_VIDEO_STREAM;
    this.ON_REMOVE_STREAM = Wazo.Phone.ON_REMOVE_STREAM;
    this.ON_VIDEO_INPUT_CHANGE = Wazo.Phone.ON_VIDEO_INPUT_CHANGE;
    this.ON_DISCONNECTED = 'room/ON_DISCONNECTED';
    this.ON_JOINED = 'room/ON_JOINED';

    this._boundOnParticipantJoined = this._onParticipantJoined.bind(this);
    this._boundOnParticipantLeft = this._onParticipantLeft.bind(this);
    this._boundOnMessage = this._onMessage.bind(this);
    this._boundOnChat = this._onChat.bind(this);
    this._boundOnSignal = this._onSignal.bind(this);
    this._boundSaveLocalVideoStream = this._saveLocalVideoStream.bind(this);
    this._boundOnReinvite = this._onReinvite.bind(this);

    this.unbind();

    this._bindEvents();

    this._transferEvents();
  }

  /**
   *
   * @param extension string
   * @param constraints string
   * @param audioOnly boolean
   * @param extra Object
   * @param room ?Room
   * @param meeting ?Meeting
   * @returns {Promise<Room>}
   */
  static async connect({ extension, constraints, audioOnly = false, extra, room, meeting }        ) {
    logger$2.info('connecting to room', { extension, audioOnly, room: !!room });

    if (!room) {
      await Wazo.Phone.connect({ media: constraints });

      const withCamera = constraints && !!constraints.video;

      if (withCamera) {
        Wazo.Phone.checkSfu();
      }

      // Call_created is triggered before call_accepted, so we have to listen for it here.
      Wazo.Websocket.once(Wazo.Websocket.CALL_CREATED, ({ data }) => {
        logger$2.info('room call received via WS', { callId: data.call_id });
        if (room) {
          room.setCallId(data.call_id);
        }
      });

      const callSession = await Wazo.Phone.call(extension, withCamera, null, audioOnly, true);
      // eslint-disable-next-line no-param-reassign
      room = new Room$1(callSession, extension, null, null, extra);

      // Wait for the call to be accepted
      await new Promise((resolve, reject) => {
        Wazo.Phone.once(Wazo.Phone.ON_CALL_ACCEPTED, resolve);
        Wazo.Phone.once(Wazo.Phone.ON_CALL_FAILED, reject);
      });
    }

    if (room && room.callSession && room.callSession.call) {
      room.setCallId(room.callSession.call.id);
    }

    if (!meeting) {
      // Fetch conference source
      const sources = await getApiClient().dird.fetchConferenceSource('default');
      // Retrieve conference sources
      const contacts = await getApiClient().dird.fetchConferenceContacts(sources.items[0]);
      // Retrieve conference
      const conference = contacts.find(contact => contact.numbers.find(number => number.number === extension));

      logger$2.info('connected to room', {
        sourceId: conference ? conference.sourceId : null,
        name: conference ? conference.name : null,
      });

      if (conference) {
        room.setSourceId(conference.sourceId);
        room.setName(conference.name);
      }
    } else if (meeting) {
      logger$2.info('Already connected to meeting', {
        uuid: meeting.uuid,
        name: meeting.name,
      });

      room.setMeetingUuid(meeting.uuid);
      room.setName(meeting.name);
    }

    return room;
  }

  static disconnect() {
    logger$2.info('static disconnection to room');

    Wazo.Phone.disconnect();
  }

  async disconnect() {
    logger$2.info('disconnection to room called');

    await Wazo.Phone.hangup(this.callSession);
    this.callSession = null;
    this.eventEmitter.emit(this.ON_DISCONNECTED, this);
    this.connected = false;
    this.unbind();

    Wazo.Phone.off(this.ON_MESSAGE, this._boundOnMessage);
    Wazo.Phone.off(this.ON_CHAT, this._boundOnChat);
    Wazo.Phone.off(this.ON_SIGNAL, this._boundOnSignal);
    Wazo.Phone.off(this.ON_VIDEO_INPUT_CHANGE, this._boundSaveLocalVideoStream);
    Wazo.Phone.phone.off(Wazo.Phone.phone.client.ON_REINVITE, this._boundOnReinvite);
    Wazo.Websocket.off(this.CONFERENCE_USER_PARTICIPANT_JOINED, this._boundOnParticipantJoined);
    Wazo.Websocket.off(this.CONFERENCE_USER_PARTICIPANT_LEFT, this._boundOnParticipantLeft);
    Wazo.Websocket.off(this.MEETING_USER_PARTICIPANT_JOINED, this._boundOnParticipantJoined);
    Wazo.Websocket.off(this.MEETING_USER_PARTICIPANT_LEFT, this._boundOnParticipantLeft);
  }

  setSourceId(sourceId        ) {
    logger$2.info('set room source id', { sourceId });

    this.sourceId = sourceId;
  }

  setMeetingUuid(meetingUuid        ) {
    logger$2.info('set meeting uuid', { meetingUuid });

    this.meetingUuid = meetingUuid;
  }

  setCallId(callId        ) {
    logger$2.info('set room call id', { callId });

    if (callId) {
      this.callId = callId;
    }
  }

  setName(name        ) {
    logger$2.info('set room name', { name });

    this.name = name;
  }

  // @TODO: change sipSession to callSession
  sendMessage(body        , sipSession      = null) {
    return Wazo.Phone.sendMessage(body, sipSession);
  }

  sendChat(content        ) {
    return Wazo.Phone.sendChat(content);
  }

  sendSignal(content     ) {
    return Wazo.Phone.sendSignal(content);
  }

  async startScreenSharing(constraints        ) {
    logger$2.info('start room screen sharing', { constraints });

    const screensharingStream = await Wazo.Phone.startScreenSharing(constraints, this.callSession);
    if (!screensharingStream) {
      console.warn('screensharing stream is null (likely due to user cancellation)');
      return null;
    }

    this._onScreenSharing();

    return screensharingStream;
  }

  async stopScreenSharing(restoreLocalStream          = true) {
    logger$2.info('stop room screen sharing');

    await Wazo.Phone.stopScreenSharing(this.callSession, restoreLocalStream);

    if (this.localParticipant) {
      this._updateLocalParticipantStream();
      // $FlowFixMe
      this.localParticipant.onStopScreensharing();
    }
  }

  turnCameraOff() {
    logger$2.info('turn room camera off');

    Wazo.Phone.turnCameraOff(this.callSession);

    if (this.localParticipant) {
      this.localParticipant.onVideoMuted();
    }
  }

  turnCameraOn() {
    logger$2.info('turn room camera on');

    Wazo.Phone.turnCameraOn(this.callSession);

    if (this.localParticipant) {
      this.localParticipant.onVideoUnMuted();
    }
  }

  mute() {
    logger$2.info('mute room');

    Wazo.Phone.mute(this.callSession);

    this.sendMuteStatus();
  }

  unmute() {
    logger$2.info('unmute room');

    Wazo.Phone.unmute(this.callSession);

    this.sendUnMuteStatus();
  }

  sendMuteStatus() {
    if (this.localParticipant) {
      this.localParticipant.onAudioMuted();
    }
  }

  sendUnMuteStatus() {
    if (this.localParticipant) {
      this.localParticipant.onAudioUnMuted();
    }
  }

  hold() {
    logger$2.info('hold room');

    Wazo.Phone.hold(this.callSession, true);

    if (this.localParticipant) {
      this.localParticipant.onHold();
    }
  }

  async resume() {
    logger$2.info('resume room');

    const newStream = await Wazo.Phone.resume(this.callSession, true);

    if (this.localParticipant) {
      // Update local participant stream (useful when resuming a shreenshared conference)
      this._updateLocalParticipantStream();

      // $FlowFixMe
      this.localParticipant.onResume();

      // $FlowFixMe
      if (!newStream && this.localParticipant.screensharing) {
        // $FlowFixMe
        this.localParticipant.onStopScreensharing();
      }
    }
  }

  _updateLocalParticipantStream() {
    const localStream = Wazo.Phone.getLocalStream(this.callSession);
    if (this.localParticipant && localStream) {
      const localWazoStream = new Wazo.Stream(localStream);
      this.localParticipant.resetStreams([localWazoStream]);
    }
  }

  sendDTMF(tone        ) {
    logger$2.info('send room DTMF', { tone });

    Wazo.Phone.sendDTMF(tone, this.callSession);
  }

  async sendReinvite(newConstraints         = null) {
    logger$2.info('send room reinvite', { callId: this.callSession ? this.callSession.getId() : null, newConstraints });
    const wasScreensharing = this.localParticipant && this.localParticipant.screensharing;

    Wazo.Phone.on(Wazo.Phone.ON_SHARE_SCREEN_STARTED, () => {
      if (Wazo.Phone.phone && Wazo.Phone.phone.currentScreenShare) {
        this._onScreenSharing();
      }
    });

    const response = await Wazo.Phone.phone.sendReinvite(this.callSession, newConstraints, true);

    if (this.localParticipant && newConstraints && newConstraints.video) {
      const localVideoStream = Wazo.Phone.phone.getLocalVideoStream(this.callSession);
      if (localVideoStream) {
        // $FlowFixMe
        this._associateStreamTo(localVideoStream, this.localParticipant);
      }
    } else if (this.localParticipant && wasScreensharing && newConstraints && !newConstraints.video) {
      // Downgrade from screenshare to audio
      this.localParticipant.onStopScreensharing();
    }

    return response;
  }

  hasALocalVideoTrack() {
    return Wazo.Phone.hasALocalVideoTrack(this.callSession);
  }

  getLocalStream() {
    return Wazo.Phone.getLocalStream(this.callSession);
  }

  getRemoteStream() {
    return Wazo.Phone.getRemoteStream(this.callSession);
  }

  getRemoteVideoStream() {
    return Wazo.Phone.getRemoteVideoStream(this.callSession);
  }

  _bindEvents() {
    if (!Wazo.Phone.phone || !Wazo.Phone.phone.currentSipSession) {
      return;
    }
    // Retrieve mapping
    Wazo.Phone.phone.currentSipSession.sessionDescriptionHandler.on('setDescription', ({ type, sdp: rawSdp }) => {
      if (type !== 'offer') {
        return;
      }

      this._mapMsid(rawSdp);
    });

    // Listen to REINVITE to ba able to map msid after upgrading to video in a  audio only conference
    // This allow to map msid with the non parsed (eg without the `stripVideo` modifier) SDP
    Wazo.Phone.phone.on(Wazo.Phone.phone.client.ON_REINVITE, this._boundOnReinvite);

    this.on(this.ON_AUDIO_STREAM, stream => {
      logger$2.info('on room audio stream');

      this.audioStream = stream;
      if (!this.roomAudioElement) {
        const sessionId = Wazo.Phone.phone.getSipSessionId(Wazo.Phone.phone.currentSipSession);
        this.roomAudioElement = Wazo.Phone.phone.createAudioElementFor(sessionId);
        this.roomAudioElement.srcObject = stream;
      } else {
        this.roomAudioElement.srcObject = stream;
      }
    });

    this.on(this.ON_VIDEO_STREAM, (stream, streamId, event, sipSession) => {
      logger$2.info('on room video stream', { streamId });

      this._mapMsid(sipSession.body.body);

      // ON_VIDEO_STREAM is called before PARTICIPANT_JOINED, so we have to keep stream in `_unassociatedVideoStreams`.
      this._unassociatedVideoStreams[streamId] = stream;

      const callId = this._getCallIdFromTrackId(streamId);
      const participant = callId ? this._getParticipantFromCallId(callId) : null;
      if (participant) {
        this.__associateStreams(participant);
      }
    });

    this.on(this.ON_REMOVE_STREAM, stream => {
      logger$2.info('on room remove stream');

      const participant = this.participants.find(someParticipant =>
        someParticipant.streams.find(someStream => someStream && someStream.id === stream.id));
      if (!participant) {
        return;
      }

      participant.videoStreams = participant.videoStreams.filter(someStream => someStream.id !== stream.id);
      participant.streams = participant.streams.filter(someStream => someStream.id !== stream.id);
      participant.onStreamUnSubscribed(stream);
    });
  }

  _onScreenSharing() {
    if (this.localParticipant) {
      this.localParticipant.onScreensharing();
    }
  }

  _onReinvite(session     , inviteRequest     ) {
    const body = inviteRequest.body || inviteRequest.message.body;
    if (body) {
      this._mapMsid(body);

      // Re-associate video streams
      this.participants.forEach(participant => {
        this.__associateStreams(participant);
      });
    }
  }

  _mapMsid(rawSdp        ) {
    const sdp = sdpParser__default['default'].parse(rawSdp);
    const labelMsidArray = sdp.media.filter(media => !!media.label).map(({ label, msid }) => ({
      label: String(label),
      streamId: msid.split(' ')[0],
      trackId: msid.split(' ')[1],
    }));

    labelMsidArray.forEach(({ label, streamId, trackId }) => {
      this._callIdStreamIdMap[String(label)] = { streamId, trackId };

      const callId = String(label);
      const participant = this._unassociatedParticipants[callId] || this._getParticipantFromCallId(callId);
      if (participant) {
        this.__associateStreams(participant);
      }
    });
  }

  _transferEvents() {
    Wazo.Websocket.on(this.CONFERENCE_USER_PARTICIPANT_JOINED, this._boundOnParticipantJoined);
    Wazo.Websocket.on(this.CONFERENCE_USER_PARTICIPANT_LEFT, this._boundOnParticipantLeft);

    Wazo.Websocket.on(this.MEETING_USER_PARTICIPANT_JOINED, this._boundOnParticipantJoined);
    Wazo.Websocket.on(this.MEETING_USER_PARTICIPANT_LEFT, this._boundOnParticipantLeft);

    // Phone events
    Wazo.Phone.on(this.ON_MESSAGE, this._boundOnMessage);
    Wazo.Phone.on(this.ON_CHAT, this._boundOnChat);
    Wazo.Phone.on(this.ON_SIGNAL, this._boundOnSignal);
    Wazo.Phone.on(this.ON_VIDEO_INPUT_CHANGE, this._boundSaveLocalVideoStream);

    [this.ON_AUDIO_STREAM, this.ON_VIDEO_STREAM, this.ON_REMOVE_STREAM].forEach(event =>
      Wazo.Phone.on(event, (...args) => this.eventEmitter.emit.apply(this.eventEmitter, [event, ...args])));
  }

  _onMessage(message         )          {
    if (message.method !== 'MESSAGE') {
      return null;
    }
    let body;
    try {
      body = JSON.parse(message.body);
    } catch (e) {
      return null;
    }

    switch (body.type) {
      case 'ConfbridgeTalking': {
        // Update participant
        const channel = body.channels[0];
        const { id: callId, talking_status: talkingStatus } = channel;
        const isTalking = talkingStatus === 'on';
        const participantIdx = this.participants.findIndex(participant => participant.callId === callId);
        if (participantIdx === -1) {
          return;
        }
        this.participants[participantIdx].onTalking(isTalking);
        break;
      }
    }

    this.eventEmitter.emit(this.ON_MESSAGE, body);

    return body;
  }

  _onChat(content        ) {
    this.eventEmitter.emit(this.ON_CHAT, content);
  }

  _onSignal(content        ) {
    const { type } = content;

    switch (type) {
      // we're receiving a external update
      case SIGNAL_TYPE_PARTICIPANT_UPDATE: {
        const { status } = content;
        const participant               = this._getParticipantFromCallId(status.callId);

        if (participant) {
          // we're receiving, so no need to broadcast
          participant.updateStatus(status, false);
        }
        break;
      }

      // this is a request to broadcast our current status
      case SIGNAL_TYPE_PARTICIPANT_REQUEST: {
        const { callId, origin } = content;
        // callId is null, someone's requesting everyone's state;
        // or callId is set and matches ours;
        if (this.localParticipant && (!callId || callId === this.localParticipant.callId)) {
          this.localParticipant.broadcastStatus(null, true);
        }

        // might as well update the requester's status
        const requester               = this._getParticipantFromCallId(origin.callId);
        if (requester) {
          // @FIXME?: when need to trigger an update on join-in; this is a bit of a hack
          logger$2.info('trigger room requester status', { origin });
          requester.triggerUpdate('REQUESTER_UPDATE');
        }
        break;
      }

      case Wazo.Phone.ON_MESSAGE_TRACK_UPDATED: {
        const { callId, update } = content;
        const participantIdx = this.participants.findIndex(p => p.callId === callId);
        if (participantIdx !== -1) {
          this.participants[participantIdx] = this._onParticipantTrackUpdate(this.participants[participantIdx], update);
        }

        break;
      }

      default: {
        console.warn('uncaught signal', content);
      }
    }

    this.eventEmitter.emit(Wazo.Phone.ON_SIGNAL, content);
  }

  async _onParticipantJoined(payload        ) {
    const participant = payload.data;
    const session = Wazo.Auth.getSession();
    let participants = [];

    // When we join the room, we can call `getConferenceParticipantsAsUser`, not before.
    if (participant.user_uuid === session.uuid) {
      logger$2.info('room current user joined');

      // Retrieve participants via an API calls
      const conferenceId = this.sourceId || payload.data.conference_id;
      let response;
      try {
        if (this.meetingUuid) {
          logger$2.info('fetching meeting participants', { meetingUuid: this.meetingUuid });
          response = await getApiClient().calld.getMeetingParticipantsAsUser(this.meetingUuid);
        } else {
          logger$2.info('fetching conference participants', { conferenceId });
          response = await getApiClient().calld.getConferenceParticipantsAsUser(conferenceId);
        }
      } catch (e) {
        logger$2.error('room participants fetching, error', e);
      }
      if (response) {
        logger$2.info('conference participants fetched', { nb: response.items.length });
        participants = response.items.map(item => {
          const isMe = item.call_id === this.callId;

          return isMe && item.call_id
            ? new Wazo.LocalParticipant(this, item, this.extra)
            : new Wazo.RemoteParticipant(this, item);
        });

        this.participants = participants;

        const localParticipant = participants.find(someParticipant => someParticipant instanceof Wazo.LocalParticipant);
        if (!this.localParticipant && localParticipant) {
          this._onLocalParticipantJoined(localParticipant);
        }

        participants.forEach(someParticipant => this._isParticipantJoining(someParticipant));
        this.eventEmitter.emit(this.ON_JOINED, localParticipant, participants);
      }

      return this.participants;
    }

    const remoteParticipant                     = !this.participants.some(p => p.callId === participant.call_id)
      ? new Wazo.RemoteParticipant(this, participant)
      : null;

    logger$2.info('other room user joined', { callId: participant.call_id, remoteParticipant: !!remoteParticipant });

    if (remoteParticipant) {
      this.participants.push(remoteParticipant);
      this._isParticipantJoining(remoteParticipant);
    }

    return remoteParticipant;
  }

  _onLocalParticipantJoined(localParticipant                  ) {
    this.localParticipant = localParticipant;

    const localVideoStream = this._getLocalVideoStream();
    if (localVideoStream) {
      this._saveLocalVideoStream(localVideoStream);
    }

    this.connected = true;

    localParticipant.broadcastStatus(null, true);

    // we're in the room, now let's request everyone's status
    if (this.localParticipant) {
      this.sendSignal({
        type: SIGNAL_TYPE_PARTICIPANT_REQUEST,
        origin: this.localParticipant.getStatus(),
      });
    }
  }

  _isParticipantJoining(participant             ) {
    this.__associateStreams(participant);
    // @VALIDATE: no need to publicize ourselves, no?
    if (participant instanceof RemoteParticipant) {
      this.eventEmitter.emit(this.CONFERENCE_USER_PARTICIPANT_JOINED, participant);
    }
  }

  _saveLocalVideoStream(stream             ) {
    const { localParticipant } = this;

    if (!localParticipant) {
      return;
    }

    const videoStream = new Wazo.Stream(stream, localParticipant);

    if (videoStream) {
      localParticipant.resetStreams([videoStream]);
      localParticipant.onStreamSubscribed(videoStream);
    }

    return videoStream;
  }

  _onParticipantLeft(payload        ) {
    const leftParticipant = this.participants.find(participant =>
      participant && participant.callId === payload.data.call_id);

    // Trigger Participant.ON_DISCONNECT event
    if (leftParticipant) {
      leftParticipant.onDisconnect();
    }

    this.participants = this.participants.filter(participant =>
      participant && participant.callId !== payload.data.call_id);
    this.eventEmitter.emit(this.CONFERENCE_USER_PARTICIPANT_LEFT, leftParticipant);
  }

  _onParticipantTrackUpdate(oldParticipant             , update        )              {
    const newParticipant = oldParticipant;

    const { trackId, streamId } = this._callIdStreamIdMap[newParticipant.callId] || {};
    const pc = Wazo.Phone.phone.currentSipSession.sessionDescriptionHandler.peerConnection;
    // Can't use `getReceivers` here because on FF we make the mapping based on the streamId
    const stream = pc.getRemoteStreams().find(someStream =>
      someStream.id === streamId || someStream.getTracks().some(track => track.id === trackId));

    if (update === 'downgrade') {
      newParticipant.resetStreams([]);
      newParticipant.onStreamUnSubscribed(stream);

      return newParticipant;
    }

    // Upgrade
    if (stream) {
      this._associateStreamTo(stream, newParticipant);
    }

    return newParticipant;
  }

  // Associate audio/video streams to the participant and triggers events on it
  __associateStreams(participant             ) {
    const { trackId } = this._callIdStreamIdMap[participant.callId] || {};
    if (!trackId) {
      this._unassociatedParticipants[participant.callId] = participant;

      return;
    }
    if (!trackId || !participant || !this.localParticipant || participant.callId === this.localParticipant.callId) {
      return;
    }

    const streamId = this._getStreamIdFrTrackId(trackId);
    const key = this._getUnassociatedMapIdFromTrackIdOrStreamId(trackId, streamId);
    const stream = this._unassociatedVideoStreams[key];

    if (stream) {
      // Try to associate stream
      this._associateStreamTo(stream, participant);

      delete this._unassociatedVideoStreams[key];
      delete this._unassociatedParticipants[participant.callId];
    }
  }

  _getUnassociatedMapIdFromTrackIdOrStreamId(trackId        , streamId         ) {
    // Find by trackId
    if (trackId in this._unassociatedVideoStreams) {
      return trackId;
    }

    // Find by streamId
    if (streamId && streamId in this._unassociatedVideoStreams) {
      return streamId;
    }

    // Find in all the streams by streamId (used on FF where we can't map by trackId)
    const idx = Object.values(this._unassociatedVideoStreams).findIndex((stream        ) =>
      stream && stream.id === streamId);
    return idx === -1 ? null : Object.keys(this._unassociatedVideoStreams)[idx];
  }

  _getStreamIdFrTrackId(trackId        ) {
    const mapping         = Object.values(this._callIdStreamIdMap).find((map        ) => map.trackId === trackId);

    return mapping ? mapping.streamId : null;
  }

  _associateStreamTo(rawStream     , participant             ) {
    const stream = new Wazo.Stream(rawStream, participant);
    participant.streams.push(stream);
    participant.videoStreams.push(stream);

    participant.onStreamSubscribed(stream);
  }

  _getCallIdFromTrackId(trackId        ) {
    return Object.keys(this._callIdStreamIdMap).find(key => this._callIdStreamIdMap[key].trackId === trackId);
  }

  _getParticipantFromCallId(callId        ) {
    return this.participants.find(participant => participant.callId === callId);
  }

  _getLocalVideoStream() {
    return Wazo.Phone.getLocalVideoStream(this.callSession);
  }
}

//      

const logger$1 = IssueReporter$1.loggerFor('sdk-sip-room');

class SipRoom extends Room$1 {

  static async connect({ extension, constraints, audioOnly = false, extra, room }        ) {
    logger$1.info('connecting to sip room', { extension, audioOnly, room: !!room });

    if (!room) {
      await Wazo.Phone.connect({ media: constraints });

      const withCamera = constraints && !!constraints.video;

      const callSession = await Wazo.Phone.call(extension, withCamera, null, audioOnly, true);
      // eslint-disable-next-line no-param-reassign
      room = new SipRoom(callSession, extension, null, null, extra);
    }

    if (room && room.callSession && room.callSession.call) {
      room.setCallId(room.callSession.call.id);
    }

    logger$1.info('connected to room', {
      extension: room.extension,
    });

    return room;
  }

  mute() {
    logger$1.info('mute sip room');

    Wazo.Phone.mute(this.callSession, false);

    this.sendMuteStatus();
  }

  unmute() {
    logger$1.info('unmute sip room');

    Wazo.Phone.unmute(this.callSession, false);

    this.sendUnMuteStatus();
  }

  getLocalGuestName() {
    return Wazo.Phone.phone.client.userAgent.options.displayName;
  }

  // Overridden to not listen to websocket messages
  _transferEvents() {
    // Phone events
    Wazo.Phone.on(this.ON_MESSAGE, this._boundOnMessage);
    Wazo.Phone.on(this.ON_CHAT, this._boundOnChat);
    Wazo.Phone.on(this.ON_SIGNAL, this._boundOnSignal);
    Wazo.Phone.on(this.ON_VIDEO_INPUT_CHANGE, this._boundSaveLocalVideoStream);

    [this.ON_AUDIO_STREAM, this.ON_VIDEO_STREAM, this.ON_REMOVE_STREAM].forEach(event =>
      Wazo.Phone.on(event, (...args) => this.eventEmitter.emit.apply(this.eventEmitter, [event, ...args])));
  }

  _onMessage(message         ) {
    // eslint-disable-next-line no-underscore-dangle
    const body = super._onMessage(message);
    if (!body) {
      return;
    }

    const getChannel = () => body.channels[0];

    switch (body.type) {
      case 'ConfbridgeWelcome':
        body.channels.forEach(channel => {
          this._onParticipantJoined(channel);
        });

        break;
      case 'ConfbridgeJoin': {
        const channel = getChannel();
        this._onParticipantJoined(channel);
        break;
      }
      case 'ConfbridgeLeave': {
        const channel = getChannel();
        this._onParticipantLeft({
          data: {
            call_id: channel.id,
          },
        });
        break;
      }
    }
  }

  async _onParticipantJoined(channel        ) {
    const isLocal = channel.channelvars.WAZO_SIP_CALL_ID === this._getCurrentSipCallIs();
    const callId = channel.id;
    const ParticipantClass = isLocal ? Wazo.LocalParticipant : Wazo.RemoteParticipant;
    const name = channel.caller ? channel.caller.name : null;
    const extra = isLocal ? { guestName: this.getLocalGuestName() } : {};
    const participant = new ParticipantClass(this, {
      caller_id_name: name,
      call_id: callId,
    }, extra);

    const participantIdx = this.participants.findIndex(other => other.callId === participant.callId);
    if (participantIdx !== -1 && name) {
      this.participants[participantIdx].name = name;
      return;
    }

    if (isLocal) {
      // Should be updated by the Wazo WS but we don't have it for now
      if (this.callSession) {
        this.callSession.ringing = false;
      }

      this._onLocalParticipantJoined(participant);

      // Give some time for the stream to be updated
      setTimeout(() => {
        this.eventEmitter.emit(this.ON_JOINED, participant, this.participants);
      }, 1000);
    }

    this.participants.push(participant);

    this._isParticipantJoining(participant);

    return participant;
  }

  _getCurrentSipCallIs() {
    return Wazo.Phone.getSipSessionId(Wazo.Phone.phone.currentSipSession);
  }

}

/* global document */

class Stream {
                          
                           

  static detachStream(stream     ) {
    stream.getTracks().forEach(track => {
      track.stop();
    });
  }

  constructor(htmlStream             , participant             ) {
    this.htmlStream = htmlStream;
    this.participant = participant;
  }

  attach(rawElement                   ) {
    const element = rawElement || document.createElement('video');
    const isLocal = this.participant instanceof Wazo.LocalParticipant;
    element.autoplay = true;
    element.srcObject = this.htmlStream;
    element.muted = isLocal;

    if (isLocal) {
      // Reverse local video
      element.style.transform = 'scale(-1, 1)';
    }

    element.onloadedmetadata = () => {
      const tracks = this.htmlStream ? this.htmlStream.getVideoTracks() : [];
      tracks.forEach(track => {
        track.enabled = true;
        // $FlowFixMe
        track.loaded = true;
      });
    };

    return element;
  }

  detach() {
    Stream.detachStream(this.htmlStream);
  }

  hasVideo() {
    if (!this.htmlStream) {
      return false;
    }

    return this.htmlStream.getTracks().some(track => track.kind === 'video' && track.readyState !== 'ended');
  }

  get id() {
    return this.htmlStream ? this.htmlStream.id : null;
  }
}

//      

class Directory {

  async findMultipleContactsByNumber(numbers          ) {
    return getApiClient().dird.findMultipleContactsByNumber(numbers);
  }

}

if (!global.wazoDirectoryInstance) {
  global.wazoDirectoryInstance = new Directory();
}

var Directory$1 = global.wazoDirectoryInstance;

//      

class Configuration {

  async getCurrentUser() {
    const session = Auth$1.getSession();
    return getApiClient().confd.getUser(session ? session.uuid : '');
  }

}

if (!global.wazoConfigurationInstance) {
  global.wazoConfigurationInstance = new Configuration();
}

var Configuration$1 = global.wazoConfigurationInstance;

/* global navigator */

const createLocalStream = async (kind        , options         = {}) => {
  const createOptions = {};
  createOptions[kind] = Object.keys(options).length > 0 ? options : true;

  // $FlowFixMe
  const mediaStream = await navigator.mediaDevices.getUserMedia(createOptions);

  return new Wazo.Stream(mediaStream, new Wazo.LocalParticipant());
};

const createLocalVideoStream = async (options        ) => createLocalStream('video', options);

const createLocalAudioStream = async (options        ) => createLocalStream('audio', options);

//      

                                   
                 
                     
  

                                     
                 
                     
  

class NotificationOptions {
                 
                     

  static parse(plain                            )                      {
    if (!plain) {
      return new NotificationOptions({ sound: true, vibration: true });
    }

    return new NotificationOptions({
      sound: plain.sound,
      vibration: plain.vibration,
    });
  }

  static newFrom(profile                     ) {
    return newFrom(profile, NotificationOptions);
  }

  constructor({ sound = true, vibration = true }                               = {}) {
    this.sound = sound;
    this.vibration = vibration;
  }

  setSound(sound         )                      {
    this.sound = sound;

    return this;
  }

  setVibration(vibration         )                      {
    this.vibration = vibration;

    return this;
  }

  enable() {
    this.vibration = true;
    this.sound = true;

    return this;
  }

  disable() {
    this.vibration = false;
    this.sound = false;

    return this;
  }

  isEnabled() {
    return this.sound || this.vibration;
  }
}

//      

                             
                                           
             
                
                                                                              
  

// Represents a conference room, like `9000`.
class Room {
             

                                  

                                           

                                                                              

  constructor({ id, connectedCallSession, participants, name }               ) {
    this.id = id;
    this.connectedCallSession = connectedCallSession;
    this.participants = participants;
    this.name = name;
  }

  getExtension()                {
    return this.connectedCallSession ? this.connectedCallSession.number : null;
  }

  connect(callSession             )       {
    return new Room({ ...this, connectedCallSession: callSession });
  }

  has(callSession             )          {
    return !!this.connectedCallSession && this.connectedCallSession.is(callSession);
  }

  addParticipant(uuid        , extension        , talking           = null) {
    if (!this.participants.some(participant => participant.uuid === uuid || participant.extension === extension)) {
      return new Room({ ...this, participants: [...this.participants, { uuid, extension, talking }] });
    }

    return this;
  }

  updateParticipant(uuid        , participant        , shouldAdd          = false) {
    const idx = this.participants.findIndex(someParticipant => someParticipant.uuid === uuid);
    if (idx === -1 && !shouldAdd) {
      return this;
    }

    const updatedParticipants = [...this.participants];
    if (idx !== -1) {
      updatedParticipants[idx] = { ...updatedParticipants[idx], ...participant };
    } else {
      updatedParticipants.push(participant);
    }

    return new Room({ ...this, participants: updatedParticipants });
  }

  updateParticipantByExtension(extension        , participant        , shouldAdd          = false) {
    const idx = this.participants.findIndex(someParticipant => someParticipant.extension === extension);
    if (idx === -1 && !shouldAdd) {
      return this;
    }

    const updatedParticipants = [...this.participants];
    if (idx !== -1) {
      updatedParticipants[idx] = { ...updatedParticipants[idx], ...participant };
    } else {
      updatedParticipants.push(participant);
    }

    return new Room({ ...this, participants: updatedParticipants });
  }

  hasCallWithId(id        )          {
    return !!this.connectedCallSession && this.connectedCallSession.getId() === id;
  }

  disconnect()       {
    return new Room({ ...this, connectedCallSession: null });
  }

  removeParticipantWithUUID(uuid        ) {
    return new Room({
      ...this,
      participants: this.participants.filter(participant => participant.uuid !== uuid),
    });
  }

  removeParticipantWithExtension(extension        ) {
    return new Room({
      ...this,
      participants: this.participants.filter(participant => participant.extension !== extension),
    });
  }

  updateFrom(room      ) {
    updateFrom(this, room);
  }

  static newFrom(room      ) {
    return newFrom(room, Room);
  }
}

//      

                                                                                                   

                                    
                                    
                           
  

                                             
                           
                         
                           
  

                                           
                       
                           
                           
  

                                 
             
                            
                        
                          
                    
                         
                
                          
                          
  

                                       
                            
                          
                            
             
                         
                   
                
                          
                          
  

class SwitchboardCall {
                       

             
                            
                        
                          
                    
                         
                
                          
                          
               

  static parse(plain                         )                  {
    return new SwitchboardCall({
      id: plain.id,
      callSession: plain.callSession || null,
      callerIdName: plain.caller_id_name || null,
      callerIdNumber: plain.caller_id_number || null,
      participantId: plain.participantId || null,
      answerTime: plain.startTime,
      state: plain.state,
      switchboardName: plain.switchboardName,
      switchboardUuid: plain.switchboardUuid,
    });
  }

  constructor({
    id,
    callSession,
    callerIdName,
    callerIdNumber,
    participantId,
    answerTime,
    state,
    switchboardName,
    switchboardUuid,
  }                           = {}) {
    this.id = id;
    this.callSession = callSession;
    this.callerIdName = callerIdName;
    this.callerIdNumber = callerIdNumber;
    this.participantId = participantId;
    this.answerTime = answerTime;
    this.state = state;
    this.switchboardName = switchboardName;
    this.switchboardUuid = switchboardUuid;

    // Useful to compare instead of instanceof with minified code
    this.type = 'SwitchboardCall';
  }

  updateFrom(switchboardCall                 ) {
    updateFrom(this, switchboardCall);
  }

  getId() {
    return this.id;
  }

  static newFrom(switchboardCall                 ) {
    return newFrom(switchboardCall, SwitchboardCall);
  }
}

SwitchboardCall.STATE = {
  INCOMING: 'incoming',
  ONGOING: 'ongoing',
  HELD: 'held',
};

//      

const FEATURES = ['chat', 'video', 'call_recording', 'fax', 'mobile_double_call', 'mobile_gsm', 'meeting'];

const getScopeName = (featureName        ) => `enterprise.app.${featureName}`;

const scopesToCheck = FEATURES.map(getScopeName);

// Handle available features on the engine.
class Features {
                    
                     
                             
                   
                                
                         
                       

  constructor() {
    this._hasChat = true;
    this._hasVideo = true;
    this._hasCallRecording = true;
    this._hasFax = true;
    this._hasMobileDoubleCall = true;
    this._hasMobileGsm = true;
    this._hasMeeting = true;
  }

  async fetchAccess() {
    let response;
    try {
      response = await getApiClient().auth.getRestrictionPolicies(scopesToCheck);
    } catch (_) {
      // Noting to do because everything should be available even if the API is not available
    }
    if (!response) {
      return;
    }
    const { scopes } = response;

    this._hasChat = this._hasFeatures(scopes, 'chat');
    this._hasVideo = this._hasFeatures(scopes, 'video');
    this._hasCallRecording = this._hasFeatures(scopes, 'call_recording');
    this._hasFax = this._hasFeatures(scopes, 'fax');
    this._hasMobileDoubleCall = this._hasFeatures(scopes, 'mobile_double_call');
    this._hasMobileGsm = this._hasFeatures(scopes, 'mobile_gsm');
    this._hasMeeting = this._hasFeatures(scopes, 'meeting');
  }

  hasChat() { return this._hasChat; }
  hasVideo() { return this._hasVideo; }
  hasCallRecording() { return this._hasCallRecording; }
  hasFax() { return this._hasFax; }
  hasMobileDoubleCall() { return this._hasMobileDoubleCall; }
  hasMobileGsm() { return this._hasMobileGsm; }
  hasMeeting() { return this._hasMeeting; }

  _hasFeatures(scopes        , featureName        ) {
    const scopeName = getScopeName(featureName);
    if (!scopes || !(scopeName in scopes)) {
      // Assume that the feature is available if not present (available by default)
      return true;
    }
    return scopes[scopeName] === true;
  }

}

var Features$1 = new Features();

var api = {
  name: 'API',
  check: async (server, session) => {
    const client = new ApiClient({ server });
    client.setToken(session.token);
    client.disableErrorLogging();

    const handleApiError = (apiName, error) => {
      const statusText = error instanceof ServerError ? 'server error' : 'api error';

      throw new Error(`${apiName} fails with status (${error.status}, ${statusText}) : ${error.message}`);
    };

    // Check simple API call
    try {
      await client.auth.getPushNotificationSenderId(session.uuid);
      await client.auth.getProviders(session.uuid);
    } catch (e) {
      handleApiError('wazo-auth', e);
    }

    try {
      await client.callLogd.listCallLogs();
    } catch (e) {
      handleApiError('wazo-callogd', e);
    }

    try {
      await client.calld.listCalls();
    } catch (e) {
      handleApiError('wazo-calld', e);
    }

    try {
      await client.calld.listVoicemails();
    } catch (e) {
      // API throws a 404 when no voicemail
      if (e.status !== 404) {
        handleApiError('wazo-calld', e);
      }
    }

    try {
      await client.chatd.getState(session.uuid);
      await client.chatd.getContactStatusInfo(session.uuid);
      await client.chatd.getUserRooms();
    } catch (e) {
      handleApiError('wazo-chatd', e);
    }

    try {
      await client.confd.getInfos();
      await client.confd.getUser(session.uuid);
    } catch (e) {
      handleApiError('wazo-confd', e);
    }

    try {
      await client.dird.listPersonalContacts();
      await client.dird.listFavorites(session.primaryContext());
      await client.dird.fetchWazoSource(session.primaryContext());
      const conferenceSource = await client.dird.fetchConferenceSource(session.primaryContext());
      await client.dird.fetchConferenceContacts(conferenceSource.items[0]);
    } catch (e) {
      handleApiError('wazo-dird', e);
    }

    try {
      await client.webhookd.getSubscriptions();
    } catch (e) {
      handleApiError('wazo-webhookd', e);
    }
  },
};

var aor = {
  name: 'List of AOR',
  check: async (server, session) => {
    const apiClient = new ApiClient({ server });
    apiClient.setToken(session.token);
    apiClient.disableErrorLogging();

    const line = session.primaryWebRtcLine();
    if (!line) {
      return 'No WebRTC line for this user';
    }
    const { username } = line;

    try {
      const aors = await apiClient.amid.getAors(username);
      const nbAors = aors.length;
      const availableAors = aors.filter(aor => aor.status === 'Reachable');

      return `Number of AOR: ${nbAors} (${availableAors.length} Avail, ${nbAors - availableAors.length} Unavail)`;
    } catch (e) {
      if (e.status === 401) {
        return 'Not available for this user';
      }

      throw e;
    }
  },
};

var wazoWebsocket = {
  name: 'Wazo Websocket',
  check: (server, session) => new Promise((resolve, reject) => {
    const client = new WebSocketClient({ host: server, token: session.token, version: 2 });

    const handleError = (message) => {
      client.close();
      reject(new Error(message));
    };

    const handleSuccess = () => {
      client.stopHeartbeat();
      client.close();
      resolve();
    };

    client.on(SOCKET_EVENTS$1.ON_ERROR, error => {
      handleError(`Connection error : ${error}`);
    });

    client.on(SOCKET_EVENTS$1.ON_OPEN, () => {
      if (session.hasEngineVersionGte(HEARTBEAT_ENGINE_VERSION)) {
        client.setOnHeartbeatTimeout(() => {
          handleError('No response to heartbeat');
        });
        client.setOnHeartbeatCallback(() => {
          handleSuccess();
        });
        client.startHeartbeat();
      } else {
        handleSuccess();
      }
    });

    client.connect();
  }),
};

var webrtcTransport = {
  name: 'WebRTC Transport (WS) ~30s',
  check: (server, session) => new Promise((resolve, reject) => {
    const client = new WebRTCClient({
      host: server,
      media: {
        audio: true,
      },
    }, session);

    const handleError = (message) => {
      client.close();
      reject(new Error(message));
    };

    const handleSuccess = async () => {
      client.stopHeartbeat();
      await client.close();
      resolve();
    };

    client.on(client.TRANSPORT_ERROR, error => {
      handleError(`Transport error : ${error}`);
    });

    client.on(client.REGISTERED, () => {
      client.setOnHeartbeatTimeout(() => {
        handleError('No response to heartbeat');
      });
      client.setOnHeartbeatCallback(() => {
        handleSuccess();
      });
      client.startHeartbeat();
    });
  }),
};

/* global MediaStream */

var webrtc = {
  name: 'WebRTC',
  check: (server, session) => new Promise((resolve, reject) => {
    if (typeof MediaStream === 'undefined') {
      return resolve('Skipped on node');
    }

    const client = new WebRTCClient({
      host: server,
      media: {
        audio: true,
      },
    }, session);

    const handleError = (message) => {
      client.close();
      reject(new Error(message));
    };

    const handleSuccess = async () => {
      client.stopHeartbeat();
      await client.close();
      resolve();
    };

    client.on(client.TRANSPORT_ERROR, error => {
      handleError(`Transport error : ${error}`);
    });

    client.on(client.REGISTERED, () => {
      const sipSession = client.call('*10');
      if (!sipSession || !client.getSipSessionId(sipSession)) {
        return handleError('Unable to make call through WebRTC');
      }

      setTimeout(() => {
        client.hangup(sipSession);

        handleSuccess();
      }, 1000);
    });
  }),
};

const parseCandidate = line => {
  let parts;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  const candidate = {
    foundation: parts[0],
    component: parts[1],
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7],
  };

  for (let i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
    }
  }

  return candidate;
};

/* global MediaStream, RTCPeerConnection */

const timeoutDuration = 8000;

// @see https://webrtchacks.com/symmetric-nat/
var SymmetricNat = {
  name: 'Symmetric NAT',
  check: () => new Promise((resolve, reject) => {
    if (typeof MediaStream === 'undefined') {
      return resolve('Skipped on node');
    }

    const candidates = {};
    const rawCandidates = [];
    let nbCandidates = 0;

    const pc = new RTCPeerConnection({
      iceServers: [
        { urls: 'stun:stun.wazo.io:443' },
        { urls: 'stun:stun1.l.google.com:19302' },
        { urls: 'stun:stun2.l.google.com:19302' },
      ],
    });

    let timeout;

    const onEnded = () => {
      clearTimeout(timeout);

      if (Object.keys(candidates).length === 0) {
        reject(new Error(`Timed out (${timeoutDuration}ms), ${nbCandidates} candidates : ${rawCandidates.join(', ')}`));
        return;
      }
      const ports = candidates[Object.keys(candidates)[0]];

      if (ports.length === 1) {
        resolve();
      } else {
        reject(new Error('Symmetric NAT detected, you should use a TURN server.'));
      }
    };

    timeout = setTimeout(onEnded, timeoutDuration);

    pc.createDataChannel('wazo-check-nat');

    pc.onicecandidate = e => {
      nbCandidates++;

      if (e.candidate) {
        rawCandidates.push(e.candidate.candidate);
      }

      if (e.candidate && e.candidate.candidate.indexOf('srflx') !== -1) {
        const cand = parseCandidate(e.candidate.candidate);
        if (!candidates[cand.relatedPort]) candidates[cand.relatedPort] = [];
        candidates[cand.relatedPort].push(cand.port);
      } else if (!e.candidate) {
        onEnded();
      }
    };

    pc.createOffer().then(offer => pc.setLocalDescription(offer));
  }),
};

/* global MediaStream, RTCPeerConnection */

const checkIsIPV4 = ip => {
  const blocks = ip.split('.');
  if (blocks.length !== 4) {
    return false;
  }

  return blocks.every(block => parseInt(block, 10) >= 0 && parseInt(block, 10) <= 255);
};

var iceIpv4 = {
  name: 'Non IP v4 ice',
  check: (server, session, externalAppConfig) => new Promise((resolve, reject) => {
    if (typeof MediaStream === 'undefined') {
      return resolve('Skipped on node');
    }

    const mobile = isMobile();
    const offerOptions = { offerToReceiveAudio: 1 };
    const ips = [];
    const config = {
      iceServers: [
        { urls: 'stun:stun1.l.google.com:19302' },
        { urls: 'stun:stun2.l.google.com:19302' },
      ],
    };
    let hasSrflxOrRelay = false;

    if (externalAppConfig && externalAppConfig.stun_servers) {
      config.iceServers = {
        ...externalAppConfig.stun_servers.split(',').map(url => ({ urls: url })),
        ...config.iceServers,
      };
    }

    if (externalAppConfig && externalAppConfig.turn_servers) {
      // $FlowFixMe
      config.iceServers = [
        ...JSON.parse(externalAppConfig.turn_servers),
        ...config.iceServers,
      ];

      // Force to use TURN when defined in config
      config.iceTransportPolicy = 'relay';
    }

    const pc = new RTCPeerConnection(config);

    pc.createDataChannel('wazo-check-ipv4');

    pc.onicecandidate = e => {
      if (e.candidate) {
        const rawCandidate = e.candidate.candidate;
        if (rawCandidate.indexOf('srflx') !== -1 || rawCandidate.indexOf('relay') !== -1) {
          hasSrflxOrRelay = true;
          const candidate = parseCandidate(e.candidate.candidate);
          ips.push(candidate.ip);
        }
      } else if (!e.candidate) {
        if (!hasSrflxOrRelay) {
          return reject(new Error('No `srflx` or `relay` found in candidate. Please consider using a TURN server.'));
        }
        if (ips.every(checkIsIPV4)) {
          resolve();
        } else {
          const nonIPV4 = ips.find(ip => !checkIsIPV4(ip));

          reject(new Error(`Non IPv4 ice candidate found : ${nonIPV4}.`));
        }

      }
    };

    pc.createOffer(offerOptions)
      .then(offer => pc.setLocalDescription(offer))
      .then(description => (mobile ? pc.createOffer(offerOptions) : description))
      .then(sessionDescription => (mobile ? pc.setLocalDescription(sessionDescription) : sessionDescription));
  }),
};

var checks = [
  aor,
  api,
  wazoWebsocket,
  webrtcTransport,
  webrtc,
  SymmetricNat,
  iceIpv4,
];

//      

const logger = IssueReporter$1.loggerFor('engine-check');

class Checker {
                   
                 
                            
                   

  constructor(server        , session         , externalAppConfig         = {}) {
    this.server = server;
    this.session = session;
    this.externalAppConfig = externalAppConfig;
    this.checks = [...checks];
  }

  async check(onCheckBegin           = () => {}, onCheckResult           = () => {}) {
    await this._addEngineVersion();

    logger.info('Engine check starting');

    for (let i = 0; i < this.checks.length; i++) {
      const { name, check } = this.checks[i];

      logger.info(`Checking ${name} ...`);

      onCheckBegin(name);
      try {
        // eslint-disable-next-line no-await-in-loop
        const result = await check(this.server, this.session, this.externalAppConfig);
        logger.info(`Checking ${name} success.`, { result });

        onCheckResult(name, result);
      } catch (e) {
        logger.info(`Checking ${name} failure`, { message: e.message });

        onCheckResult(name, e);
      }
    }

    logger.info('Engine check done.');
  }

  addCheck(check        ) {
    this.checks.push(check);
  }

  async _addEngineVersion() {
    if (!this.session.engineVersion) {
      const apiClient = new ApiClient({ server: this.server });
      apiClient.setToken(this.session.token);

      const { wazo_version: engineVersion } = await apiClient.confd.getInfos();
      this.session.engineVersion = engineVersion;
    }
  }
}

//      
/* eslint-disable no-unused-vars */
/* global window, document */
const BRIDGE_CONFIG_RETRIEVED = 'bridge/CONFIG_RETRIEVED';
const BRIDGE_CREATE_OR_UPDATE_CARD = 'bridge/BRIDGE_CREATE_OR_UPDATE_CARD';
const BRIDGE_OPTIONS_FETCHED = 'bridge/BRIDGE_OPTIONS_FETCHED';
const BRIDGE_OPTIONS_FOUND = 'bridge/BRIDGE_OPTIONS_FOUND';
const BRIDGE_SEARCH_OPTIONS = 'bridge/BRIDGE_SEARCH_OPTIONS';
const BRIDGE_DISPLAY_LINKED_OPTION = 'bridge/DISPLAY_LINKED_OPTION';
const BRIDGE_UPDATE_FORM_SCHEMA = 'bridge/BRIDGE_UPDATE_FORM_SCHEMA';
const BRIDGE_WAZO_CONTACT_SEARCH = 'bridge/BRIDGE_WAZO_CONTACT_SEARCH';
const BRIDGE_ON_AGENT_LOGGED_IN = 'bridge/BRIDGE_ON_AGENT_LOGGED_IN';
const BRIDGE_ON_AGENT_LOGGED_OUT = 'bridge/BRIDGE_ON_AGENT_LOGGED_OUT';
const BRIDGE_ON_AGENT_PAUSED = 'bridge/BRIDGE_ON_AGENT_PAUSED';
const BRIDGE_ON_AGENT_RESUMED = 'bridge/BRIDGE_ON_AGENT_RESUMED';
const BRIDGE_ON_LANGUAGE_CHANGED = 'bridge/BRIDGE_ON_LANGUAGE_CHANGED';
const BRIDGE_ON_CALL_LOCALLY_ACCEPTED = 'bridge/BRIDGE_ON_CALL_LOCALLY_ACCEPTED';
const BRIDGE_ON_CALL_REJECTED = 'bridge/BRIDGE_ON_CALL_REJECTED';
const BRIDGE_ON_CALL_ESTABLISHED = 'bridge/BRIDGE_ON_CALL_ESTABLISHED';
const BRIDGE_ON_CALL_HELD = 'bridge/BRIDGE_ON_CALL_HELD';
const BRIDGE_ON_CALL_RESUMED = 'bridge/BRIDGE_ON_CALL_RESUMED';
const BRIDGE_ON_CALL_MUTED = 'bridge/BRIDGE_ON_CALL_MUTED';
const BRIDGE_ON_CALL_UN_MUTED = 'bridge/BRIDGE_ON_CALL_UN_MUTED';
const BRIDGE_ON_DTMF = 'bridge/BRIDGE_ON_DTMF';
const BRIDGE_ON_DIRECT_TRANSFER = 'bridge/BRIDGE_ON_DIRECT_TRANSFER';
const BRIDGE_ON_CREATE_INDIRECT_TRANSFER = 'bridge/BRIDGE_ON_CREATE_INDIRECT_TRANSFER';
const BRIDGE_ON_CANCEL_INDIRECT_TRANSFER = 'bridge/BRIDGE_ON_CANCEL_INDIRECT_TRANSFER';
const BRIDGE_ON_CONFIRM_INDIRECT_TRANSFER = 'bridge/BRIDGE_ON_CONFIRM_INDIRECT_TRANSFER';
const BRIDGE_ON_INDIRECT_TRANSFER_CALL_MADE = 'bridge/BRIDGE_ON_INDIRECT_TRANSFER_CALL_MADE';
const BRIDGE_ON_INDIRECT_TRANSFER_DONE = 'bridge/BRIDGE_ON_INDIRECT_TRANSFER_DONE';
const BRIDGE_ON_START_RECORDING = 'bridge/BRIDGE_ON_START_RECORDING';
const BRIDGE_ON_STOP_RECORDING = 'bridge/BRIDGE_ON_STOP_RECORDING';
const BRIDGE_ON_CARD_CANCELED = 'bridge/BRIDGE_ON_CARD_CANCELED';
const BRIDGE_ENABLE_AGENT = 'bridge/BRIDGE_ENABLE_AGENT';
const BRIDGE_SET_CARD_CONTENT = 'bridge/BRIDGE_SET_CARD_CONTENT';
const BRIDGE_ENABLE_DEBUG = 'bridge/BRIDGE_ENABLE_DEBUG';

const BRIDGE_INJECT_CSS = 'bridge/BRIDGE_INJECT_CSS';
const BRIDGE_CUSTOMIZE_APPEARANCE = 'bridge/BRIDGE_CUSTOMIZE_APPEARANCE';

const SDK_CLICK_TO_CALL = 'sdk/CLICK_TO_CALL';
const SDK_ON_OUTGOING_CALL_MADE = 'sdk/SDK_ON_OUTGOING_CALL_MADE';
const SDK_CALL_ENDED = 'sdk/ON_CALL_ENDED';
const SDK_CALL_INCOMING = 'sdk/SDK_CALL_INCOMING';
const SDK_AUTHENTICATED = 'sdk/SDK_AUTHENTICATED';
const SDK_LOGGED_OUT = 'sdk/SDK_LOGGED_OUT';

class Softphone {
              
                
                 
                     
                  
                        

  // Message waiting for the iframe to be loaded
                             

  onLinkEnabled(link        ) {}
  onIFrameLoaded() {}

  onCallLocallyAnswered(call        ) {}
  onCallEstablished(call        ) {}
  onOutgoingCallMade(call        ) {}
  onCallIncoming(call        ) {}
  onCallRejected(call        ) {}
  onCallEnded(call        , card        , direction        , fromExtension        ) {}

  onCardSaved(card        ) {}
  onCardCanceled() {}
  onAuthenticated(session        ) {}
  onLoggedOut() {}

  onSearchOptions(fieldId        , query        ) {
    this.onOptionsResults(fieldId, []);
  }

  onDisplayLinkedOption(optionId        ) {}
  onWazoContactSearch(query        ) {}
  onAgentLoggedIn() {}
  onAgentLoggedOut() {}
  onAgentPaused() {}
  onAgentResumed() {}
  onLanguageChanged(language        ) {}
  onCallHeld() {}
  onCallResumed() {}
  onCallMuted() {}
  onCallUnMuted() {}
  onDtmfSent(tone        ) {}
  onDirectTransfer(number        ) {}
  onCreateIndirectTransfer(number        ) {}
  onCancelIndirectTransfer() {}
  onConfirmIndirectTransfer() {}
  onIndirectCallMade(call        ) {}
  onIndirectTransferDone(call        ) {}
  onStartRecording() {}
  onStopRecording() {}
  onUnHandledEvent(event        ) {}

  init({
    url,
    width,
    height,
    server,
    port,
    language,
    wrapUpDuration,
    enableAgent = true,
    tenantId,
    domainName,
    debug = false,
  }         = {}) {
    this.url = url || 'https://softphone.wazo.io';
    this.width = width || 500;
    this.height = height || 600;
    this.displayed = false;
    this.iframeLoaded = false;

    this.iframeLoaded = false;
    this._pendingMessages = [];
    window.addEventListener('message', this._onMessage.bind(this), false);

    if (!server) {
      throw new Error('`server` is not set');
    }

    const config         = { server };
    if (language) {
      config.language = language;
    }
    if (port) {
      config.port = port;
    }
    if (tenantId) {
      console.warn('Use of `tenantId` is deprecated when calling `Softphone.init()`, use `domainName` instead');
      config.tenantId = tenantId;
    }
    if (domainName) {
      config.domainName = domainName;
    }
    if (wrapUpDuration) {
      config.wrapUpDuration = wrapUpDuration;
    }

    this._sendMessage(BRIDGE_CONFIG_RETRIEVED, { config });

    if (enableAgent) {
      this._sendMessage(BRIDGE_ENABLE_AGENT);
    }

    if (debug) {
      this._sendMessage(BRIDGE_ENABLE_DEBUG);
    }

    this._createIframe(() => {
      this.iframeLoaded = true;
      this._pendingMessages.forEach(([type, payload]) => this._sendMessage(type, payload));

      this.onIFrameLoaded();
    });
  }

  parseLinks() {
    const links = this._getLinks();

    links.forEach(link => {
      link.setAttribute('data-wazo-parsed', true);
      link.addEventListener('click', this._onLinkClick.bind(this));
      this.onLinkEnabled(link);
    });
  }

  makeCall(number        ) {
    this.displaySoftphone();

    this._sendMessage(SDK_CLICK_TO_CALL, { number });
  }

  toggleSoftphoneDisplay() {
    if (this.displayed) {
      this.hideSoftphone();
    } else {
      this.displaySoftphone();
    }
  }

  displaySoftphone() {
    if (!this.iframe) {
      this._createIframe();
    }

    if (this.iframe) {
      this.iframe.style.display = 'block';
    }

    this.displayed = true;
  }

  hideSoftphone() {
    if (this.iframe) {
      this.iframe.style.display = 'none';
    }
    this.displayed = false;
  }

  optionsFetched(fieldId        , options       ) {
    this._sendMessage(BRIDGE_OPTIONS_FETCHED, { fieldId, options });
  }

  onOptionsResults(fieldId        , options       ) {
    this._sendMessage(BRIDGE_OPTIONS_FOUND, { fieldId, options });
  }

  setFormSchema(schema        , uiSchema        ) {
    this._sendMessage(BRIDGE_UPDATE_FORM_SCHEMA, { schema, uiSchema });
  }

  setCardValue(field        , value     ) {
    this._sendMessage(BRIDGE_SET_CARD_CONTENT, { field, value });
  }

  injectCss(css        ) {
    this._sendMessage(BRIDGE_INJECT_CSS, { css });
  }

  customizeAppearance(themes        , translations        , assets        ) {
    this._sendMessage(BRIDGE_CUSTOMIZE_APPEARANCE, { themes, translations, assets });
  }

  _createIframe(cb           = () => {}) {
    this.iframe = document.createElement('iframe');
    // $FlowFixMe
    this.iframe.width = this.width;
    // $FlowFixMe
    this.iframe.height = this.height;
    // $FlowFixMe
    this.iframe.allow = 'camera *; microphone *; autoplay *; display-capture *';
    this.iframe.style.position = 'absolute';
    this.iframe.style.left = '0';
    this.iframe.style.bottom = '0';
    this.iframe.style.border = '1px solid #aaa';
    this.iframe.style.backgroundColor = 'white';
    this.iframe.src = this.url;
    this.iframe.style.display = 'none';
    this.iframe.id = 'wazo-softphone';

    this.iframe.onload = cb;

    // $FlowFixMe
    document.body.appendChild(this.iframe);
  }

  _getLinks() {
    return [].slice.call(document.querySelectorAll('a:not([data-wazo-parsed])'), 0)
      .filter(link => link.href.indexOf('tel:') === 0 || link.href.indexOf('callto:') === 0);
  }

  _onLinkClick(e        ) {
    e.preventDefault();
    const number = e.target.href.split(':')[1];

    this.makeCall(number);
  }

  _onAuthenticated() {
    this.parseLinks();
  }

  _onMessage(event        ) {
    if (!event.data) {
      return;
    }

    switch (event.data.type) {
      case SDK_ON_OUTGOING_CALL_MADE:
        this.onOutgoingCallMade(event.data.callSession);
        break;
      case SDK_CALL_ENDED: {
        const { callSession, content, direction, userExtension } = event.data;
        this.onCallEnded(callSession, content, direction, userExtension);
        break;
      }
      case SDK_CALL_INCOMING:
        this.onCallIncoming(event.data.callSession);
        break;
      case SDK_AUTHENTICATED:
        // $FlowFixMe
        this._onAuthenticated(event.data.session);
        this.onAuthenticated(event.data.session);
        break;
      case SDK_LOGGED_OUT:
        this.onLoggedOut();
        break;
      case BRIDGE_CREATE_OR_UPDATE_CARD: {
        const { content } = event.data;
        this.onCardSaved(content);
        break;
      }
      case BRIDGE_SEARCH_OPTIONS: {
        const { fieldId, query } = event.data;
        this.onSearchOptions(fieldId, query);
        break;
      }
      case BRIDGE_DISPLAY_LINKED_OPTION:
        this.onDisplayLinkedOption(event.data.linkedOptionId);
        break;
      case BRIDGE_WAZO_CONTACT_SEARCH:
        this.onWazoContactSearch(event.data.query);
        break;
      case BRIDGE_ON_AGENT_LOGGED_IN:
        this.onAgentLoggedIn();
        break;
      case BRIDGE_ON_AGENT_LOGGED_OUT:
        this.onAgentLoggedOut();
        break;
      case BRIDGE_ON_AGENT_PAUSED:
        this.onAgentPaused();
        break;
      case BRIDGE_ON_AGENT_RESUMED:
        this.onAgentResumed();
        break;
      case BRIDGE_ON_LANGUAGE_CHANGED:
        this.onLanguageChanged(event.data.language);
        break;
      case BRIDGE_ON_CALL_HELD:
        this.onCallHeld();
        break;
      case BRIDGE_ON_CALL_RESUMED:
        this.onCallResumed();
        break;
      case BRIDGE_ON_CALL_MUTED:
        this.onCallMuted();
        break;
      case BRIDGE_ON_CALL_UN_MUTED:
        this.onCallUnMuted();
        break;
      case BRIDGE_ON_DTMF:
        this.onDtmfSent(event.data.tone);
        break;
      case BRIDGE_ON_DIRECT_TRANSFER:
        this.onDirectTransfer(event.data.number);
        break;
      case BRIDGE_ON_CREATE_INDIRECT_TRANSFER:
        this.onCreateIndirectTransfer(event.data.number);
        break;
      case BRIDGE_ON_CANCEL_INDIRECT_TRANSFER:
        this.onCancelIndirectTransfer();
        break;
      case BRIDGE_ON_CONFIRM_INDIRECT_TRANSFER:
        this.onConfirmIndirectTransfer();
        break;
      case BRIDGE_ON_INDIRECT_TRANSFER_CALL_MADE:
        this.onIndirectCallMade(event.data.call);
        break;
      case BRIDGE_ON_INDIRECT_TRANSFER_DONE:
        this.onIndirectTransferDone(event.data.call);
        break;
      case BRIDGE_ON_START_RECORDING:
        this.onStartRecording();
        break;
      case BRIDGE_ON_STOP_RECORDING:
        this.onStopRecording();
        break;
      case BRIDGE_ON_CARD_CANCELED:
        this.onCardCanceled();
        break;
      case BRIDGE_ON_CALL_LOCALLY_ACCEPTED:
        this.onCallLocallyAnswered(event.data.call);
        break;
      case BRIDGE_ON_CALL_REJECTED:
        this.onCallRejected(event.data.call);
        break;
      case BRIDGE_ON_CALL_ESTABLISHED:
        this.onCallEstablished(event.data.call);
        break;
      default:
        this.onUnHandledEvent(event);
        break;
    }
  }

  _sendMessage(type        , payload         = {}) {
    if (!this.iframe || !this.iframeLoaded) {
      this._pendingMessages.push([type, payload]);
      return;
    }

    this.iframe.contentWindow.postMessage({ type, ...payload }, '*');
  }
}

var Softphone$1 = new Softphone();

/* global window */

const Wazo = {
  Auth: Auth$1,
  Phone: Phone$1,
  Websocket: Websocket$1,
  Room: Room$1,
  SipRoom,
  RemoteParticipant,
  LocalParticipant,
  Stream,
  createLocalVideoStream,
  createLocalAudioStream,
  Configuration: Configuration$1,
  Directory: Directory$1,
  getApiClient,
  IssueReporter: IssueReporter$1,
  loggerFor: IssueReporter$1.loggerFor.bind(IssueReporter$1),
  Features: Features$1,
  Checker,
  Softphone: Softphone$1,

  // Domain
  domain: {
    BadResponse,
    ServerError,
    Call,
    CallLog,
    CTIPhone,
    Recording,
    ChatMessage,
    ChatRoom,
    Contact,
    ForwardOption,
    Line,
    NotificationOptions,
    Profile,
    Session,
    Voicemail,
    Relocation,
    ConferenceRoom: Room,
    CallSession,
    IndirectTransfer,
    SwitchboardCall,
    WebRTCPhone,
    Meeting,
  },

  // Api
  get api() { return getApiClient(); },
  get agentd() { return getApiClient().agentd; },
  get amid() { return getApiClient().amid; },
  get application() { return getApiClient().application; },
  get auth() { return getApiClient().auth; },
  get callLogs() { return getApiClient().callLogs; },
  get calld() { return getApiClient().calld; },
  get chatd() { return getApiClient().chatd; },
  get confd() { return getApiClient().confd; },
  get dird() { return getApiClient().dird; },
  get webhookd() { return getApiClient().webhookd; },

  // Error
  InvalidSubscription,
  InvalidAuthorization,
  CanceledCallError,
  SFUNotAvailableError,
  NoTenantIdError,
  NoDomainNameError,
};

if (window) {
  window.Wazo = Wazo;
}
if (global) {
  global.Wazo = Wazo;
}

module.exports = Wazo;
